var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _g355, _g356, _g357, _g358, _g359, _g360, _g361, _g362, _g363, _g364, _g365, _g366, _g367, _g368, _g369, _g370, _g371, _g372, _g373, _g374, _g375, _g376, _g377, _g378, _g379, _g380, _g381, _g382, _g383, _g384, _g385, _g386, _g387, _g388, _g389, _g390, _g391, _g392, _g393, _g394, _g395, _g396, _g397, _g398, _g399, _g400, _g401, _g402, _g403, _g404, _g405, _g406, _g407, _g408, _g409, _g410, _g411, _g412, _g413, _g414, _g415, _g416, _g417, _g418, _g419, _g420, _g421, _g422, _g423, _g424, _g425, _g426, _g427, _g428, _g429, _g430, _g431, _g432, _g433, _g434, _g435, _g436, _g437, _g438, _g439, _g440, _g441, _g442, _g443, _g444, _g445, _g446, _g447, _g448, _g449, _g450, _g451, _g452, _g453, _g454, _g455, _g456, _g457, _g458, _g459, _g460, _g461, _g462, _g463, _g464, _g465, _g466, _g467, _g468, _g469, _g470, _g471, _g472, _g473, _g474, _g475, _g476, _g477, _g478, _g479, _g480, _g481, _g482, _g483, _g484, _g485, _g486, _g487, _g488, _g489, _g490, _g491, _g492, _g493, _g494, _g495, _g496, _g497, _g498, _g499, _g500, _g501, _g502, _g503, _g504, _g505, _g506, _g507, _g508, _g509, _g510, _g511, _g512, _g513, _g514, _g515, _g516, _g517, _g518, _g519, _g520, _g521, _g522, _g523, _g524, _g525, _g526, _g527, _g528, _g529, _g530, _g531, _g532, _g533, _g534, _g535, _g536, _g537, _g538, _g539, _g540, _g541, _g542, _g543, _g544, _g545, _g546, _g547, _g548, _g549, _g550, _g551, _g552, _g553, _g554, _g555, _g556, _g557, _g558, _g559, _g560, _g561, _g562, _g563, _g564, _g565, _g566, _g567, _g568, _g569, _g570, _g571, _g572, _g573, _g574, _g575, _g576, _g577, _g578, _g579, _g580, _g581, _g582, _g583, _g584, _g585, _g586, _g587, _g588, _g589, _g590, _g591, _g592, _g593, _g594, _g595, _g596, _g597, _g598, _g599, _g600, _g601, _g602, _g603, _g604, _g605, _g606, _g607, _g608, _g609, _g610, _g611, _g612, _g613, _g614, _g615, _g616, _g617, _g618, _g619, _g620, _g621, _g622, _g623, _g624, _g625, _g626, _g627, _g628, _g629, _g630, _g631, _g632, _g633, _g634, _g635, _g636, _g637, _g638, _g639, _g640, _g641, _g642, _g643, _g644, _g645, _g646, _g647, _g648, _g649, _g650, _g651, _g652, _g653, _g654, _g655, _g656, _g657, _g658, _g659, _g660, _g661, _g662, _g663, _g664, _g665, _g666, _g667, _g668, _g669, _g670, _g671, _g672, _g673, _g674, _g675, _g676, _g677, _g678, _g679, _g680, _g681, _g682, _g683, _g684, _g685, _g686, _g687, _g688, _g689, _g690, _g691, _g692, _g693, _g694, _g695, _g696, _g697, _g698, _g699, _g700, _g701, _g702, _g703, _g704, _g705, _g706, _g707, _g708, _g709, _g710, _g711, _g712, _g713, _g714, _g715, _g716, _g717, _g718, _g719, _g720, _g721, _g722, _g723, _g724, _g725, _g726, _g727, _g728, _g729, _g730, _g731, _g732, _g733, _g734, _g735, _g736, _g737, _g738, _g739, _g740, _g741, _g742, _g743, _g744, _g745, _g746, _g747, _g748, _g749, _g750, _g751, _g752, _g753, _g754, _g755, _g756, _g757, _g758, _g759, _g760, _g761, _g762, _g763, _g764, _g765, _g766, _g767, _g768, _g769, _g770, _g771, _g772, _g773, _g774, _g775, _g776, _g777, _g778, _g779, _g780, _g781, _g782, _g783, _g784, _g785, _g786, _g787, _g788, _g789, _g790, _g791, _g792, _g793, _g794, _g795, _g796, _g797, _g798, _g799, _g800, _g801, _g802, _g803, _g804, _g805, _g806, _g807, _g808, _g809, _g810, _g811, _g812, _g813, _g814, _g815, _g816, _g817, _g818, _g819, _g820, _g821, _g822, _g823, _g824, _g825, _g826, _g827, _g828, _g829, _g830, _g831, _g832, _g833, _g834, _g835, _g836, _g837, _g838, _g839, _g840, _g841, _g842, _g843, _g844, _g845, _g846, _g847, _g848, _g849, _g850, _g851, _g852, _g853, _g854, _g855, _g856, _g857, _g858, _g859, _g860, _g861, _g862, _g863, _g864, _g865, _g866, _g867, _g868, _g869, _g870, _g871, _g872, _g873, _g874, _g875, _g876, _g877, _g878, _g879, _g880, _g881, _g882, _g883, _g884, _g885, _g886, _g887, _g888, _g889, _g890, _g891, _g892, _g893, _g894, _g895, _g896, _g897, _g898, _g899, _g900, _g901, _g902, _g903, _g904, _g905, _g906, _g907, _g908, _g909, _g910, _g911, _g912, _g913, _g914, _g915, _g916, _g917, _g918, _g919, _g920, _g921, _g922, _g923, _g924, _g925, _g926, _g927, _g928, _g929, _g930, _g931, _g932, _g933, _g934, _g935, _g936, _g937, _g938, _g939, _g940, _g941, _g942, _g943, _g944, _g945, _g946, _g947, _g948, _g949, _g950, _g951, _g952, _g953, _g954, _g955, _g956, _g957, _g958, _g959, _g960, _g961, _g962, _g963, _g964, _g965, _g966, _g967, _g968, _g969, _g970, _g971, _g972, _g973, _g974, _g975, _g976, _g977, _g978, _g979, _g980, _g981, _g982, _g983, _g984, _g985, _g986, _g987, _g988, _g989, _g990, _g991, _g992, _g993, _g994, _g995, _g996, _g997, _g998, _g999, _g1000, _g1001, _g1002, _g1003, _g1004, _g1005, _g1006, _g1007, _g1008, _g1009, _g1010, _g1011, _g1012, _g1013, _g1014, _g1015, _g1016, _g1017, _g1018, _g1019, _g1020, _g1021, _g1022, _g1023, _g1024, _g1025, _g1026, _g1027, _g1028, _g1029, _g1030, _g1031, _g1032, _g1033, _g1034, _g1035, _g1036, _g1037, _g1038, _g1039, _g1040, _g1041, _g1042, _g1043, _g1044, _g1045, _g1046, _g1047, _g1048, _g1049, _g1050, _g1051, _g1052, _g1053, _g1054, _g1055, _g1056, _g1057, _g1058, _g1059, _g1060, _g1061, _g1062, _g1063, _g1064, _g1065, _g1066, _g1067, _g1068, _g1069, _g1070, _g1071, _g1072, _g1073, _g1074, _g1075, _g1076, _g1077, _g1078, _g1079, _g1080, _g1081, _g1082, _g1083, _g1084, _g1085, _g1086, _g1087, _g1088, _g1089, _g1090, _g1091, _g1092, _g1093, _g1094, _g1095, _g1096, _g1097, _g1098, _g1099, _g1100, _g1101, _g1102, _g1103, _g1104, _g1105, _g1106, _g1107, _g1108, _g1109, _g1110, _g1111, _g1112, _g1113, _g1114, _g1115, _g1116, _g1117, _g1118, _g1119, _g1120, _g1121, _g1122, _g1123, _g1124, _g1125, _g1126, _g1127, _g1128, _g1129, _g1130, _g1131, _g1132, _g1133, _g1134, _g1135, _g1136, _g1137, _g1138, _g1139, _g1140, _g1141, _g1142, _g1143, _g1144, _g1145, _g1146, _g1147, _g1148, _g1149, _g1150, _g1151, _g1152, _g1153, _g1154, _g1155, _g1156, _g1157, _g1158, _g1159, _g1160, _g1161, _g1162, _g1163, _g1164, _g1165, _g1166, _g1167, _g1168, _g1169, _g1170, _g1171, _g1172, _g1173, _g1174, _g1175, _g1176, _g1177, _g1178, _g1179, _g1180, _g1181, _g1182, _g1183, _g1184, _g1185, _g1186, _g1187, _g1188, _g1189, _g1190, _g1191, _g1192, _g1193, _g1194, _g1195, _g1196, _g1197, _g1198, _g1199, _g1200, _g1201, _g1202, _g1203, _g1204, _g1205, _g1206, _g1207, _g1208, _g1209, _g1210, _g1211, _g1212, _g1213, _g1214, _g1215, _g1216, _g1217, _g1218, _g1219, _g1220, _g1221, _g1222, _g1223, _g1224, _g1225, _g1226, _g1227, _g1228, _g1229, _g1230, _g1231, _g1232, _g1233, _g1234, _g1235, _g1236, _g1237, _g1238, _g1239, _g1240, _g1241, _g1242, _g1243, _g1244, _g1245, _g1246, _g1247, _g1248, _g1249, _g1250, _g1251, _g1252, _g1253, _g1254, _g1255, _g1256, _g1257, _g1258, _g1259, _g1260, _g1261, _g1262, _g1263, _g1264, _g1265, _g1266, _g1267, _g1268, _g1269, _g1270, _g1271, _g1272, _g1273, _g1274, _g1275, _g1276, _g1277, _g1278, _g1279, _g1280, _g1281, _g1282, _g1283, _g1284, _g1285, _g1286, _g1287, _g1288, _g1289, _g1290, _g1291, _g1292, _g1293, _g1294, _g1295, _g1296, _g1297, _g1298, _g1299, _g1300, _g1301, _g1302, _g1303, _g1304, _g1305, _g1306, _g1307, _g1308, _g1309, _g1310, _g1311, _g1312, _g1313, _g1314, _g1315, _g1316, _g1317, _g1318, _g1319, _g1320, _g1321, _g1322, _g1323, _g1324, _g1325, _g1326, _g1327, _g1328, _g1329, _g1330, _g1331, _g1332, _g1333, _g1334, _g1335, _g1336, _g1337, _g1338, _g1339, _g1340, _g1341, _g1342, _g1343, _g1344, _g1345, _g1346, _g1347, _g1348, _g1349, _g1350, _g1351, _g1352, _g1353, _g1354, _g1355, _g1356, _g1357, _g1358, _g1359, _g1360, _g1361, _g1362, _g1363, _g1364, _g1365, _g1366, _g1367, _g1368, _g1369, _g1370, _g1371, _g1372, _g1373, _g1374, _g1375, _g1376, _g1377, _g1378, _g1379, _g1380, _g1381, _g1382, _g1383, _g1384, _g1385, _g1386, _g1387, _g1388, _g1389, _g1390, _g1391, _g1392, _g1393, _g1394, _g1395, _g1396, _g1397, _g1398, _g1399, _g1400, _g1401, _g1402, _g1403, _g1404, _g1405, _g1406, _g1407, _g1408, _g1409, _g1410, _g1411, _g1412, _g1413, _g1414, _g1415, _g1416, _g1417, _g1418, _g1419, _g1420, _g1421, _g1422, _g1423, _g1424, _g1425, _g1426, _g1427, _g1428, _g1429, _g1430, _g1431, _g1432, _g1433, _g1434, _g1435, _g1436, _g1437, _g1438, _g1439, _g1440, _g1441, _g1442, _g1443, _g1444, _g1445, _g1446, _g1447, _g1448, _g1449, _g1450, _g1451, _g1452, _g1453, _g1454, _g1455, _g1456, _g1457, _g1458, _g1459, _g1460, _g1461, _g1462, _g1463, _g1464, _g1465, _g1466, _g1467, _g1468, _g1469, _g1470, _g1471, _g1472, _g1473, _g1474, _g1475, _g1476, _g1477, _g1478, _g1479, _g1480, _g1481, _g1482, _g1483, _g1484, _g1485, _g1486, _g1487, _g1488, _g1489, _g1490, _g1491, _g1492, _g1493, _g1494, _g1495, _g1496, _g1497, _g1498, _g1499, _g1500, _g1501, _g1502, _g1503, _g1504, _g1505, _g1506, _g1507, _g1508, _g1509, _g1510, _g1511, _g1512, _g1513, _g1514, _g1515, _g1516, _g1517, _g1518, _g1519, _g1520, _g1521, _g1522, _g1523, _g1524, _g1525, _g1526, _g1527, _g1528, _g1529, _g1530, _g1531, _g1532, _g1533, _g1534, _g1535, _g1536, _g1537, _g1538, _g1539, _g1540, _g1541, _g1542, _g1543, _g1544, _g1545, _g1546, _g1547, _g1548, _g1549, _g1550, _g1551, _g1552, _g1553, _g1554, _g1555, _g1556, _g1557, _g1558, _g1559, _g1560, _g1561, _g1562, _g1563, _g1564, _g1565, _g1566, _g1567, _g1568, _g1569, _g1570, _g1571, _g1572, _g1573, _g1574, _g1575, _g1576, _g1577, _g1578, _g1579, _g1580, _g1581, _g1582, _g1583, _g1584, _g1585, _g1586, _g1587, _g1588, _g1589, _g1590, _g1591, _g1592, _g1593, _g1594, _g1595, _g1596, _g1597, _g1598, _g1599, _g1600, _g1601, _g1602, _g1603, _g1604, _g1605, _g1606, _g1607, _g1608, _g1609, _g1610, _g1611, _g1612, _g1613, _g1614, _g1615, _g1616, _g1617, _g1618, _g1619, _g1620, _g1621, _g1622, _g1623, _g1624, _g1625, _g1626, _g1627, _g1628, _g1629, _g1630, _g1631, _g1632, _g1633, _g1634, _g1635, _g1636, _g1637, _g1638, _g1639, _g1640, _g1641, _g1642, _g1643, _g1644, _g1645, _g1646, _g1647, _g1648, _g1649, _g1650, _g1651, _g1652, _g1653, _g1654, _g1655, _g1656, _g1657, _g1658, _g1659, _g1660, _g1661, _g1662, _g1663, _g1664, _g1665, _g1666, _g1667, _g1668, _g1669, _g1670, _g1671, _g1672, _g1673, _g1674, _g1675, _g1676, _g1677, _g1678, _g1679, _g1680, _g1681, _g1682, _g1683, _g1684, _g1685, _g1686, _g1687, _g1688, _g1689, _g1690, _g1691, _g1692, _g1693, _g1694, _g1695, _g1696, _g1697, _g1698, _g1699, _g1700, _g1701, _g1702, _g1703, _g1704, _g1705, _g1706, _g1707, _g1708, _g1709, _g1710, _g1711, _g1712, _g1713, _g1714, _g1715, _g1716, _g1717, _g1718, _g1719, _g1720, _g1721, _g1722, _g1723, _g1724, _g1725, _g1726, _g1727, _g1728, _g1729, _g1730, _g1731, _g1732, _g1733, _g1734, _g1735, _g1736, _g1737, _g1738, _g1739, _g1740, _g1741, _g1742, _g1743, _g1744, _g1745, _g1746, _g1747, _g1748, _g1749, _g1750, _g1751, _g1752, _g1753, _g1754, _g1755, _g1756, _g1757, _g1758, _g1759, _g1760, _g1761, _g1762, _g1763, _g1764, _g1765, _g1766, _g1767, _g1768, _g1769, _g1770, _g1771, _g1772, _g1773, _g1774, _g1775, _g1776, _g1777, _g1778, _g1779, _g1780, _g1781, _g1782, _g1783, _g1784, _g1785, _g1786, _g1787, _g1788, _g1789, _g1790, _g1791, _g1792, _g1793, _g1794, _g1795, _g1796, _g1797, _g1798, _g1799, _g1800, _g1801, _g1802, _g1803, _g1804, _g1805, _g1806, _g1807, _g1808, _g1809, _g1810, _g1811, _g1812, _g1813, _g1814, _g1815, _g1816, _g1817, _g1818, _g1819, _g1820, _g1821, _g1822, _g1823, _g1824, _g1825, _g1826, _g1827, _g1828, _g1829, _g1830, _g1831, _g1832, _g1833, _g1834, _g1835, _g1836, _g1837, _g1838, _g1839, _g1840, _g1841, _g1842, _g1843, _g1844, _g1845, _g1846, _g1847, _g1848, _g1849, _g1850, _g1851, _g1852, _g1853, _g1854, _g1855, _g1856, _g1857, _g1858, _g1859, _g1860, _g1861, _g1862, _g1863, _g1864, _g1865, _g1866, _g1867, _g1868, _g1869, _g1870, _g1871, _g1872, _g1873, _g1874, _g1875, _g1876, _g1877, _g1878, _g1879, _g1880, _g1881, _g1882, _g1883, _g1884, _g1885, _g1886, _g1887, _g1888, _g1889, _g1890, _g1891, _g1892, _g1893, _g1894, _g1895, _g1896, _g1897, _g1898, _g1899, _g1900, _g1901, _g1902, _g1903, _g1904, _g1905, _g1906, _g1907, _g1908, _g1909, _g1910, _g1911, _g1912, _g1913, _g1914, _g1915, _g1916, _g1917, _g1918, _g1919, _g1920, _g1921, _g1922, _g1923, _g1924, _g1925, _g1926, _g1927, _g1928, _g1929, _g1930, _g1931, _g1932, _g1933, _g1934, _g1935, _g1936, _g1937, _g1938, _g1939, _g1940, _g1941, _g1942, _g1943, _g1944, _g1945, _g1946, _g1947, _g1948, _g1949, _g1950, _g1951, _g1952, _g1953, _g1954, _g1955, _g1956, _g1957, _g1958, _g1959, _g1960, _g1961, _g1962, _g1963, _g1964, _g1965, _g1966, _g1967, _g1968, _g1969, _g1970, _g1971, _g1972, _g1973, _g1974, _g1975, _g1976, _g1977, _g1978, _g1979, _g1980, _g1981, _g1982, _g1983, _g1984, _g1985, _g1986, _g1987, _g1988, _g1989, _g1990, _g1991, _g1992, _g1993, _g1994, _g1995, _g1996, _g1997, _g1998, _g1999, _g2000, _g2001, _g2002, _g2003, _g2004, _g2005, _g2006, _g2007, _g2008, _g2009, _g2010, _g2011, _g2012, _g2013, _g2014, _g2015, _g2016, _g2017, _g2018, _g2019, _g2020, _g2021, _g2022, _g2023, _g2024, _g2025, _g2026, _g2027, _g2028, _g2029, _g2030, _g2031, _g2032, _g2033, _g2034, _g2035, _g2036, _g2037, _g2038, _g2039, _g2040, _g2041, _g2042, _g2043, _g2044, _g2045, _g2046, _g2047, _g2048, _g2049, _g2050, _g2051, _g2052, _g2053, _g2054, _g2055, _g2056, _g2057, _g2058, _g2059, _g2060, _g2061, _g2062, _g2063, _g2064, _g2065, _g2066, _g2067, _g2068, _g2069, _g2070, _g2071, _g2072, _g2073, _g2074, _g2075, _g2076, _g2077, _g2078, _g2079, _g2080, _g2081, _g2082, _g2083, _g2084, _g2085, _g2086, _g2087, _g2088, _g2089, _g2090, _g2091, _g2092, _g2093, _g2094, _g2095, _g2096, _g2097, _g2098, _g2099, _g2100, _g2101, _g2102, _g2103, _g2104, _g2105, _g2106, _g2107, _g2108, _g2109, _g2110, _g2111, _g2112, _g2113, _g2114, _g2115, _g2116, _g2117, _g2118, _g2119, _g2120, _g2121, _g2122, _g2123, _g2124, _g2125, _g2126, _g2127, _g2128, _g2129, _g2130, _g2131, _g2132, _g2133, _g2134, _g2135, _g2136, _g2137, _g2138, _g2139, _g2140, _g2141, _g2142, _g2143, _g2144, _g2145, _g2146, _g2147, _g2148, _g2149, _g2150, _g2151, _g2152, _g2153, _g2154, _g2155, _g2156, _g2157, _g2158, _g2159, _g2160, _g2161, _g2162, _g2163, _g2164, _g2165, _g2166, _g2167, _g2168, _g2169, _g2170, _g2171, _g2172, _g2173, _g2174, _g2175, _g2176, _g2177, _g2178, _g2179, _g2180, _g2181, _g2182, _g2183, _g2184, _g2185, _g2186, _g2187, _g2188, _g2189, _g2190, _g2191, _g2192, _g2193, _g2194, _g2195, _g2196, _g2197, _g2198, _g2199, _g2200, _g2201, _g2202, _g2203, _g2204, _g2205, _g2206, _g2207, _g2208, _g2209, _g2210, _g2211, _g2212, _g2213, _g2214, _g2215, _g2216, _g2217, _g2218, _g2219, _g2220, _g2221, _g2222, _g2223, _g2224, _g2225, _g2226, _g2227, _g2228, _g2229, _g2230, _g2231, _g2232, _g2233, _g2234, _g2235, _g2236, _g2237, _g2238, _g2239, _g2240, _g2241, _g2242, _g2243, _g2244, _g2245, _g2246, _g2247, _g2248, _g2249, _g2250, _g2251, _g2252, _g2253, _g2254, _g2255, _g2256, _g2257, _g2258, _g2259, _g2260, _g2261, _g2262, _g2263, _g2264, _g2265, _g2266, _g2267, _g2268, _g2269, _g2270, _g2271, _g2272, _g2273, _g2274, _g2275, _g2276, _g2277, _g2278, _g2279, _g2280, _g2281, _g2282, _g2283, _g2284, _g2285, _g2286, _g2287, _g2288, _g2289, _g2290, _g2291, _g2292, _g2293, _g2294, _g2295, _g2296, _g2297, _g2298, _g2299, _g2300, _g2301, _g2302, _g2303, _g2304, _g2305, _g2306, _g2307, _g2308, _g2309, _g2310, _g2311, _g2312, _g2313, _g2314, _g2315, _g2316, _g2317, _g2318, _g2319, _g2320, _g2321, _g2322, _g2323, _g2324, _g2325, _g2326, _g2327, _g2328, _g2329, _g2330, _g2331, _g2332, _g2333, _g2334, _g2335, _g2336, _g2337, _g2338, _g2339, _g2340, _g2341, _g2342, _g2343, _g2344, _g2345, _g2346, _g2347, _g2348, _g2349, _g2350, _g2351, _g2352, _g2353, _g2354, _g2355, _g2356, _g2357, _g2358, _g2359, _g2360, _g2361, _g2362, _g2363, _g2364, _g2365, _g2366, _g2367, _g2368, _g2369, _g2370, _g2371, _g2372, _g2373, _g2374, _g2375, _g2376, _g2377, _g2378, _g2379, _g2380, _g2381, _g2382, _g2383, _g2384, _g2385, _g2386, _g2387, _g2388, _g2389, _g2390, _g2391, _g2392, _g2393, _g2394, _g2395, _g2396, _g2397, _g2398, _g2399, _g2400, _g2401, _g2402, _g2403, _g2404, _g2405, _g2406, _g2407, _g2408, _g2409, _g2410, _g2411, _g2412, _g2413, _g2414, _g2415, _g2416, _g2417, _g2418, _g2419, _g2420, _g2421, _g2422, _g2423, _g2424, _g2425, _g2426, _g2427, _g2428, _g2429, _g2430, _g2431, _g2432, _g2433, _g2434, _g2435, _g2436, _g2437, _g2438, _g2439, _g2440, _g2441, _g2442, _g2443, _g2444, _g2445, _g2446, _g2447, _g2448, _g2449, _g2450, _g2451, _g2452, _g2453, _g2454, _g2455, _g2456, _g2457, _g2458, _g2459, _g2460, _g2461, _g2462, _g2463, _g2464, _g2465, _g2466, _g2467, _g2468, _g2469, _g2470, _g2471, _g2472, _g2473, _g2474, _g2475, _g2476, _g2477, _g2478, _g2479, _g2480, _g2481, _g2482, _g2483, _g2484, _g2485, _g2486, _g2487, _g2488, _g2489, _g2490, _g2491, _g2492, _g2493, _g2494, _g2495, _g2496, _g2497, _g2498, _g2499, _g2500, _g2501, _g2502, _g2503, _g2504, _g2505, _g2506, _g2507, _g2508, _g2509, _g2510, _g2511, _g2512, _g2513, _g2514, _g2515, _g2516, _g2517, _g2518, _g2519, _g2520, _g2521, _g2522, _g2523, _g2524, _g2525, _g2526, _g2527, _g2528, _g2529, _g2530, _g2531, _g2532, _g2533, _g2534, _g2535, _g2536, _g2537, _g2538, _g2539, _g2540, _g2541, _g2542, _g2543, _g2544, _g2545, _g2546, _g2547, _g2548, _g2549, _g2550, _g2551, _g2552, _g2553, _g2554, _g2555, _g2556, _g2557, _g2558, _g2559, _g2560, _g2561, _g2562, _g2563, _g2564, _g2565, _g2566, _g2567, _g2568, _g2569, _g2570, _g2571, _g2572, _g2573, _g2574, _g2575, _g2576, _g2577, _g2578, _g2579, _g2580, _g2581, _g2582, _g2583, _g2584, _g2585, _g2586, _g2587, _g2588, _g2589, _g2590, _g2591, _g2592;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarmosharkM6Ultra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.97 344.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.28px;}.cls-1{stroke:#0b0c0d;}.cls-2{stroke:#323538;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m6BodyFill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#202225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m6LeftButtonFill",
    x1: 0,
    y1: 0,
    x2: 0.9,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4c4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#343638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f2123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m6RightButtonFill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#303235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1d1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m6CenterFill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m6WheelFill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#686a6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#343638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111214"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "m6Honeycomb",
    width: 24,
    height: 20.8,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1 H14 L19 10.4 L14 19.8 H6 L1 10.4 Z",
    fill: "#050607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 -9.4 H26 L31 0 L26 9.4 H18 L13 0 Z",
    fill: "#090a0b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m6BodyClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.29 .24 C56 5.5 36 14.5 18.67 20.37 C11.5 23.5 7.5 29 5.17 38.57 C2.8 60 4.2 84 3.43 108.75 C.5 119 2.2 144 3.87 162.75 C5 180 5.4 196 4.25 210.56 C.5 231 -.5 251 1.28 268.08 C3.8 285 9 299 17.5 308.71 C34 331 60 343 88.98 344.55 C118 344 144 331 160.46 308.71 C169 299 174.2 285 176.7 268.08 C178.5 251 177.5 231 173.72 210.56 C172.6 196 173 180 174.1 162.75 C175.8 144 177.5 119 174.54 108.75 C173.8 84 175.2 60 172.79 38.57 C170.5 29 166.5 23.5 159.29 20.37 C142 14.5 122 5.5 103.67 .24 C95 -.4 83 -.4 74.29 .24 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "M6_COLOR_LAYER"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m6BodyFill)",
    d: "M74.29 .24 C56 5.5 36 14.5 18.67 20.37 C11.5 23.5 7.5 29 5.17 38.57 C2.8 60 4.2 84 3.43 108.75 C.5 119 2.2 144 3.87 162.75 C5 180 5.4 196 4.25 210.56 C.5 231 -.5 251 1.28 268.08 C3.8 285 9 299 17.5 308.71 C34 331 60 343 88.98 344.55 C118 344 144 331 160.46 308.71 C169 299 174.2 285 176.7 268.08 C178.5 251 177.5 231 173.72 210.56 C172.6 196 173 180 174.1 162.75 C175.8 144 177.5 119 174.54 108.75 C173.8 84 175.2 60 172.79 38.57 C170.5 29 166.5 23.5 159.29 20.37 C142 14.5 122 5.5 103.67 .24 C95 -.4 83 -.4 74.29 .24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m6LeftButtonFill)",
    d: "M74.4 1 C55 6 34 14 18.7 20.6 C12.2 24 9 30 7.4 37 L8.8 72.2 C9.5 91 11 111 13 130 C14.2 142 18.5 151 27 153 H87.8 V98 C81 96 76 92 76 86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m6RightButtonFill)",
    d: "M103.6 1 C123 6 144 14 159.3 20.6 C165.8 24 169 30 170.6 37 L169.2 72.2 C168.5 91 167 111 165 130 C163.8 142 159.5 151 151 153 H90.2 V98 C97 96 102 92 102 86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m6CenterFill)",
    d: "M76 1 C82 -.2 96 -.2 102 1 L102 86 C101 94 96 98 89 99 C82 98 77 94 76 86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    opacity: 0.97,
    d: "M13 151 H165 L170 211 C166 258 157 309 128 331 C105 348 73 348 50 333 C21 314 10 261 8 211 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 101,
    width: 182,
    height: 229,
    fill: "url(#m6Honeycomb)",
    clipPath: "url(#m6BodyClip)",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f3134",
    d: "M4.4 61 C7 57 10 57 11 62 L13 132 C13 139 10 143 7 141 L3 130 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303235",
    d: "M6 151 C9 148 12 150 12.5 156 L14 204 C14 211 11 215 8 211 L5 199 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191b1d",
    d: "M173.6 61 C171 57 168 57 167 62 L165 132 C165 139 168 143 171 141 L175 130 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2,
    y: 28,
    width: 19.6,
    height: 54,
    rx: 8,
    fill: "#08090a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 29.5,
    width: 16.4,
    height: 50.5,
    rx: 7,
    fill: "url(#m6WheelFill)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#111315",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 36 l5 4 5-4 M84 44 l5 4 5-4 M84 52 l5 4 5-4 M84 60 l5 4 5-4 M84 68 l5 4 5-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89 99 V211",
    stroke: "#090a0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 151 C45 154 68 154 89 154 C110 154 133 154 165 151",
    fill: "none",
    stroke: "#08090a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22 C40 14 59 6 74 2 M104 2 C119 6 138 14 160 22",
    fill: "none",
    stroke: "#66686a",
    strokeWidth: 0.8,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.29 .24 C56 5.5 36 14.5 18.67 20.37 C11.5 23.5 7.5 29 5.17 38.57 C2.8 60 4.2 84 3.43 108.75 C.5 119 2.2 144 3.87 162.75 C5 180 5.4 196 4.25 210.56 C.5 231 -.5 251 1.28 268.08 C3.8 285 9 299 17.5 308.71 C34 331 60 343 88.98 344.55 C118 344 144 331 160.46 308.71 C169 299 174.2 285 176.7 268.08 C178.5 251 177.5 231 173.72 210.56 C172.6 196 173 180 174.1 162.75 C175.8 144 177.5 119 174.54 108.75 C173.8 84 175.2 60 172.79 38.57 C170.5 29 166.5 23.5 159.29 20.37 C142 14.5 122 5.5 103.67 .24 C95 -.4 83 -.4 74.29 .24 Z",
    fill: "none",
    stroke: "#626568",
    strokeWidth: 0.85,
    opacity: 0.72
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "88.98 344.55 95.72 344.3 103.1 343.44 110.25 342.03 117.15 340.13 123.81 337.76 130.19 334.93 136.27 331.62 142.02 327.82 147.38 323.52 152.32 318.75 156.86 313.54 160.46 308.71"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 338.82,
    x2: 81.49,
    y2: 338.82
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-2",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 335.94,
    x2: 101.46,
    y2: 335.94
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-3",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 335.94,
    x2: 69.01,
    y2: 335.94
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-4",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 332.33,
    x2: 92.73,
    y2: 332.33
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-5",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 326.57,
    x2: 117.69,
    y2: 326.57
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-6",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 326.57,
    x2: 85.24,
    y2: 326.57
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-7",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 326.57,
    x2: 52.78,
    y2: 326.57
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-8",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 322.97,
    x2: 76.5,
    y2: 322.97
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-9",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 322.97,
    x2: 108.95,
    y2: 322.97
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-10",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 115.15,
    y1: 318.62,
    x2: 114.79,
    y2: 318.62
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-11",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.82,
    y1: 318.62,
    x2: 63.17,
    y2: 318.62
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-12",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 317.2,
    x2: 133.92,
    y2: 317.2
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-13",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 317.2,
    x2: 101.46,
    y2: 317.2
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-14",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 317.2,
    x2: 69.01,
    y2: 317.2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-15",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 317.2,
    x2: 36.56,
    y2: 317.2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-16",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.57,
    y1: 315.36,
    x2: 74.46,
    y2: 315.36
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-17",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.94,
    y1: 315.36,
    x2: 51.77,
    y2: 315.36
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-18",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.4,
    y1: 315.36,
    x2: 103.51,
    y2: 315.36
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-19",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.03,
    y1: 315.36,
    x2: 126.2,
    y2: 315.36
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-20",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 313.6,
    x2: 60.27,
    y2: 313.6
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-21",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 313.6,
    x2: 92.73,
    y2: 313.6
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-22",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 313.6,
    x2: 125.18,
    y2: 313.6
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-23",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.51,
    y1: 311.9,
    x2: 98.4,
    y2: 311.9
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-24",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.46,
    y1: 311.9,
    x2: 79.56,
    y2: 311.9
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-25",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.58,
    y1: 308.64,
    x2: 66.47,
    y2: 308.64
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-26",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.3,
    y1: 308.64,
    x2: 39.53,
    y2: 308.64
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-27",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.38,
    y1: 308.64,
    x2: 111.49,
    y2: 308.64
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-28",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 132.67,
    y1: 308.64,
    x2: 138.43,
    y2: 308.64
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-29",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 307.83,
    x2: 117.69,
    y2: 307.83
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-30",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 307.83,
    x2: 85.24,
    y2: 307.83
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-31",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 307.83,
    x2: 52.78,
    y2: 307.83
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-32",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.43,
    y1: 305.18,
    x2: 133.37,
    y2: 305.18
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-33",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.5,
    y1: 305.18,
    x2: 109.38,
    y2: 305.18
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-34",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.86,
    y1: 305.18,
    x2: 86.1,
    y2: 305.18
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-35",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.53,
    y1: 305.18,
    x2: 44.59,
    y2: 305.18
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-36",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.47,
    y1: 305.18,
    x2: 68.58,
    y2: 305.18
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-37",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 304.23,
    x2: 44.05,
    y2: 304.23
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-38",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 304.23,
    x2: 76.5,
    y2: 304.23
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-39",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 304.23,
    x2: 108.95,
    y2: 304.23
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-40",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 304.23,
    x2: 141.41,
    y2: 304.23
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-41",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.94,
    y1: 301.91,
    x2: 51.17,
    y2: 301.91
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-42",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.03,
    y1: 301.91,
    x2: 126.79,
    y2: 301.91
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-2",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "17.5 308.71 18.34 309.89 19.38 311.31 20.37 312.6 21.38 313.88 22.54 315.28 23.79 316.72 25.13 318.19 26.55 319.68 28.05 321.18 29.65 322.68 31.34 324.18 33.12 325.65 34.98 327.1 36.92 328.51 38.94 329.89 41.03 331.21 43.2 332.5 45.43 333.73 47.74 334.91 50.12 336.04 52.56 337.11 55.07 338.12 57.65 339.08 60.29 339.97 62.99 340.79 65.76 341.55 68.58 342.23 71.47 342.84 74.41 343.36 77.4 343.8 80.45 344.14 83.55 344.38 86.7 344.52 88.98 344.55"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-3",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.82 34.98 8.54 35.29 8.08 35.72 7.67 36.04 7.34 36.23 7.2 36.28"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-4",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.46 23.25 12.63 24.02 11.81 24.92 11.12 25.8 10.56 26.64 10.12 27.4 9.98 27.67"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-43",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.46,
    y1: 23.25,
    x2: 13.46,
    y2: 23.25
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-44",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.7,
    y1: 10.14,
    x2: 55.92,
    y2: 10.05
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-45",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.7,
    y1: 9.49,
    x2: 55.37,
    y2: 9.62
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-46",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.52,
    y1: 10.5,
    x2: 53.7,
    y2: 10.43
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-47",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 41.17,
    y1: 15.81,
    x2: 41.35,
    y2: 15.74
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-48",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.19,
    y1: 5.17,
    x2: 67.35,
    y2: 5.11
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-5",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "18.07 20.56 17.7 20.7 16.67 21.14 15.67 21.66 14.72 22.27 13.82 22.94 13.46 23.25"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-49",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.26,
    y1: 15.95,
    x2: 39.44,
    y2: 15.89
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-50",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.07,
    y1: 4.96,
    x2: 69.23,
    y2: 4.91
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-51",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.07,
    y1: 4.34,
    x2: 68.79,
    y2: 4.44
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-52",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 4.69,
    x2: 76.01,
    y2: 5.2
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-53",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.33,
    y1: 20.48,
    x2: 18.08,
    y2: 20.56
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-6",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "74.29 0.24 67.44 2.53 60.08 5.3 52.85 8.17 45.7 10.99 38.63 13.66 31.63 16.15 24.75 18.45 18.67 20.37"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-54",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.91,
    y1: 20.79,
    x2: 27.09,
    y2: 20.73
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-55",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.59,
    y1: 20.39,
    x2: 18.33,
    y2: 20.48
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-56",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.67,
    y1: 20.37,
    x2: 18.59,
    y2: 20.39
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-57",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 127.71,
    y1: 299.24,
    x2: 115.16,
    y2: 299.24
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-58",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.25,
    y1: 299.24,
    x2: 82.71,
    y2: 299.24
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-59",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.8,
    y1: 299.24,
    x2: 50.26,
    y2: 299.24
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-60",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 298.47,
    x2: 133.92,
    y2: 298.47
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-61",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 298.47,
    x2: 101.46,
    y2: 298.47
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-62",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 298.47,
    x2: 69.01,
    y2: 298.47
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-63",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 298.47,
    x2: 36.56,
    y2: 298.47
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-64",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 294.86,
    x2: 27.82,
    y2: 294.86
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-65",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 294.86,
    x2: 60.27,
    y2: 294.86
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-66",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 294.86,
    x2: 92.73,
    y2: 294.86
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-67",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 294.86,
    x2: 125.18,
    y2: 294.86
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-68",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 294.86,
    x2: 157.63,
    y2: 294.86
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-69",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 289.1,
    x2: 150.15,
    y2: 289.1
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-70",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 289.1,
    x2: 117.69,
    y2: 289.1
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-71",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 289.1,
    x2: 85.24,
    y2: 289.1
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-72",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 289.1,
    x2: 52.78,
    y2: 289.1
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-73",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 289.1,
    x2: 20.33,
    y2: 289.1
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-74",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.3,
    y1: 288.38,
    x2: 7.62,
    y2: 288.38
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-75",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 169.67,
    y1: 288.38,
    x2: 170.35,
    y2: 288.38
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-76",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.22,
    y1: 286.22,
    x2: 8.6,
    y2: 286.22
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-77",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.74,
    y1: 286.22,
    x2: 169.36,
    y2: 286.22
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-78",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 285.5,
    x2: 44.05,
    y2: 285.5
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-79",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 285.5,
    x2: 76.5,
    y2: 285.5
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-80",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 285.5,
    x2: 108.95,
    y2: 285.5
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-81",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 285.5,
    x2: 141.41,
    y2: 285.5
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-82",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.07,
    y1: 285.01,
    x2: 147.79,
    y2: 285.01
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-83",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.89,
    y1: 285.01,
    x2: 30.18,
    y2: 285.01
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-84",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172,
    y1: 284.06,
    x2: 171.34,
    y2: 284.06
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-85",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.97,
    y1: 284.06,
    x2: 6.62,
    y2: 284.06
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-86",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.06,
    y1: 281.75,
    x2: 26.01,
    y2: 281.75
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-87",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.9,
    y1: 281.75,
    x2: 151.96,
    y2: 281.75
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-88",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 142.62,
    y1: 282.04,
    x2: 138.02,
    y2: 282.04
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-89",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 141.49,
    y1: 282.04,
    x2: 139.19,
    y2: 282.04
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-90",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 307.83,
    x2: 20.33,
    y2: 294.86
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-91",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 289.1,
    x2: 19.13,
    y2: 287.02
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-92",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 317.2,
    x2: 32.82,
    y2: 310.72
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-93",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 294.86,
    x2: 31.56,
    y2: 301.35
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-94",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.62,
    y1: 288.38,
    x2: 7.72,
    y2: 288.62
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-95",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.62,
    y1: 288.38,
    x2: 7.72,
    y2: 288.62
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-7",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.8 28.17 9.77 28.28 9.56 29.06 9.4 29.81 9.28 30.52 9.2 31.18"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-8",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.98 27.66 9.98 27.68 9.91 27.83 9.85 28 9.8 28.17"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-96",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.98,
    y1: 27.67,
    x2: 9.99,
    y2: 27.66
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-9",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.54 36.45 6.44 36.49 6.17 36.65 5.93 36.88 5.73 37.16 5.55 37.49 5.39 37.86 5.26 38.25 5.17 38.57"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-97",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 279.73,
    x2: 133.92,
    y2: 279.73
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-98",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 279.73,
    x2: 101.46,
    y2: 279.73
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-99",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 279.73,
    x2: 69.01,
    y2: 279.73
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-100",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 279.73,
    x2: 36.56,
    y2: 279.73
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-101",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.04,
    y1: 279.73,
    x2: 7.32,
    y2: 279.73
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-102",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.93,
    y1: 279.73,
    x2: 170.64,
    y2: 279.73
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-103",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.59,
    y1: 279.02,
    x2: 148.48,
    y2: 279.02
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-104",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 141.82,
    y1: 279.02,
    x2: 135.1,
    y2: 279.02
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-105",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.87,
    y1: 279.02,
    x2: 36.15,
    y2: 279.02
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-106",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.49,
    y1: 279.02,
    x2: 25.38,
    y2: 279.02
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-107",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.01,
    y1: 277.57,
    x2: 10.7,
    y2: 277.57
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-108",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.96,
    y1: 277.57,
    x2: 167.26,
    y2: 277.57
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-109",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 276.13,
    x2: 27.82,
    y2: 276.13
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-110",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 276.13,
    x2: 60.27,
    y2: 276.13
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-111",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 276.13,
    x2: 92.73,
    y2: 276.13
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-112",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 276.13,
    x2: 125.18,
    y2: 276.13
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-113",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 276.13,
    x2: 157.63,
    y2: 276.13
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-114",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.4,
    y1: 275.99,
    x2: 42.87,
    y2: 275.99
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-115",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.1,
    y1: 275.99,
    x2: 143.57,
    y2: 275.99
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-116",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.1,
    y1: 275.41,
    x2: 169.63,
    y2: 275.41
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-117",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.87,
    y1: 275.41,
    x2: 8.34,
    y2: 275.41
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-118",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.41,
    y1: 271.37,
    x2: 13.28,
    y2: 271.37
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-119",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.9,
    y1: 271.37,
    x2: 42.87,
    y2: 271.37
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-120",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.1,
    y1: 271.37,
    x2: 144.07,
    y2: 271.37
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-121",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.69,
    y1: 271.37,
    x2: 165.55,
    y2: 271.37
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-122",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.28,
    y1: 271.09,
    x2: 9.75,
    y2: 271.09
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-123",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.89,
    y1: 271.09,
    x2: 2.36,
    y2: 271.09
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-124",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.69,
    y1: 271.09,
    x2: 168.22,
    y2: 271.09
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-125",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.08,
    y1: 271.09,
    x2: 175.6,
    y2: 271.09
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-126",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 270.37,
    x2: 150.15,
    y2: 270.37
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-127",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 270.37,
    x2: 117.69,
    y2: 270.37
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-128",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 270.37,
    x2: 85.24,
    y2: 270.37
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-129",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 270.37,
    x2: 52.78,
    y2: 270.37
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-130",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 270.37,
    x2: 20.33,
    y2: 270.37
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-131",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.06,
    y1: 269.64,
    x2: 149.73,
    y2: 269.64
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-132",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.03,
    y1: 269.64,
    x2: 135.1,
    y2: 269.64
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-133",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.87,
    y1: 269.64,
    x2: 34.93,
    y2: 269.64
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-134",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.24,
    y1: 269.64,
    x2: 19.91,
    y2: 269.64
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-135",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.63,
    y1: 268.92,
    x2: 3.21,
    y2: 268.92
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-136",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.34,
    y1: 268.92,
    x2: 174.76,
    y2: 268.92
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-137",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.38,
    y1: 266.76,
    x2: 175.92,
    y2: 266.76
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-138",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 169.7,
    y1: 266.76,
    x2: 166.3,
    y2: 266.76
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-139",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.58,
    y1: 266.76,
    x2: 2.05,
    y2: 266.76
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-140",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.26,
    y1: 266.76,
    x2: 11.67,
    y2: 266.76
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-141",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 266.76,
    x2: 44.05,
    y2: 266.76
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-142",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 266.76,
    x2: 76.5,
    y2: 266.76
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-143",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 266.76,
    x2: 108.95,
    y2: 266.76
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-144",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 266.76,
    x2: 141.41,
    y2: 266.76
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-145",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.59,
    y1: 262.44,
    x2: 2.76,
    y2: 262.44
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-146",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.37,
    y1: 262.44,
    x2: 175.21,
    y2: 262.44
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-147",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.01,
    y1: 281.75,
    x2: 27.89,
    y2: 285.01
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-148",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.99,
    y1: 304.23,
    x2: 39.53,
    y2: 305.18
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-149",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 270.37,
    x2: 19.91,
    y2: 269.63
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-150",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 326.57,
    x2: 49.04,
    y2: 320.08
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-151",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 298.47,
    x2: 32.82,
    y2: 291.98
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-152",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.15,
    y1: 311.84,
    x2: 45.3,
    y2: 308.64
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-153",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 276.13,
    x2: 31.56,
    y2: 282.61
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-154",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 304.23,
    x2: 47.79,
    y2: 310.72
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-155",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.82,
    y1: 320.35,
    x2: 56.94,
    y2: 315.36
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-156",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 307.83,
    x2: 49.04,
    y2: 301.35
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-157",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 279.73,
    x2: 32.82,
    y2: 273.25
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-158",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 335.94,
    x2: 65.27,
    y2: 329.45
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-159",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.93,
    y1: 313.63,
    x2: 62.82,
    y2: 318.62
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-160",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 257.4,
    x2: 31.56,
    y2: 263.88
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-161",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 285.5,
    x2: 47.79,
    y2: 291.98
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-162",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 313.6,
    x2: 64.02,
    y2: 320.08
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-10",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.89 283.34 7.52 290.44 10.61 297.17 14.13 303.51 17.5 308.71"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-163",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.36,
    y1: 271.09,
    x2: 2.39,
    y2: 271.19
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-164",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.36,
    y1: 271.09,
    x2: 2.39,
    y2: 271.19
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-11",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.28 268.08 2.79 275.88 4.89 283.34"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-165",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.83,
    y1: 271.28,
    x2: 1.81,
    y2: 271.19
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-166",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.83,
    y1: 271.28,
    x2: 1.82,
    y2: 271.18
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-167",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.4,
    y1: 259.99,
    x2: 1.28,
    y2: 268.08
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-168",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.77,
    y1: 260.21,
    x2: 0.79,
    y2: 260.37
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-169",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.77,
    y1: 260.21,
    x2: 0.79,
    y2: 260.37
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-170",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.14,
    y1: 251.64,
    x2: 0.4,
    y2: 259.99
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-171",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.01,
    y1: 38.68,
    x2: 6,
    y2: 38.82
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-172",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.01,
    y1: 38.68,
    x2: 6,
    y2: 38.82
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-173",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.12,
    y1: 45.36,
    x2: 4.18,
    y2: 44.67
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-174",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.12,
    y1: 45.36,
    x2: 4.18,
    y2: 44.73
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-175",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.34,
    y1: 31.07,
    x2: 9.32,
    y2: 31.2
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-176",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.42,
    y1: 108.81,
    x2: 3.42,
    y2: 108.81
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-12",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.63 114.34 1.57 114.65 1.51 114.97 1.45 115.3 1.4 115.63 1.36 115.97 1.32 116.31 1.28 116.66 1.25 117.01 1.23 117.36 1.21 117.72 1.2 118.08 1.19 118.45 1.19 118.82 1.2 119.19 1.21 119.56 1.23 119.83"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-13",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.43 108.75 3.43 108.75 3.43 108.76"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-14",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.17 38.57 5.03 39.17 4.74 40.53 4.5 41.86 4.3 43.14 4.15 44.38 4.12 44.73"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-15",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.43 108.76 3.42 108.78 3.41 108.82 3.38 108.89 3.35 109.01 3.29 109.16"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-16",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.29 109.16 3.22 109.34 3.14 109.55 2.96 110"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-17",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2.96 110 2.87 110.24 2.78 110.49 2.69 110.74 2.6 110.99 2.5 111.25 2.42 111.5 2.33 111.76 2.24 112.03 2.16 112.3 2.08 112.57 2 112.85 1.92 113.13 1.84 113.42 1.77 113.72 1.7 114.03 1.63 114.34"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-177",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.91,
    y1: 41.95,
    x2: 26.91,
    y2: 38.49
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-178",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.91,
    y1: 44.26,
    x2: 24.91,
    y2: 47.71
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-179",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.91,
    y1: 59.24,
    x2: 26.91,
    y2: 55.78
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-180",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.44,
    y1: 39.84,
    x2: 24.91,
    y2: 65.01
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-181",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.08,
    y1: 66.45,
    x2: 14.93,
    y2: 82.3
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-182",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.93,
    y1: 84.03,
    x2: 25.08,
    y2: 68.18
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-183",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.91,
    y1: 65.01,
    x2: 40.3,
    y2: 41.81
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-184",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.71,
    y1: 270.8,
    x2: 6.42,
    y2: 271.03
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-185",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.79,
    y1: 269.39,
    x2: 7.53,
    y2: 269.08
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-186",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 261,
    x2: 133.92,
    y2: 261
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-187",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 261,
    x2: 101.46,
    y2: 261
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-188",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 261,
    x2: 69.01,
    y2: 261
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-189",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 261,
    x2: 36.56,
    y2: 261
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-190",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.71,
    y1: 260.28,
    x2: 5.24,
    y2: 260.28
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-191",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.26,
    y1: 260.28,
    x2: 172.73,
    y2: 260.28
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-192",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.85,
    y1: 258.12,
    x2: 174.2,
    y2: 258.12
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-193",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 165.27,
    y1: 258.12,
    x2: 163.87,
    y2: 258.12
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-194",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.11,
    y1: 258.12,
    x2: 3.77,
    y2: 258.12
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-195",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.69,
    y1: 258.12,
    x2: 14.09,
    y2: 258.12
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-196",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.69,
    y1: 257.4,
    x2: 27.82,
    y2: 257.4
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-197",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 257.4,
    x2: 60.27,
    y2: 257.4
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-198",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 257.4,
    x2: 92.73,
    y2: 257.4
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-199",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 257.4,
    x2: 125.18,
    y2: 257.4
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-200",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 257.4,
    x2: 157.27,
    y2: 257.4
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-201",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.92,
    y1: 253.79,
    x2: 5.19,
    y2: 253.79
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-202",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.64,
    y1: 253.79,
    x2: 0.37,
    y2: 253.79
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-203",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.05,
    y1: 253.79,
    x2: 172.77,
    y2: 253.79
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-204",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.33,
    y1: 253.79,
    x2: 177.59,
    y2: 253.79
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-205",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.83,
    y1: 251.63,
    x2: 150.15,
    y2: 251.63
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-206",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 251.63,
    x2: 117.69,
    y2: 251.63
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-207",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 251.63,
    x2: 85.24,
    y2: 251.63
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-208",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 251.63,
    x2: 52.78,
    y2: 251.63
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-209",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 251.63,
    x2: 21.13,
    y2: 251.63
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-210",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.68,
    y1: 251.63,
    x2: 9.09,
    y2: 251.63
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-211",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.8,
    y1: 251.63,
    x2: 0.96,
    y2: 251.63
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-212",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.29,
    y1: 251.63,
    x2: 168.87,
    y2: 251.63
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-213",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.16,
    y1: 251.63,
    x2: 177,
    y2: 251.63
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-214",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.66,
    y1: 249.47,
    x2: 177.45,
    y2: 249.47
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-215",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.38,
    y1: 249.47,
    x2: 170.84,
    y2: 249.47
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-216",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.31,
    y1: 249.47,
    x2: 0.51,
    y2: 249.47
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-217",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.59,
    y1: 249.47,
    x2: 7.12,
    y2: 249.47
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-218",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 248.03,
    x2: 44.05,
    y2: 248.03
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-219",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 248.03,
    x2: 76.5,
    y2: 248.03
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-220",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 248.03,
    x2: 108.95,
    y2: 248.03
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-221",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 248.03,
    x2: 141.41,
    y2: 248.03
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-222",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.46,
    y1: 245.15,
    x2: 9.6,
    y2: 245.15
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-223",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.44,
    y1: 245.15,
    x2: 1.26,
    y2: 245.15
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-224",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.51,
    y1: 245.15,
    x2: 168.37,
    y2: 245.15
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-225",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.52,
    y1: 245.15,
    x2: 176.71,
    y2: 245.15
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-226",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.5,
    y1: 242.98,
    x2: 3.14,
    y2: 242.98
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-227",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.47,
    y1: 242.98,
    x2: 174.83,
    y2: 242.98
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-228",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 242.26,
    x2: 133.92,
    y2: 242.26
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-229",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 242.26,
    x2: 101.46,
    y2: 242.26
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-230",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 242.26,
    x2: 69.01,
    y2: 242.26
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-231",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 242.26,
    x2: 36.56,
    y2: 242.26
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-232",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.25,
    y1: 270.8,
    x2: 171.54,
    y2: 271.03
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-233",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.17,
    y1: 269.39,
    x2: 170.43,
    y2: 269.08
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-234",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 157.71,
    y1: 286.92,
    x2: 158.65,
    y2: 287.34
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-18",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.36 208.16 9.63 208.62 9.95 209.01 10.3 209.29 10.64 209.45 10.87 209.51"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-235",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.82,
    y1: 306.91,
    x2: 56.94,
    y2: 301.91
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-236",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 289.1,
    x2: 49.04,
    y2: 282.61
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-237",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 261,
    x2: 32.82,
    y2: 254.51
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-238",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 317.2,
    x2: 65.27,
    y2: 310.72
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-239",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.93,
    y1: 300.18,
    x2: 62.31,
    y2: 304.3
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-240",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 238.66,
    x2: 31.56,
    y2: 245.15
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-241",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 266.76,
    x2: 47.79,
    y2: 273.25
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-242",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 294.86,
    x2: 64.02,
    y2: 301.35
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-243",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 322.97,
    x2: 80.25,
    y2: 329.45
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-244",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.46,
    y1: 313.63,
    x2: 68.58,
    y2: 308.64
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-245",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.58,
    y1: 306.91,
    x2: 74.46,
    y2: 311.9
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-246",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 270.37,
    x2: 49.04,
    y2: 263.88
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-247",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 242.26,
    x2: 32.82,
    y2: 235.78
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-248",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 326.57,
    x2: 81.49,
    y2: 320.08
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-249",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 298.47,
    x2: 65.27,
    y2: 291.98
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-250",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 219.93,
    x2: 31.56,
    y2: 226.41
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-251",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 248.03,
    x2: 47.79,
    y2: 254.51
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-252",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 276.13,
    x2: 64.02,
    y2: 282.61
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-253",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 304.23,
    x2: 80.25,
    y2: 310.72
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-254",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 332.33,
    x2: 96.47,
    y2: 338.82
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-255",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.3,
    y1: 208.06,
    x2: 9.36,
    y2: 208.16
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-256",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.29,
    y1: 208.02,
    x2: 9.09,
    y2: 207.63
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-19",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.09 207.63 9.05 207.54 8.87 207.22 8.65 206.84 8.41 206.44 8.13 206.01 7.84 205.53 7.55 205.03 7.25 204.51 6.96 203.96 6.68 203.4 6.42 202.82 6.18 202.23 5.96 201.63 5.76 201 5.58 200.36 5.44 199.7 5.31 199.03 5.22 198.35 5.16 197.66 5.12 196.95 5.12 196.4"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-20",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.1 207.64 9.17 207.79 9.3 208.05"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-257",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.09,
    y1: 207.63,
    x2: 9.09,
    y2: 207.63
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-258",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.3,
    y1: 208.05,
    x2: 9.29,
    y2: 208.02
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-259",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.43,
    y1: 271.2,
    x2: 12.41,
    y2: 271.09
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-260",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.43,
    y1: 271.2,
    x2: 12.41,
    y2: 271.09
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-261",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.18,
    y1: 109.64,
    x2: 5.16,
    y2: 109.48
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-262",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.84,
    y1: 115.95,
    x2: 5.76,
    y2: 115.2
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-263",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.76,
    y1: 115.2,
    x2: 5.7,
    y2: 114.64
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-264",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.67,
    y1: 114.33,
    x2: 5.58,
    y2: 113.46
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-265",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.84,
    y1: 115.95,
    x2: 5.79,
    y2: 115.46
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-266",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.09,
    y1: 118.33,
    x2: 6.03,
    y2: 117.71
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-267",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.67,
    y1: 114.69,
    x2: 5.59,
    y2: 113.95
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-268",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.79,
    y1: 115.46,
    x2: 5.7,
    y2: 114.65
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-269",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.27,
    y1: 110.42,
    x2: 5.17,
    y2: 109.48
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-270",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.7,
    y1: 114.65,
    x2: 5.58,
    y2: 113.46
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-21",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "5.27 110.42 5.26 110.33 5.24 110.15"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-271",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.08,
    y1: 108.69,
    x2: 5.08,
    y2: 108.61
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-272",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.93,
    y1: 107.17,
    x2: 4.86,
    y2: 106.43
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-273",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.54,
    y1: 114.67,
    x2: 5.41,
    y2: 113.36
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-274",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.22,
    y1: 111.41,
    x2: 5.16,
    y2: 110.77
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-275",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.22,
    y1: 111.41,
    x2: 5.16,
    y2: 110.77
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-22",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.25 163.92 12.37 165.28 12.56 167.59 12.73 169.92 12.89 172.3 13.03 174.7 13.11 176.27"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-276",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.97,
    y1: 131.11,
    x2: 5.94,
    y2: 130.73
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-277",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.97,
    y1: 131.11,
    x2: 5.94,
    y2: 130.73
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-23",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.2 101.5 3.86 96.57 3.52 91.43 3.31 87.89"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-278",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.63,
    y1: 107.58,
    x2: 4.55,
    y2: 106.36
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-279",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.55,
    y1: 106.36,
    x2: 4.2,
    y2: 101.5
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-24",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.23 119.83 1.85 130.93 2.18 136.76 2.5 142.72 2.83 148.69 3.11 153.78"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-280",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.11,
    y1: 176.27,
    x2: 13.13,
    y2: 176.73
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-281",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.18,
    y1: 176.26,
    x2: 13.24,
    y2: 177.41
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-25",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.17 177.42 13.41 182.21 13.68 187.72 13.9 193.03 14.07 198.11 14.17 202.97 14.19 206.79"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-282",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.13,
    y1: 176.73,
    x2: 13.17,
    y2: 177.42
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-283",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.18,
    y1: 176.26,
    x2: 13.23,
    y2: 177.41
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-284",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.42,
    y1: 162.63,
    x2: 9.43,
    y2: 162.72
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-285",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.8,
    y1: 156.13,
    x2: 6.78,
    y2: 155.27
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-286",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.89,
    y1: 161.31,
    x2: 6.8,
    y2: 156.13
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-287",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.43,
    y1: 155.88,
    x2: 9.42,
    y2: 155.36
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-288",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.43,
    y1: 156.12,
    x2: 9.42,
    y2: 155.36
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-289",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.43,
    y1: 156.12,
    x2: 9.43,
    y2: 155.88
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-26",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.12 196.39 5.09 191.7 4.98 186.17 4.81 180.46 4.61 174.68 4.3 168.47 3.87 162.75"
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-290",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.72,
    y1: 161.31,
    x2: 9.72,
    y2: 160.45
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-291",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.72,
    y1: 156.12,
    x2: 9.72,
    y2: 155.26
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-292",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.53,
    y1: 26.4,
    x2: 11.53,
    y2: 82.76
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-293",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.26,
    y1: 82.3,
    x2: 13.26,
    y2: 25.23
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-294",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.49,
    y1: 225.26,
    x2: 13.49,
    y2: 223.53
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-295",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.49,
    y1: 146.15,
    x2: 15.49,
    y2: 150.67
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-296",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.37,
    y1: 151.88,
    x2: 18.37,
    y2: 154.52
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-297",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 126.25,
    x2: 20.33,
    y2: 139.22
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-298",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.12,
    y1: 196.39,
    x2: 5.12,
    y2: 196.4
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-299",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.26,
    y1: 50.93,
    x2: 13.27,
    y2: 50.6
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-300",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.26,
    y1: 50.93,
    x2: 13.27,
    y2: 50.6
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-27",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.19 206.79 14.18 207.24 14.12 207.9 14.02 208.51 13.87 209.08 13.68 209.57"
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-301",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.31,
    y1: 245.83,
    x2: 0.14,
    y2: 251.64
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-302",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 277.69,
    x2: 13.01,
    y2: 277.56
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-303",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.42,
    y1: 199.75,
    x2: 5.43,
    y2: 199.65
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-304",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.31,
    y1: 245.83,
    x2: 0.32,
    y2: 245.62
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-305",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.51,
    y1: 242.96,
    x2: 0.5,
    y2: 243.1
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-306",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.51,
    y1: 242.96,
    x2: 0.5,
    y2: 243.1
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-307",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.87,
    y1: 242.9,
    x2: 6.86,
    y2: 243.09
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-308",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.03,
    y1: 236.5,
    x2: 0.9,
    y2: 237.86
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-309",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.88,
    y1: 242.9,
    x2: 6.86,
    y2: 243.09
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-28",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.03 236.5 1.17 235.18 1.5 232.18"
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-29",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.25 210.56 4.52 208.06 4.71 206.24"
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-310",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.26,
    y1: 210.56,
    x2: 4.13,
    y2: 211.68
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-311",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.26,
    y1: 210.56,
    x2: 4.13,
    y2: 211.68
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-312",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.62,
    y1: 216,
    x2: 3.49,
    y2: 217.04
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-313",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.48,
    y1: 224.44,
    x2: 2.61,
    y2: 223.45
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-314",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.67,
    y1: 212.76,
    x2: 9.8,
    y2: 211.73
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-315",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.82,
    y1: 219.12,
    x2: 4.11,
    y2: 217.04
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-316",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.89,
    y1: 225.26,
    x2: 6.01,
    y2: 224.4
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-317",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.01,
    y1: 224.4,
    x2: 6.24,
    y2: 222.85
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-318",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.14,
    y1: 134.58,
    x2: 8.13,
    y2: 134.61
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-319",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 107.52,
    x2: 16.59,
    y2: 114
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-320",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.7,
    y1: 65.01,
    x2: 40.3,
    y2: 88.21
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-321",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.31,
    y1: 89.94,
    x2: 28.49,
    y2: 108.68
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-322",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.49,
    y1: 110.41,
    x2: 36.56,
    y2: 98.15
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-323",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.3,
    y1: 89.94,
    x2: 55.7,
    y2: 65.01
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-324",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 42.79,
    x2: 78.89,
    y2: 41.35
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-325",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.09,
    y1: 241.6,
    x2: 61.97,
    y2: 241.6
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-326",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.63,
    y1: 241.6,
    x2: 76.89,
    y2: 241.6
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-327",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.54,
    y1: 241.6,
    x2: 94.42,
    y2: 241.6
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-328",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.08,
    y1: 241.6,
    x2: 109.34,
    y2: 241.6
  }))), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-329",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 116,
    y1: 241.6,
    x2: 126.88,
    y2: 241.6
  }))), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-330",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.66,
    y1: 240.82,
    x2: 175.61,
    y2: 240.82
  }))), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-331",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 169,
    y1: 240.82,
    x2: 165.39,
    y2: 240.82
  }))), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-332",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.3,
    y1: 240.82,
    x2: 2.35,
    y2: 240.82
  }))), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-333",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.97,
    y1: 240.82,
    x2: 12.58,
    y2: 240.82
  }))), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-334",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.13,
    y1: 238.66,
    x2: 27.82,
    y2: 238.66
  }))), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-335",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 238.66,
    x2: 60.27,
    y2: 238.66
  }))), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-336",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 238.66,
    x2: 92.73,
    y2: 238.66
  }))), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-337",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 238.66,
    x2: 125.18,
    y2: 238.66
  }))), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-338",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 238.66,
    x2: 155.84,
    y2: 238.66
  }))), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-339",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.54,
    y1: 237.94,
    x2: 34.06,
    y2: 237.94
  }))), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-340",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.84,
    y1: 236.5,
    x2: 3.84,
    y2: 236.5
  }))), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-341",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.06,
    y1: 236.5,
    x2: 1.03,
    y2: 236.5
  }))), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-342",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.69,
    y1: 236.5,
    x2: 79.83,
    y2: 236.5
  }))), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-343",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.13,
    y1: 236.5,
    x2: 112.28,
    y2: 236.5
  }))), _g372 || (_g372 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-344",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.59,
    y1: 236.5,
    x2: 143.74,
    y2: 236.5
  }))), _g373 || (_g373 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-345",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.12,
    y1: 236.5,
    x2: 174.13,
    y2: 236.5
  }))), _g374 || (_g374 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-346",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.9,
    y1: 236.5,
    x2: 176.93,
    y2: 236.5
  }))), _g375 || (_g375 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-347",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.4,
    y1: 234.34,
    x2: 6.96,
    y2: 234.34
  }))), _g376 || (_g376 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-348",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.09,
    y1: 234.34,
    x2: 1.39,
    y2: 234.34
  }))), _g377 || (_g377 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-349",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.56,
    y1: 234.34,
    x2: 171.01,
    y2: 234.34
  }))), _g378 || (_g378 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-350",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.87,
    y1: 234.34,
    x2: 176.58,
    y2: 234.34
  }))), _g379 || (_g379 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-351",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.46,
    y1: 232.9,
    x2: 150.15,
    y2: 232.9
  }))), _g380 || (_g380 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-352",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 232.9,
    x2: 117.69,
    y2: 232.9
  }))), _g381 || (_g381 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-353",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 232.9,
    x2: 85.24,
    y2: 232.9
  }))), _g382 || (_g382 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-354",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 232.9,
    x2: 52.78,
    y2: 232.9
  }))), _g383 || (_g383 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-355",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 232.9,
    x2: 22.51,
    y2: 232.9
  }))), _g384 || (_g384 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-356",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.46,
    y1: 232.18,
    x2: 176.46,
    y2: 232.18
  }))), _g385 || (_g385 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-357",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.1,
    y1: 232.18,
    x2: 172.26,
    y2: 232.18
  }))), _g386 || (_g386 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-358",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.74,
    y1: 232.18,
    x2: 161.77,
    y2: 232.18
  }))), _g387 || (_g387 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-359",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.5,
    y1: 232.18,
    x2: 1.51,
    y2: 232.18
  }))), _g388 || (_g388 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-360",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.87,
    y1: 232.18,
    x2: 5.71,
    y2: 232.18
  }))), _g389 || (_g389 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-361",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.23,
    y1: 232.18,
    x2: 16.2,
    y2: 232.18
  }))), _g390 || (_g390 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-362",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 229.29,
    x2: 44.05,
    y2: 229.29
  }))), _g391 || (_g391 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-363",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 229.29,
    x2: 76.5,
    y2: 229.29
  }))), _g392 || (_g392 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-364",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 229.29,
    x2: 108.95,
    y2: 229.29
  }))), _g393 || (_g393 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-365",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 229.29,
    x2: 141.41,
    y2: 229.29
  }))), _g394 || (_g394 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-366",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.84,
    y1: 227.85,
    x2: 7.93,
    y2: 227.85
  }))), _g395 || (_g395 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-367",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.85,
    y1: 227.85,
    x2: 2.21,
    y2: 227.85
  }))), _g396 || (_g396 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-368",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.13,
    y1: 227.85,
    x2: 170.03,
    y2: 227.85
  }))), _g397 || (_g397 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-369",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.11,
    y1: 227.85,
    x2: 175.76,
    y2: 227.85
  }))), _g398 || (_g398 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-370",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.89,
    y1: 225.69,
    x2: 12.32,
    y2: 225.69
  }))), _g399 || (_g399 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-371",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.64,
    y1: 225.69,
    x2: 3.49,
    y2: 225.69
  }))), _g400 || (_g400 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-372",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.08,
    y1: 225.69,
    x2: 165.65,
    y2: 225.69
  }))), _g401 || (_g401 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-373",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.33,
    y1: 225.69,
    x2: 174.47,
    y2: 225.69
  }))), _g402 || (_g402 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-374",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.08,
    y1: 225.26,
    x2: 171.35,
    y2: 225.26
  }))), _g403 || (_g403 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-375",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.01,
    y1: 225.26,
    x2: 162.68,
    y2: 225.26
  }))), _g404 || (_g404 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-376",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.59,
    y1: 225.26,
    x2: 13.49,
    y2: 225.26
  }))), _g405 || (_g405 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-377",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.89,
    y1: 225.26,
    x2: 6.62,
    y2: 225.26
  }))), _g406 || (_g406 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-378",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.29,
    y1: 223.53,
    x2: 174.77,
    y2: 223.53
  }))), _g407 || (_g407 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-379",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.18,
    y1: 223.53,
    x2: 167.5,
    y2: 223.53
  }))), _g408 || (_g408 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-380",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.73,
    y1: 223.53,
    x2: 162.66,
    y2: 223.53
  }))), _g409 || (_g409 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-381",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 223.53,
    x2: 133.92,
    y2: 223.53
  }))), _g410 || (_g410 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-382",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 223.53,
    x2: 101.46,
    y2: 223.53
  }))), _g411 || (_g411 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-383",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 223.53,
    x2: 69.01,
    y2: 223.53
  }))), _g412 || (_g412 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-384",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 223.53,
    x2: 36.56,
    y2: 223.53
  }))), _g413 || (_g413 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-385",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.34,
    y1: 223.53,
    x2: 6.14,
    y2: 223.53
  }))), _g414 || (_g414 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-386",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.68,
    y1: 223.53,
    x2: 3.19,
    y2: 223.53
  }))), _g415 || (_g415 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-387",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.78,
    y1: 223.53,
    x2: 10.46,
    y2: 223.53
  }))), _g416 || (_g416 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-388",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.49,
    y1: 223.53,
    x2: 16.66,
    y2: 223.53
  }))), _g417 || (_g417 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-389",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.63,
    y1: 223.53,
    x2: 171.82,
    y2: 223.53
  }))), _g418 || (_g418 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-390",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.86,
    y1: 209.51,
    x2: 11.8,
    y2: 209.69
  }))), _g419 || (_g419 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-30",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.27 160.95 11.51 161.34 11.74 161.82 11.95 162.39 12.11 163 12.21 163.63 12.25 163.92"
  }))), _g420 || (_g420 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-391",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 251.63,
    x2: 49.04,
    y2: 245.15
  }))), _g421 || (_g421 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-392",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 223.53,
    x2: 32.82,
    y2: 217.04
  }))), _g422 || (_g422 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-393",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 335.94,
    x2: 97.72,
    y2: 329.45
  }))), _g423 || (_g423 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-394",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 307.83,
    x2: 81.49,
    y2: 301.35
  }))), _g424 || (_g424 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-395",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 279.73,
    x2: 65.27,
    y2: 273.25
  }))), _g425 || (_g425 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-396",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.22,
    y1: 300.18,
    x2: 86.1,
    y2: 305.18
  }))), _g426 || (_g426 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-397",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 201.19,
    x2: 31.56,
    y2: 207.68
  }))), _g427 || (_g427 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-398",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 229.29,
    x2: 47.79,
    y2: 235.78
  }))), _g428 || (_g428 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-399",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 257.4,
    x2: 64.02,
    y2: 263.88
  }))), _g429 || (_g429 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-400",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 285.5,
    x2: 80.25,
    y2: 291.98
  }))), _g430 || (_g430 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-401",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 313.6,
    x2: 96.47,
    y2: 320.08
  }))), _g431 || (_g431 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-402",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 232.9,
    x2: 49.04,
    y2: 226.41
  }))), _g432 || (_g432 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-403",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 204.79,
    x2: 32.82,
    y2: 198.31
  }))), _g433 || (_g433 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-404",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 317.2,
    x2: 97.72,
    y2: 310.72
  }))), _g434 || (_g434 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-405",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 289.1,
    x2: 81.49,
    y2: 282.61
  }))), _g435 || (_g435 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-406",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 261,
    x2: 65.27,
    y2: 254.51
  }))), _g436 || (_g436 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-407",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.2,
    y1: 299.24,
    x2: 94.75,
    y2: 300.18
  }))), _g437 || (_g437 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-408",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.51,
    y1: 315.36,
    x2: 104.57,
    y2: 317.2
  }))), _g438 || (_g438 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-409",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 182.46,
    x2: 31.56,
    y2: 188.94
  }))), _g439 || (_g439 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-410",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 210.56,
    x2: 47.79,
    y2: 217.04
  }))), _g440 || (_g440 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-411",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 238.66,
    x2: 64.02,
    y2: 245.15
  }))), _g441 || (_g441 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-412",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 266.76,
    x2: 80.25,
    y2: 273.25
  }))), _g442 || (_g442 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-413",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 294.86,
    x2: 96.47,
    y2: 301.35
  }))), _g443 || (_g443 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-414",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 322.97,
    x2: 112.7,
    y2: 329.45
  }))), _g444 || (_g444 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-415",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.57,
    y1: 317.2,
    x2: 106.5,
    y2: 313.63
  }))), _g445 || (_g445 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-31",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.67 106.36 4.67 106.36 4.67 106.37 4.68 106.39 4.68 106.43 4.69 106.47 4.7 106.51 4.71 106.57 4.72 106.63 4.74 106.7 4.75 106.78 4.76 106.86"
  }))), _g446 || (_g446 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-416",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.35,
    y1: 144.82,
    x2: 15.52,
    y2: 145.6
  }))), _g447 || (_g447 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-417",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.37,
    y1: 134.84,
    x2: 13.38,
    y2: 134.92
  }))), _g448 || (_g448 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-418",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.69,
    y1: 134.84,
    x2: 10.71,
    y2: 134.94
  }))), _g449 || (_g449 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-419",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.23,
    y1: 134.06,
    x2: 13.37,
    y2: 134.84
  }))), _g450 || (_g450 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-420",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.78,
    y1: 151.01,
    x2: 11.05,
    y2: 152.7
  }))), _g451 || (_g451 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-421",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.76,
    y1: 106.86,
    x2: 4.79,
    y2: 107.05
  }))), _g452 || (_g452 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-32",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.13 134.61 8.5 137 9.01 140.22 9.51 143.39 10 146.52 10.47 149.6 10.79 151.82"
  }))), _g453 || (_g453 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-422",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.79,
    y1: 107.05,
    x2: 4.83,
    y2: 107.28
  }))), _g454 || (_g454 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-33",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.83 107.28 4.87 107.53 4.89 107.67 4.91 107.82 4.93 107.98"
  }))), _g455 || (_g455 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-423",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.79,
    y1: 151.82,
    x2: 10.79,
    y2: 151.82
  }))), _g456 || (_g456 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-424",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.81,
    y1: 134.82,
    x2: 7.79,
    y2: 134.66
  }))), _g457 || (_g457 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-34",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.93 107.98 4.95 108.15 4.97 108.32 5 108.51 5.02 108.7 5.05 108.9 5.07 109.11 5.1 109.33"
  }))), _g458 || (_g458 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-35",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.79 151.82 10.83 152.08 10.88 152.72 10.88 153.38 10.84 154.01 10.75 154.59 10.62 155.1 10.47 155.52 10.31 155.83 10.17 156.03 10.12 156.08"
  }))), _g459 || (_g459 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-425",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.1,
    y1: 109.33,
    x2: 5.14,
    y2: 109.67
  }))), _g460 || (_g460 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-36",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "6.1 118.32 6.05 117.87 6.03 117.71"
  }))), _g461 || (_g461 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-37",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "5.24 110.15 5.23 110.07 5.18 109.64"
  }))), _g462 || (_g462 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-38",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.85 116.4 6 117.8 6.44 121.64 6.88 125.32 7.33 128.84 7.78 132.21 8.13 134.61"
  }))), _g463 || (_g463 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-426",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.91,
    y1: 20.74,
    x2: 24.91,
    y2: 41.95
  }))), _g464 || (_g464 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-427",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.91,
    y1: 47.71,
    x2: 24.91,
    y2: 59.24
  }))), _g465 || (_g465 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-428",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.38,
    y1: 279.02,
    x2: 25.38,
    y2: 276.13
  }))), _g466 || (_g466 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-429",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.91,
    y1: 55.78,
    x2: 26.91,
    y2: 44.26
  }))), _g467 || (_g467 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-430",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.91,
    y1: 38.49,
    x2: 26.91,
    y2: 20.1
  }))), _g468 || (_g468 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-431",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.22,
    y1: 178.05,
    x2: 34.22,
    y2: 177.14
  }))), _g469 || (_g469 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-432",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.66,
    y1: 122.65,
    x2: 35.66,
    y2: 126.97
  }))), _g470 || (_g470 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-433",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 116.89,
    x2: 37.1,
    y2: 129.86
  }))), _g471 || (_g471 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-434",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 135.62,
    x2: 37.1,
    y2: 148.59
  }))), _g472 || (_g472 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-435",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 157.49,
    x2: 37.1,
    y2: 158.93
  }))), _g473 || (_g473 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-436",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 161.81,
    x2: 37.1,
    y2: 167.33
  }))), _g474 || (_g474 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-437",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 173.09,
    x2: 37.1,
    y2: 186.06
  }))), _g475 || (_g475 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-438",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 191.82,
    x2: 37.1,
    y2: 204.79
  }))), _g476 || (_g476 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-439",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.83,
    y1: 148.59,
    x2: 38.83,
    y2: 135.62
  }))), _g477 || (_g477 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-440",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.83,
    y1: 129.86,
    x2: 38.83,
    y2: 116.89
  }))), _g478 || (_g478 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-441",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.44,
    y1: 15.78,
    x2: 39.44,
    y2: 39.84
  }))), _g479 || (_g479 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-442",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.17,
    y1: 39.84,
    x2: 41.17,
    y2: 15.14
  }))), _g480 || (_g480 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-443",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.71,
    y1: 191.82,
    x2: 41.71,
    y2: 204.79
  }))), _g481 || (_g481 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-444",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.02,
    y1: 220.94,
    x2: 9.86,
    y2: 221.86
  }))), _g482 || (_g482 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-445",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.02,
    y1: 220.94,
    x2: 9.86,
    y2: 221.85
  }))), _g483 || (_g483 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-446",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.6,
    y1: 217.76,
    x2: 10.53,
    y2: 218.13
  }))), _g484 || (_g484 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-447",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.6,
    y1: 217.76,
    x2: 10.53,
    y2: 218.13
  }))), _g485 || (_g485 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-448",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.26,
    y1: 217.77,
    x2: 10.79,
    y2: 214.9
  }))), _g486 || (_g486 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-449",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.26,
    y1: 217.76,
    x2: 10.78,
    y2: 214.9
  }))), _g487 || (_g487 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-450",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.53,
    y1: 66.45,
    x2: 55.53,
    y2: 68.18
  }))), _g488 || (_g488 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-451",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 120.49,
    x2: 31.56,
    y2: 114
  }))), _g489 || (_g489 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-452",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 116.89,
    x2: 32.82,
    y2: 123.37
  }))), _g490 || (_g490 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-453",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 139.22,
    x2: 31.56,
    y2: 132.74
  }))), _g491 || (_g491 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-454",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 111.12,
    x2: 47.79,
    y2: 104.64
  }))), _g492 || (_g492 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-455",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.68,
    y1: 84.03,
    x2: 65.68,
    y2: 82.3
  }))), _g493 || (_g493 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-456",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 135.62,
    x2: 32.82,
    y2: 142.11
  }))), _g494 || (_g494 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-457",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 114,
    x2: 67.35,
    y2: 82.3
  }))), _g495 || (_g495 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-458",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.78,
    y1: 107.52,
    x2: 69.07,
    y2: 82.76
  }))), _g496 || (_g496 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-459",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.52,
    y1: 43.11,
    x2: 90.53,
    y2: 43.09
  }))), _g497 || (_g497 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-460",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.52,
    y1: 43.11,
    x2: 90.53,
    y2: 43.09
  }))), _g498 || (_g498 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-39",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.87 162.75 4.27 162.33 4.59 161.97 4.86 161.67 5.06 161.42 5.15 161.31"
  }))), _g499 || (_g499 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-461",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.83,
    y1: 63.35,
    x2: 96.32,
    y2: 62.84
  }))), _g500 || (_g500 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-462",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.13,
    y1: 85.82,
    x2: 81.64,
    y2: 86.18
  }))), _g501 || (_g501 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-463",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 79.8,
    x2: 86.02,
    y2: 79.91
  }))), _g502 || (_g502 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-464",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 73.46,
    x2: 93.2,
    y2: 73.36
  }))), _g503 || (_g503 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-465",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.82,
    y1: 220.94,
    x2: 10.86,
    y2: 220.94
  }))), _g504 || (_g504 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-466",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.65,
    y1: 220.94,
    x2: 16.76,
    y2: 220.94
  }))), _g505 || (_g505 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-467",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.11,
    y1: 220.94,
    x2: 168.14,
    y2: 220.94
  }))), _g506 || (_g506 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-468",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.1,
    y1: 219.93,
    x2: 27.82,
    y2: 219.93
  }))), _g507 || (_g507 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-469",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 219.93,
    x2: 60.27,
    y2: 219.93
  }))), _g508 || (_g508 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-470",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 219.93,
    x2: 92.73,
    y2: 219.93
  }))), _g509 || (_g509 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-471",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 219.93,
    x2: 125.18,
    y2: 219.93
  }))), _g510 || (_g510 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-472",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 219.93,
    x2: 154.87,
    y2: 219.93
  }))), _g511 || (_g511 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-473",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.58,
    y1: 219.21,
    x2: 166.84,
    y2: 219.21
  }))), _g512 || (_g512 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-474",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.81,
    y1: 219.21,
    x2: 13.35,
    y2: 219.21
  }))), _g513 || (_g513 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-475",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.8,
    y1: 219.21,
    x2: 4.44,
    y2: 219.21
  }))), _g514 || (_g514 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-476",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.39,
    y1: 219.21,
    x2: 11.12,
    y2: 219.21
  }))), _g515 || (_g515 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-477",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.36,
    y1: 219.21,
    x2: 164.62,
    y2: 219.21
  }))), _g516 || (_g516 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-478",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.16,
    y1: 219.21,
    x2: 173.52,
    y2: 219.21
  }))), _g517 || (_g517 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-479",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.17,
    y1: 217.76,
    x2: 11.34,
    y2: 217.76
  }))), _g518 || (_g518 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-480",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.63,
    y1: 217.76,
    x2: 168.8,
    y2: 217.76
  }))), _g519 || (_g519 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-481",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.06,
    y1: 217.04,
    x2: 6.69,
    y2: 217.04
  }))), _g520 || (_g520 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-482",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.11,
    y1: 217.04,
    x2: 3.49,
    y2: 217.04
  }))), _g521 || (_g521 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-483",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.9,
    y1: 217.04,
    x2: 171.27,
    y2: 217.04
  }))), _g522 || (_g522 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-484",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.85,
    y1: 217.04,
    x2: 174.48,
    y2: 217.04
  }))), _g523 || (_g523 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-485",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.25,
    y1: 214.88,
    x2: 172.04,
    y2: 214.88
  }))), _g524 || (_g524 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-486",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.71,
    y1: 214.88,
    x2: 5.93,
    y2: 214.88
  }))), _g525 || (_g525 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-487",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 154.76,
    y1: 214.16,
    x2: 150.15,
    y2: 214.16
  }))), _g526 || (_g526 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-488",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 214.16,
    x2: 117.69,
    y2: 214.16
  }))), _g527 || (_g527 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-489",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 214.16,
    x2: 85.24,
    y2: 214.16
  }))), _g528 || (_g528 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-490",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 214.16,
    x2: 52.78,
    y2: 214.16
  }))), _g529 || (_g529 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-491",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 214.16,
    x2: 23.21,
    y2: 214.16
  }))), _g530 || (_g530 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-492",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.39,
    y1: 210.56,
    x2: 7.58,
    y2: 210.56
  }))), _g531 || (_g531 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-493",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.38,
    y1: 210.56,
    x2: 4.24,
    y2: 210.56
  }))), _g532 || (_g532 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-494",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 210.56,
    x2: 44.05,
    y2: 210.56
  }))), _g533 || (_g533 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-495",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 210.56,
    x2: 76.5,
    y2: 210.56
  }))), _g534 || (_g534 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-496",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 210.56,
    x2: 108.95,
    y2: 210.56
  }))), _g535 || (_g535 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-497",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 210.56,
    x2: 141.41,
    y2: 210.56
  }))), _g536 || (_g536 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-498",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.33,
    y1: 210.56,
    x2: 170.38,
    y2: 210.56
  }))), _g537 || (_g537 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-499",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.58,
    y1: 210.56,
    x2: 173.72,
    y2: 210.56
  }))), _g538 || (_g538 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-500",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.61,
    y1: 209.7,
    x2: 11.93,
    y2: 209.7
  }))), _g539 || (_g539 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-501",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.79,
    y1: 208.4,
    x2: 4.79,
    y2: 208.4
  }))), _g540 || (_g540 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-502",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.18,
    y1: 208.4,
    x2: 173.17,
    y2: 208.4
  }))), _g541 || (_g541 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-503",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.19,
    y1: 206.44,
    x2: 13.4,
    y2: 206.44
  }))), _g542 || (_g542 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-504",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.25,
    y1: 206.24,
    x2: 173.19,
    y2: 206.24
  }))), _g543 || (_g543 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-505",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.71,
    y1: 206.24,
    x2: 4.77,
    y2: 206.24
  }))), _g544 || (_g544 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-506",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 204.79,
    x2: 133.92,
    y2: 204.79
  }))), _g545 || (_g545 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-507",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 204.79,
    x2: 101.46,
    y2: 204.79
  }))), _g546 || (_g546 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-508",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 204.79,
    x2: 69.01,
    y2: 204.79
  }))), _g547 || (_g547 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-509",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 204.79,
    x2: 36.56,
    y2: 204.79
  }))), _g548 || (_g548 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-510",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.7,
    y1: 210.56,
    x2: 12.67,
    y2: 210.56
  }))), _g549 || (_g549 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-511",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.4,
    y1: 206.44,
    x2: 11.43,
    y2: 206.35
  }))), _g550 || (_g550 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-40",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.79 155.26 4.74 155.21 4.55 155.02 4.3 154.79 3.99 154.51 3.6 154.19 3.11 153.78"
  }))), _g551 || (_g551 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-512",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 214.16,
    x2: 49.04,
    y2: 207.68
  }))), _g552 || (_g552 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-513",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 186.06,
    x2: 32.82,
    y2: 179.58
  }))), _g553 || (_g553 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-514",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 298.47,
    x2: 97.72,
    y2: 291.98
  }))), _g554 || (_g554 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-515",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 270.37,
    x2: 81.49,
    y2: 263.88
  }))), _g555 || (_g555 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-516",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 242.26,
    x2: 65.27,
    y2: 235.78
  }))), _g556 || (_g556 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-517",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 326.57,
    x2: 113.95,
    y2: 320.08
  }))), _g557 || (_g557 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-518",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.84,
    y1: 304.23,
    x2: 106.39,
    y2: 306.91
  }))), _g558 || (_g558 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-519",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.56,
    y1: 321.07,
    x2: 118.14,
    y2: 320.35
  }))), _g559 || (_g559 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-520",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.38,
    y1: 305.18,
    x2: 108.87,
    y2: 304.28
  }))), _g560 || (_g560 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-521",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 163.72,
    x2: 31.56,
    y2: 170.21
  }))), _g561 || (_g561 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-522",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 191.82,
    x2: 47.79,
    y2: 198.31
  }))), _g562 || (_g562 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-523",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 219.93,
    x2: 64.02,
    y2: 226.41
  }))), _g563 || (_g563 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-524",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 248.03,
    x2: 80.25,
    y2: 254.51
  }))), _g564 || (_g564 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-525",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 276.13,
    x2: 96.47,
    y2: 282.61
  }))), _g565 || (_g565 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-526",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 304.23,
    x2: 112.7,
    y2: 310.72
  }))), _g566 || (_g566 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-527",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 195.43,
    x2: 49.04,
    y2: 188.94
  }))), _g567 || (_g567 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-528",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 167.33,
    x2: 33.27,
    y2: 161.63
  }))), _g568 || (_g568 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-529",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 279.73,
    x2: 97.72,
    y2: 273.25
  }))), _g569 || (_g569 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-530",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 251.63,
    x2: 81.49,
    y2: 245.15
  }))), _g570 || (_g570 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-531",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 223.53,
    x2: 65.27,
    y2: 217.04
  }))), _g571 || (_g571 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-532",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 307.83,
    x2: 113.95,
    y2: 301.35
  }))), _g572 || (_g572 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-533",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.68,
    y1: 307.83,
    x2: 118.14,
    y2: 306.91
  }))), _g573 || (_g573 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-534",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 173.09,
    x2: 47.79,
    y2: 179.58
  }))), _g574 || (_g574 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-535",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 201.19,
    x2: 64.02,
    y2: 207.68
  }))), _g575 || (_g575 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-536",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 229.29,
    x2: 80.25,
    y2: 235.78
  }))), _g576 || (_g576 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-537",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 257.4,
    x2: 96.47,
    y2: 263.88
  }))), _g577 || (_g577 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-538",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 285.5,
    x2: 112.7,
    y2: 291.98
  }))), _g578 || (_g578 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-539",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 313.6,
    x2: 128.92,
    y2: 320.08
  }))), _g579 || (_g579 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-540",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.49,
    y1: 299.24,
    x2: 118.03,
    y2: 300.18
  }))), _g580 || (_g580 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-541",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.87,
    y1: 279.73,
    x2: 42.87,
    y2: 266.76
  }))), _g581 || (_g581 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-542",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.87,
    y1: 261,
    x2: 42.87,
    y2: 248.03
  }))), _g582 || (_g582 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-543",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.17,
    y1: 182.17,
    x2: 45.17,
    y2: 175.04
  }))), _g583 || (_g583 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-544",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.9,
    y1: 199.85,
    x2: 46.9,
    y2: 196.77
  }))), _g584 || (_g584 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-545",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.19,
    y1: 180.62,
    x2: 47.19,
    y2: 178.53
  }))), _g585 || (_g585 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-546",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.7,
    y1: 10.28,
    x2: 53.7,
    y2: 38.49
  }))), _g586 || (_g586 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-547",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.7,
    y1: 44.26,
    x2: 53.7,
    y2: 55.78
  }))), _g587 || (_g587 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-548",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.7,
    y1: 59.24,
    x2: 55.7,
    y2: 47.71
  }))), _g588 || (_g588 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-549",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.7,
    y1: 41.95,
    x2: 55.7,
    y2: 9.49
  }))), _g589 || (_g589 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-550",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.27,
    y1: 38.68,
    x2: 96.32,
    y2: 38.52
  }))), _g590 || (_g590 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-551",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.08,
    y1: 41.38,
    x2: 96.32,
    y2: 40.71
  }))), _g591 || (_g591 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-552",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.29,
    y1: 39.52,
    x2: 97.56,
    y2: 38.87
  }))), _g592 || (_g592 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-553",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.95,
    y1: 41.24,
    x2: 97.56,
    y2: 39.81
  }))), _g593 || (_g593 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-554",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.83,
    y1: 46.94,
    x2: 96.32,
    y2: 45.8
  }))), _g594 || (_g594 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-555",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.95,
    y1: 44.99,
    x2: 97.56,
    y2: 43.71
  }))), _g595 || (_g595 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-556",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 63.07,
    x2: 93.2,
    y2: 62.61
  }))), _g596 || (_g596 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-557",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.68,
    y1: 209.57,
    x2: 13.45,
    y2: 209.98
  }))), _g597 || (_g597 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-558",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.83,
    y1: 54.24,
    x2: 96.32,
    y2: 53.39
  }))), _g598 || (_g598 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-559",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 129.86,
    x2: 47.79,
    y2: 123.37
  }))), _g599 || (_g599 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-560",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 126.25,
    x2: 49.04,
    y2: 132.74
  }))), _g600 || (_g600 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-561",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.96,
    y1: 96.51,
    x2: 65.27,
    y2: 104.64
  }))), _g601 || (_g601 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-562",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 170.21,
    x2: 27.82,
    y2: 176.69
  }))), _g602 || (_g602 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-563",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 148.59,
    x2: 47.79,
    y2: 142.11
  }))), _g603 || (_g603 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-564",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 120.49,
    x2: 64.02,
    y2: 114
  }))), _g604 || (_g604 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-565",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 144.99,
    x2: 49.04,
    y2: 151.47
  }))), _g605 || (_g605 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-566",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 179.58,
    x2: 36.56,
    y2: 173.09
  }))), _g606 || (_g606 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-567",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 116.89,
    x2: 65.27,
    y2: 123.37
  }))), _g607 || (_g607 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-568",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 64.93,
    x2: 93.2,
    y2: 64.53
  }))), _g608 || (_g608 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-569",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.49,
    y1: 80.8,
    x2: 87.4,
    y2: 80.94
  }))), _g609 || (_g609 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-570",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.13,
    y1: 95.44,
    x2: 81.64,
    y2: 96.17
  }))), _g610 || (_g610 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-571",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 69.11,
    x2: 91.95,
    y2: 68.86
  }))), _g611 || (_g611 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-572",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 86.02,
    x2: 84.76,
    y2: 86.34
  }))), _g612 || (_g612 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-573",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 84.1,
    x2: 84.76,
    y2: 84.36
  }))), _g613 || (_g613 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-574",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.06,
    y1: 201.91,
    x2: 5.51,
    y2: 201.91
  }))), _g614 || (_g614 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-575",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.66,
    y1: 201.91,
    x2: 172.46,
    y2: 201.91
  }))), _g615 || (_g615 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-576",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.12,
    y1: 201.19,
    x2: 27.82,
    y2: 201.19
  }))), _g616 || (_g616 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-577",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 201.19,
    x2: 60.27,
    y2: 201.19
  }))), _g617 || (_g617 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-578",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 201.19,
    x2: 92.73,
    y2: 201.19
  }))), _g618 || (_g618 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-579",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 201.19,
    x2: 125.18,
    y2: 201.19
  }))), _g619 || (_g619 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-580",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 201.19,
    x2: 154.85,
    y2: 201.19
  }))), _g620 || (_g620 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-581",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.23,
    y1: 197.59,
    x2: 98.13,
    y2: 197.59
  }))), _g621 || (_g621 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-582",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.83,
    y1: 197.59,
    x2: 76.73,
    y2: 197.59
  }))), _g622 || (_g622 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-583",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.23,
    y1: 197.01,
    x2: 98.47,
    y2: 197.01
  }))), _g623 || (_g623 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-584",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.5,
    y1: 197.01,
    x2: 76.73,
    y2: 197.01
  }))), _g624 || (_g624 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-585",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.23,
    y1: 196.82,
    x2: 98.58,
    y2: 196.82
  }))), _g625 || (_g625 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-586",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.38,
    y1: 196.82,
    x2: 76.73,
    y2: 196.82
  }))), _g626 || (_g626 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-587",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.03,
    y1: 195.43,
    x2: 150.15,
    y2: 195.43
  }))), _g627 || (_g627 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-588",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 195.43,
    x2: 117.69,
    y2: 195.43
  }))), _g628 || (_g628 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-589",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 195.43,
    x2: 85.24,
    y2: 195.43
  }))), _g629 || (_g629 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-590",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 195.43,
    x2: 52.78,
    y2: 195.43
  }))), _g630 || (_g630 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-591",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 195.43,
    x2: 22.94,
    y2: 195.43
  }))), _g631 || (_g631 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-592",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.64,
    y1: 192.11,
    x2: 83.32,
    y2: 192.11
  }))), _g632 || (_g632 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-593",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 191.82,
    x2: 44.05,
    y2: 191.82
  }))), _g633 || (_g633 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-594",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 191.82,
    x2: 76.5,
    y2: 191.82
  }))), _g634 || (_g634 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-595",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 191.82,
    x2: 108.95,
    y2: 191.82
  }))), _g635 || (_g635 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-596",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 191.82,
    x2: 141.41,
    y2: 191.82
  }))), _g636 || (_g636 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-597",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.33,
    y1: 190.38,
    x2: 95.64,
    y2: 190.38
  }))), _g637 || (_g637 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-598",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 186.06,
    x2: 133.92,
    y2: 186.06
  }))), _g638 || (_g638 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-599",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 186.06,
    x2: 101.46,
    y2: 186.06
  }))), _g639 || (_g639 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-600",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 186.06,
    x2: 69.01,
    y2: 186.06
  }))), _g640 || (_g640 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-601",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 186.06,
    x2: 36.56,
    y2: 186.06
  }))), _g641 || (_g641 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-602",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.12,
    y1: 238.66,
    x2: 123.48,
    y2: 241.6
  }))), _g642 || (_g642 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-603",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.1,
    y1: 256.04,
    x2: 139.09,
    y2: 261
  }))), _g643 || (_g643 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-604",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.31,
    y1: 261,
    x2: 135.1,
    y2: 253.28
  }))), _g644 || (_g644 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-605",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.7,
    y1: 241.6,
    x2: 123.34,
    y2: 238.66
  }))), _g645 || (_g645 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-606",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 142.62,
    y1: 282.04,
    x2: 141.08,
    y2: 279.73
  }))), _g646 || (_g646 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-607",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 142.62,
    y1: 282.04,
    x2: 141.18,
    y2: 279.88
  }))), _g647 || (_g647 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-608",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.59,
    y1: 114,
    x2: 20.33,
    y2: 120.49
  }))), _g648 || (_g648 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-609",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 142.11,
    x2: 36.56,
    y2: 148.59
  }))), _g649 || (_g649 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-610",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 176.69,
    x2: 49.04,
    y2: 170.21
  }))), _g650 || (_g650 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-611",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 261,
    x2: 97.72,
    y2: 254.51
  }))), _g651 || (_g651 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-612",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 232.9,
    x2: 81.49,
    y2: 226.41
  }))), _g652 || (_g652 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-613",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 204.79,
    x2: 65.27,
    y2: 198.31
  }))), _g653 || (_g653 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-614",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 317.2,
    x2: 130.17,
    y2: 310.72
  }))), _g654 || (_g654 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-615",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 289.1,
    x2: 113.95,
    y2: 282.61
  }))), _g655 || (_g655 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-616",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.79,
    y1: 301.91,
    x2: 127.69,
    y2: 303.48
  }))), _g656 || (_g656 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-617",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 132.74,
    x2: 27.82,
    y2: 126.25
  }))), _g657 || (_g657 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-618",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 182.46,
    x2: 64.02,
    y2: 188.94
  }))), _g658 || (_g658 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-619",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 210.56,
    x2: 80.25,
    y2: 217.04
  }))), _g659 || (_g659 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-620",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 238.66,
    x2: 96.47,
    y2: 245.15
  }))), _g660 || (_g660 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-621",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 266.76,
    x2: 112.7,
    y2: 273.25
  }))), _g661 || (_g661 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-622",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 294.86,
    x2: 128.92,
    y2: 301.35
  }))), _g662 || (_g662 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-623",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.43,
    y1: 308.64,
    x2: 138.58,
    y2: 308.89
  }))), _g663 || (_g663 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-624",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 123.37,
    x2: 36.56,
    y2: 129.86
  }))), _g664 || (_g664 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-625",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 242.26,
    x2: 97.72,
    y2: 235.78
  }))), _g665 || (_g665 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-626",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 214.16,
    x2: 81.49,
    y2: 207.68
  }))), _g666 || (_g666 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-627",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 186.06,
    x2: 65.27,
    y2: 179.58
  }))), _g667 || (_g667 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-628",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 298.47,
    x2: 130.17,
    y2: 291.98
  }))), _g668 || (_g668 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-629",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 270.37,
    x2: 113.95,
    y2: 263.88
  }))), _g669 || (_g669 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-630",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.53,
    y1: 82.76,
    x2: 25.83,
    y2: 107.52
  }))), _g670 || (_g670 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-631",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 114,
    x2: 13.26,
    y2: 82.3
  }))), _g671 || (_g671 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-632",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 163.72,
    x2: 64.02,
    y2: 170.21
  }))), _g672 || (_g672 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-633",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 142.11,
    x2: 44.05,
    y2: 135.62
  }))), _g673 || (_g673 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-634",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 191.82,
    x2: 80.25,
    y2: 198.31
  }))), _g674 || (_g674 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-635",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 219.93,
    x2: 96.47,
    y2: 226.41
  }))), _g675 || (_g675 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-636",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 248.03,
    x2: 112.7,
    y2: 254.51
  }))), _g676 || (_g676 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-637",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 276.13,
    x2: 128.92,
    y2: 282.61
  }))), _g677 || (_g677 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-638",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 304.23,
    x2: 145.15,
    y2: 310.72
  }))), _g678 || (_g678 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-639",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.93,
    y1: 82.3,
    x2: 15.93,
    y2: 84.03
  }))), _g679 || (_g679 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-640",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.25,
    y1: 85.18,
    x2: 75.24,
    y2: 84.86
  }))), _g680 || (_g680 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-641",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.24,
    y1: 81.64,
    x2: 75.24,
    y2: 81.58
  }))), _g681 || (_g681 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-642",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.24,
    y1: 81.64,
    x2: 75.24,
    y2: 81.58
  }))), _g682 || (_g682 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-643",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.23,
    y1: 76.54,
    x2: 75.23,
    y2: 76.07
  }))), _g683 || (_g683 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-644",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.23,
    y1: 76.54,
    x2: 75.23,
    y2: 76.07
  }))), _g684 || (_g684 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-645",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.21,
    y1: 68.61,
    x2: 75.21,
    y2: 67.89
  }))), _g685 || (_g685 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-646",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.21,
    y1: 68.61,
    x2: 75.21,
    y2: 67.89
  }))), _g686 || (_g686 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-647",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.08,
    y1: 201.44,
    x2: 67.08,
    y2: 195.18
  }))), _g687 || (_g687 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-648",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.35,
    y1: 4.97,
    x2: 67.35,
    y2: 82.3
  }))), _g688 || (_g688 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-649",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.07,
    y1: 82.76,
    x2: 69.07,
    y2: 4.34
  }))), _g689 || (_g689 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-650",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.96,
    y1: 96.51,
    x2: 69.96,
    y2: 111.12
  }))), _g690 || (_g690 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-651",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.96,
    y1: 116.89,
    x2: 69.96,
    y2: 129.86
  }))), _g691 || (_g691 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-652",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.96,
    y1: 135.62,
    x2: 69.96,
    y2: 148.59
  }))), _g692 || (_g692 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-653",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 204.79,
    x2: 71.69,
    y2: 191.82
  }))), _g693 || (_g693 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-654",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 186.06,
    x2: 71.69,
    y2: 173.09
  }))), _g694 || (_g694 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-655",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 167.33,
    x2: 71.69,
    y2: 162.99
  }))), _g695 || (_g695 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-656",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 160.11,
    x2: 71.69,
    y2: 158.67
  }))), _g696 || (_g696 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-657",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 148.59,
    x2: 71.69,
    y2: 135.62
  }))), _g697 || (_g697 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-658",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 129.86,
    x2: 71.69,
    y2: 116.89
  }))), _g698 || (_g698 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-659",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 111.12,
    x2: 71.69,
    y2: 97.76
  }))), _g699 || (_g699 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-660",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.05,
    y1: 116.89,
    x2: 72.05,
    y2: 111.12
  }))), _g700 || (_g700 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-661",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.13,
    y1: 160.14,
    x2: 73.13,
    y2: 158.69
  }))), _g701 || (_g701 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-662",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.13,
    y1: 148.59,
    x2: 73.13,
    y2: 135.62
  }))), _g702 || (_g702 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-663",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.13,
    y1: 129.86,
    x2: 73.13,
    y2: 116.89
  }))), _g703 || (_g703 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-664",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.01,
    y1: 88.64,
    x2: 76.01,
    y2: 1
  }))), _g704 || (_g704 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-665",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.73,
    y1: 197.59,
    x2: 76.73,
    y2: 192.22
  }))), _g705 || (_g705 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-666",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.73,
    y1: 185.66,
    x2: 76.73,
    y2: 173.49
  }))), _g706 || (_g706 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-667",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.73,
    y1: 166.93,
    x2: 76.73,
    y2: 163.08
  }))), _g707 || (_g707 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-668",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 42.79,
    x2: 77.45,
    y2: 93.42
  }))), _g708 || (_g708 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-669",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 29.36,
    x2: 77.45,
    y2: 2.76
  }))), _g709 || (_g709 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-670",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 78.89,
    y1: 41.35,
    x2: 78.89,
    y2: 95.08
  }))), _g710 || (_g710 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-671",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.76,
    y1: 95.76,
    x2: 79.76,
    y2: 40.85
  }))), _g711 || (_g711 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-672",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.05,
    y1: 112.56,
    x2: 72.05,
    y2: 111.12
  }))), _g712 || (_g712 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-673",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.47,
    y1: 49.54,
    x2: 90.56,
    y2: 48.66
  }))), _g713 || (_g713 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-674",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.66,
    y1: 39.02,
    x2: 91.82,
    y2: 37.77
  }))), _g714 || (_g714 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-675",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.76,
    y1: 38.9,
    x2: 91.82,
    y2: 38.39
  }))), _g715 || (_g715 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-676",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 38.91,
    x2: 91.95,
    y2: 37.7
  }))), _g716 || (_g716 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-677",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 39.88,
    x2: 91.95,
    y2: 38.66
  }))), _g717 || (_g717 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-678",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.66,
    y1: 41.46,
    x2: 91.82,
    y2: 40.29
  }))), _g718 || (_g718 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-679",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.47,
    y1: 58.08,
    x2: 90.56,
    y2: 57.47
  }))), _g719 || (_g719 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-680",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 43.78,
    x2: 91.95,
    y2: 42.69
  }))), _g720 || (_g720 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-681",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.66,
    y1: 46.74,
    x2: 91.82,
    y2: 45.75
  }))), _g721 || (_g721 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-682",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.49,
    y1: 91.2,
    x2: 87.4,
    y2: 91.68
  }))), _g722 || (_g722 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-683",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 50.34,
    x2: 91.95,
    y2: 49.46
  }))), _g723 || (_g723 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-684",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.17,
    y1: 38.04,
    x2: 93.2,
    y2: 37.87
  }))), _g724 || (_g724 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-685",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93,
    y1: 41.11,
    x2: 93.2,
    y2: 40.1
  }))), _g725 || (_g725 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-686",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.66,
    y1: 54.44,
    x2: 91.82,
    y2: 53.7
  }))), _g726 || (_g726 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-687",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 46.32,
    x2: 93.2,
    y2: 45.28
  }))), _g727 || (_g727 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-688",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.3,
    y1: 95.09,
    x2: 86.14,
    y2: 95.71
  }))), _g728 || (_g728 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-689",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 59.01,
    x2: 91.95,
    y2: 58.43
  }))), _g729 || (_g729 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-690",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 53.77,
    x2: 93.2,
    y2: 52.99
  }))), _g730 || (_g730 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-691",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.47,
    y1: 68.11,
    x2: 90.56,
    y2: 67.83
  }))), _g731 || (_g731 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-692",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 90.24,
    x2: 86.02,
    y2: 90.69
  }))), _g732 || (_g732 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-693",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 95.84,
    x2: 84.76,
    y2: 96.5
  }))), _g733 || (_g733 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-694",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 94.13,
    x2: 84.76,
    y2: 94.73
  }))), _g734 || (_g734 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-695",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 188.94,
    x2: 27.82,
    y2: 195.43
  }))), _g735 || (_g735 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-696",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.98,
    y1: 162.24,
    x2: 44.05,
    y2: 167.33
  }))), _g736 || (_g736 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-697",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 139.22,
    x2: 64.02,
    y2: 132.74
  }))), _g737 || (_g737 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-698",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 111.12,
    x2: 80.63,
    y2: 103.97
  }))), _g738 || (_g738 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-699",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 124.27,
    y1: 38.49,
    x2: 122.27,
    y2: 41.95
  }))), _g739 || (_g739 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-700",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 198.31,
    x2: 36.56,
    y2: 191.82
  }))), _g740 || (_g740 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-701",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 170.21,
    x2: 52.78,
    y2: 163.72
  }))), _g741 || (_g741 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-702",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 107.52,
    x2: 81.49,
    y2: 114
  }))), _g742 || (_g742 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-703",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 135.62,
    x2: 65.27,
    y2: 142.11
  }))), _g743 || (_g743 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-704",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.27,
    y1: 47.71,
    x2: 124.27,
    y2: 44.26
  }))), _g744 || (_g744 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-705",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 207.68,
    x2: 27.82,
    y2: 214.16
  }))), _g745 || (_g745 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-706",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 179.58,
    x2: 44.05,
    y2: 186.06
  }))), _g746 || (_g746 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-707",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 129.86,
    x2: 80.25,
    y2: 123.37
  }))), _g747 || (_g747 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-708",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 124.27,
    y1: 55.78,
    x2: 122.27,
    y2: 59.24
  }))), _g748 || (_g748 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-709",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 217.04,
    x2: 36.56,
    y2: 210.56
  }))), _g749 || (_g749 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-710",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 188.94,
    x2: 52.78,
    y2: 182.46
  }))), _g750 || (_g750 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-711",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 126.25,
    x2: 81.49,
    y2: 132.74
  }))), _g751 || (_g751 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-712",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.28,
    y1: 82.3,
    x2: 121.44,
    y2: 66.45
  }))), _g752 || (_g752 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-713",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.27,
    y1: 65.01,
    x2: 136.8,
    y2: 39.84
  }))), _g753 || (_g753 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-714",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.66,
    y1: 41.81,
    x2: 124.27,
    y2: 65.01
  }))), _g754 || (_g754 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-715",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.43,
    y1: 68.18,
    x2: 113.28,
    y2: 84.03
  }))), _g755 || (_g755 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-716",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 226.41,
    x2: 27.82,
    y2: 232.9
  }))), _g756 || (_g756 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-717",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 170.21,
    x2: 60.27,
    y2: 176.69
  }))), _g757 || (_g757 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-718",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 198.31,
    x2: 44.05,
    y2: 204.79
  }))), _g758 || (_g758 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-719",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 114,
    x2: 92.73,
    y2: 120.49
  }))), _g759 || (_g759 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-720",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 148.59,
    x2: 80.25,
    y2: 142.11
  }))), _g760 || (_g760 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-721",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.45,
    y1: 209.98,
    x2: 13.22,
    y2: 210.28
  }))), _g761 || (_g761 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-722",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.47,
    y1: 152,
    x2: 18.37,
    y2: 152.05
  }))), _g762 || (_g762 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-723",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.37,
    y1: 177.41,
    x2: 10.45,
    y2: 177.5
  }))), _g763 || (_g763 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-724",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.34,
    y1: 182.46,
    x2: 27.82,
    y2: 182.46
  }))), _g764 || (_g764 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-725",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 182.46,
    x2: 60.27,
    y2: 182.46
  }))), _g765 || (_g765 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-726",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 182.46,
    x2: 92.73,
    y2: 182.46
  }))), _g766 || (_g766 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-727",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 182.46,
    x2: 125.18,
    y2: 182.46
  }))), _g767 || (_g767 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-728",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 182.46,
    x2: 155.62,
    y2: 182.46
  }))), _g768 || (_g768 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-729",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.74,
    y1: 181.75,
    x2: 143.89,
    y2: 181.75
  }))), _g769 || (_g769 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-730",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 144.89,
    y1: 180.02,
    x2: 143.74,
    y2: 180.02
  }))), _g770 || (_g770 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-731",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.17,
    y1: 177.41,
    x2: 12.38,
    y2: 177.41
  }))), _g771 || (_g771 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-732",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.28,
    y1: 177.41,
    x2: 13.24,
    y2: 177.41
  }))), _g772 || (_g772 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-733",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.93,
    y1: 176.69,
    x2: 150.15,
    y2: 176.69
  }))), _g773 || (_g773 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-734",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 176.69,
    x2: 117.69,
    y2: 176.69
  }))), _g774 || (_g774 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-735",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 176.69,
    x2: 85.24,
    y2: 176.69
  }))), _g775 || (_g775 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-736",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 176.69,
    x2: 52.78,
    y2: 176.69
  }))), _g776 || (_g776 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-737",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 176.69,
    x2: 22.04,
    y2: 176.69
  }))), _g777 || (_g777 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-738",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.11,
    y1: 176.26,
    x2: 12.32,
    y2: 176.26
  }))), _g778 || (_g778 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-739",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.6,
    y1: 175.99,
    x2: 44.31,
    y2: 175.99
  }))), _g779 || (_g779 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-740",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 173.09,
    x2: 44.05,
    y2: 173.09
  }))), _g780 || (_g780 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-741",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 173.09,
    x2: 76.5,
    y2: 173.09
  }))), _g781 || (_g781 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-742",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 173.09,
    x2: 108.95,
    y2: 173.09
  }))), _g782 || (_g782 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-743",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 173.09,
    x2: 141.41,
    y2: 173.09
  }))), _g783 || (_g783 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-744",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 149.92,
    y1: 171.95,
    x2: 147.39,
    y2: 171.95
  }))), _g784 || (_g784 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-745",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 170.22,
    x2: 149.92,
    y2: 170.22
  }))), _g785 || (_g785 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-746",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 167.33,
    x2: 133.92,
    y2: 167.33
  }))), _g786 || (_g786 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-747",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 167.33,
    x2: 101.46,
    y2: 167.33
  }))), _g787 || (_g787 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-748",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 167.33,
    x2: 69.01,
    y2: 167.33
  }))), _g788 || (_g788 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-749",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 167.33,
    x2: 36.56,
    y2: 167.33
  }))), _g789 || (_g789 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-750",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.25,
    y1: 163.98,
    x2: 11.49,
    y2: 163.98
  }))), _g790 || (_g790 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-751",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.04,
    y1: 163.72,
    x2: 27.82,
    y2: 163.72
  }))), _g791 || (_g791 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-752",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 163.72,
    x2: 60.27,
    y2: 163.72
  }))), _g792 || (_g792 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-753",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 163.72,
    x2: 92.73,
    y2: 163.72
  }))), _g793 || (_g793 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-754",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 163.72,
    x2: 125.18,
    y2: 163.72
  }))), _g794 || (_g794 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-755",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 163.72,
    x2: 156.93,
    y2: 163.72
  }))), _g795 || (_g795 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-41",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.72 160.45 10.75 160.45 10.86 160.51 11.04 160.67 11.27 160.95"
  }))), _g796 || (_g796 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-756",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 134.19,
    y1: 236.5,
    x2: 138.83,
    y2: 242.26
  }))), _g797 || (_g797 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-757",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.01,
    y1: 257.4,
    x2: 157.84,
    y2: 265.89
  }))), _g798 || (_g798 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-758",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 104.64,
    x2: 36.56,
    y2: 111.12
  }))), _g799 || (_g799 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-759",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 132.74,
    x2: 52.78,
    y2: 139.22
  }))), _g800 || (_g800 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-760",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 223.53,
    x2: 97.72,
    y2: 217.04
  }))), _g801 || (_g801 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-761",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 195.43,
    x2: 81.49,
    y2: 188.94
  }))), _g802 || (_g802 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-762",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 167.33,
    x2: 66.45,
    y2: 162.88
  }))), _g803 || (_g803 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-763",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 279.73,
    x2: 130.17,
    y2: 273.25
  }))), _g804 || (_g804 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-764",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 251.63,
    x2: 113.95,
    y2: 245.15
  }))), _g805 || (_g805 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-765",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 307.83,
    x2: 146.4,
    y2: 301.35
  }))), _g806 || (_g806 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-766",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 151.47,
    x2: 60.27,
    y2: 144.99
  }))), _g807 || (_g807 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-767",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 123.37,
    x2: 44.05,
    y2: 116.89
  }))), _g808 || (_g808 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-768",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 173.09,
    x2: 80.25,
    y2: 179.58
  }))), _g809 || (_g809 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-769",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 201.19,
    x2: 96.47,
    y2: 207.68
  }))), _g810 || (_g810 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-770",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 229.29,
    x2: 112.7,
    y2: 235.78
  }))), _g811 || (_g811 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-771",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 257.4,
    x2: 128.92,
    y2: 263.88
  }))), _g812 || (_g812 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-772",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 285.5,
    x2: 145.15,
    y2: 291.98
  }))), _g813 || (_g813 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-773",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 114,
    x2: 52.78,
    y2: 120.49
  }))), _g814 || (_g814 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-774",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 142.11,
    x2: 69.01,
    y2: 148.59
  }))), _g815 || (_g815 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-775",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 204.79,
    x2: 97.72,
    y2: 198.31
  }))), _g816 || (_g816 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-776",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 176.69,
    x2: 81.49,
    y2: 170.21
  }))), _g817 || (_g817 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-777",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 261,
    x2: 130.17,
    y2: 254.51
  }))), _g818 || (_g818 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-778",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 232.9,
    x2: 113.95,
    y2: 226.41
  }))), _g819 || (_g819 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-779",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 289.1,
    x2: 146.4,
    y2: 282.61
  }))), _g820 || (_g820 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-780",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.08,
    y1: 68.18,
    x2: 24.08,
    y2: 66.45
  }))), _g821 || (_g821 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-781",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.91,
    y1: 65.01,
    x2: 39.31,
    y2: 89.94
  }))), _g822 || (_g822 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-782",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 98.15,
    x2: 51.12,
    y2: 110.4
  }))), _g823 || (_g823 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-783",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 132.74,
    x2: 60.27,
    y2: 126.25
  }))), _g824 || (_g824 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-784",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 182.46,
    x2: 96.47,
    y2: 188.94
  }))), _g825 || (_g825 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-785",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 210.56,
    x2: 112.7,
    y2: 217.04
  }))), _g826 || (_g826 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-786",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 238.66,
    x2: 128.92,
    y2: 245.15
  }))), _g827 || (_g827 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-787",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 266.76,
    x2: 145.15,
    y2: 273.25
  }))), _g828 || (_g828 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-788",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.12,
    y1: 108.67,
    x2: 41.3,
    y2: 89.94
  }))), _g829 || (_g829 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-789",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.3,
    y1: 88.21,
    x2: 26.91,
    y2: 65.01
  }))), _g830 || (_g830 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-790",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 123.37,
    x2: 69.01,
    y2: 129.86
  }))), _g831 || (_g831 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-791",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 186.06,
    x2: 97.72,
    y2: 179.58
  }))), _g832 || (_g832 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-792",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 242.26,
    x2: 130.17,
    y2: 235.78
  }))), _g833 || (_g833 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-793",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 214.16,
    x2: 113.95,
    y2: 207.68
  }))), _g834 || (_g834 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-794",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 270.37,
    x2: 146.4,
    y2: 263.88
  }))), _g835 || (_g835 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-795",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.49,
    y1: 49.54,
    x2: 87.4,
    y2: 48.66
  }))), _g836 || (_g836 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-796",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.48,
    y1: 43.1,
    x2: 87.4,
    y2: 42.1
  }))), _g837 || (_g837 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-797",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.44,
    y1: 38.8,
    x2: 87.4,
    y2: 38.33
  }))), _g838 || (_g838 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-798",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.67,
    y1: 134.84,
    x2: 87.69,
    y2: 158.16
  }))), _g839 || (_g839 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-799",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 119.95,
    x2: 90.28,
    y2: 130.19
  }))), _g840 || (_g840 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-800",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 130.19,
    x2: 90.28,
    y2: 134.84
  }))), _g841 || (_g841 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-801",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 139.22,
    x2: 85.24,
    y2: 126.25
  }))), _g842 || (_g842 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-802",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.24,
    y1: 120.49,
    x2: 85.24,
    y2: 107.52
  }))), _g843 || (_g843 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-803",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.69,
    y1: 97.67,
    x2: 87.69,
    y2: 134.84
  }))), _g844 || (_g844 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-804",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.26,
    y1: 158.84,
    x2: 88.26,
    y2: 97.29
  }))), _g845 || (_g845 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-805",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 89.7,
    y1: 158.84,
    x2: 89.7,
    y2: 97.29
  }))), _g846 || (_g846 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-806",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 115.66,
    x2: 90.28,
    y2: 119.95
  }))), _g847 || (_g847 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-807",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 97.67,
    x2: 90.28,
    y2: 105.96
  }))), _g848 || (_g848 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-808",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 134.84,
    x2: 90.29,
    y2: 158.16
  }))), _g849 || (_g849 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-809",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 139.22,
    x2: 92.73,
    y2: 126.25
  }))), _g850 || (_g850 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-810",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 120.49,
    x2: 92.73,
    y2: 107.52
  }))), _g851 || (_g851 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-811",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.21,
    y1: 95.76,
    x2: 98.21,
    y2: 40.85
  }))), _g852 || (_g852 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-812",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.07,
    y1: 95.08,
    x2: 99.07,
    y2: 41.35
  }))), _g853 || (_g853 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-813",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.51,
    y1: 2.76,
    x2: 100.51,
    y2: 29.36
  }))), _g854 || (_g854 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-814",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.51,
    y1: 93.42,
    x2: 100.51,
    y2: 42.79
  }))), _g855 || (_g855 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-42",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "87.69 97.67 87.69 100.53 87.69 113.37"
  }))), _g856 || (_g856 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-815",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.68,
    y1: 134.84,
    x2: 87.68,
    y2: 158.16
  }))), _g857 || (_g857 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-816",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.69,
    y1: 113.37,
    x2: 87.69,
    y2: 119.95
  }))), _g858 || (_g858 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-817",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 105.96,
    x2: 90.28,
    y2: 115.66
  }))), _g859 || (_g859 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-818",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 97.67,
    x2: 90.28,
    y2: 134.84
  }))), _g860 || (_g860 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-43",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "87.69 125.99 87.68 130.19 87.68 134.84"
  }))), _g861 || (_g861 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-819",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.69,
    y1: 119.95,
    x2: 87.68,
    y2: 125.99
  }))), _g862 || (_g862 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-820",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.29,
    y1: 134.84,
    x2: 90.28,
    y2: 158.16
  }))), _g863 || (_g863 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-821",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.53,
    y1: 38.8,
    x2: 90.56,
    y2: 38.33
  }))), _g864 || (_g864 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-822",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.48,
    y1: 43.1,
    x2: 90.56,
    y2: 42.1
  }))), _g865 || (_g865 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-823",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 235.78,
    x2: 36.56,
    y2: 229.29
  }))), _g866 || (_g866 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-824",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 207.68,
    x2: 52.78,
    y2: 201.19
  }))), _g867 || (_g867 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-825",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 179.58,
    x2: 69.01,
    y2: 173.09
  }))), _g868 || (_g868 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-826",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 123.37,
    x2: 101.46,
    y2: 116.89
  }))), _g869 || (_g869 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-827",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 245.15,
    x2: 27.82,
    y2: 251.63
  }))), _g870 || (_g870 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-828",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 188.94,
    x2: 60.27,
    y2: 195.43
  }))), _g871 || (_g871 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-829",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 217.04,
    x2: 44.05,
    y2: 223.53
  }))), _g872 || (_g872 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-830",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 104.64,
    x2: 108.95,
    y2: 111.12
  }))), _g873 || (_g873 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-831",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 132.74,
    x2: 92.73,
    y2: 139.22
  }))), _g874 || (_g874 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-832",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 78.94,
    y1: 163.1,
    x2: 76.5,
    y2: 167.33
  }))), _g875 || (_g875 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-833",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.53,
    y1: 277.52,
    x2: 20.33,
    y2: 276.13
  }))), _g876 || (_g876 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-834",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 254.51,
    x2: 36.56,
    y2: 248.03
  }))), _g877 || (_g877 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-835",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 226.41,
    x2: 52.78,
    y2: 219.93
  }))), _g878 || (_g878 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-836",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 198.31,
    x2: 69.01,
    y2: 191.82
  }))), _g879 || (_g879 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-837",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 170.21,
    x2: 85.24,
    y2: 163.72
  }))), _g880 || (_g880 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-838",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 142.11,
    x2: 101.46,
    y2: 135.62
  }))), _g881 || (_g881 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-839",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 114,
    x2: 117.69,
    y2: 107.52
  }))), _g882 || (_g882 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-840",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 263.88,
    x2: 27.82,
    y2: 270.37
  }))), _g883 || (_g883 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-841",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 207.68,
    x2: 60.27,
    y2: 214.16
  }))), _g884 || (_g884 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-842",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 235.78,
    x2: 44.05,
    y2: 242.26
  }))), _g885 || (_g885 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-843",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 123.37,
    x2: 108.95,
    y2: 129.86
  }))), _g886 || (_g886 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-844",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 179.58,
    x2: 76.5,
    y2: 186.06
  }))), _g887 || (_g887 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-44",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.22 210.28 12.99 210.47 12.79 210.55 12.67 210.56"
  }))), _g888 || (_g888 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-845",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.08,
    y1: 156.13,
    x2: 10.1,
    y2: 156.12
  }))), _g889 || (_g889 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-846",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.5,
    y1: 161.31,
    x2: 5.15,
    y2: 161.31
  }))), _g890 || (_g890 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-847",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.72,
    y1: 161.13,
    x2: 9.56,
    y2: 161.13
  }))), _g891 || (_g891 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-848",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.97,
    y1: 160.45,
    x2: 10.73,
    y2: 160.45
  }))), _g892 || (_g892 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-849",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.1,
    y1: 156.12,
    x2: 7.72,
    y2: 156.12
  }))), _g893 || (_g893 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-850",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.72,
    y1: 155.36,
    x2: 9.26,
    y2: 155.36
  }))), _g894 || (_g894 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-851",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.79,
    y1: 155.26,
    x2: 10.57,
    y2: 155.26
  }))), _g895 || (_g895 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-852",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.18,
    y1: 151.95,
    x2: 10.79,
    y2: 151.95
  }))), _g896 || (_g896 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-853",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.26,
    y1: 151.74,
    x2: 16.1,
    y2: 151.74
  }))), _g897 || (_g897 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-854",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 151.47,
    x2: 113.95,
    y2: 151.47
  }))), _g898 || (_g898 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-855",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 151.47,
    x2: 64.02,
    y2: 151.47
  }))), _g899 || (_g899 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-856",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.49,
    y1: 150.21,
    x2: 15.25,
    y2: 150.21
  }))), _g900 || (_g900 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-857",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 148.59,
    x2: 140.86,
    y2: 148.59
  }))), _g901 || (_g901 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-858",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.13,
    y1: 148.59,
    x2: 133.92,
    y2: 148.59
  }))), _g902 || (_g902 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-859",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 148.59,
    x2: 108.01,
    y2: 148.59
  }))), _g903 || (_g903 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-860",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 148.59,
    x2: 101.46,
    y2: 148.59
  }))), _g904 || (_g904 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-861",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 148.59,
    x2: 37.1,
    y2: 148.59
  }))), _g905 || (_g905 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-862",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.83,
    y1: 148.59,
    x2: 44.05,
    y2: 148.59
  }))), _g906 || (_g906 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-863",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 148.59,
    x2: 69.96,
    y2: 148.59
  }))), _g907 || (_g907 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-864",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 148.59,
    x2: 76.5,
    y2: 148.59
  }))), _g908 || (_g908 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-865",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.06,
    y1: 145.71,
    x2: 162.59,
    y2: 145.71
  }))), _g909 || (_g909 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-866",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.3,
    y1: 145.71,
    x2: 143.07,
    y2: 145.71
  }))), _g910 || (_g910 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-867",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.2,
    y1: 145.07,
    x2: 162.73,
    y2: 145.07
  }))), _g911 || (_g911 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-868",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 144.99,
    x2: 52.78,
    y2: 144.99
  }))), _g912 || (_g912 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-869",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 144.99,
    x2: 125.18,
    y2: 144.99
  }))), _g913 || (_g913 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-870",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.87,
    y1: 162.75,
    x2: 9.13,
    y2: 162.76
  }))), _g914 || (_g914 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-871",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.67,
    y1: 159.9,
    x2: 10.19,
    y2: 159.9
  }))), _g915 || (_g915 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-872",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.55,
    y1: 156.73,
    x2: 8.53,
    y2: 156.73
  }))), _g916 || (_g916 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-873",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.55,
    y1: 156.73,
    x2: 7.14,
    y2: 156.72
  }))), _g917 || (_g917 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-874",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.53,
    y1: 156.73,
    x2: 7.9,
    y2: 156.73
  }))), _g918 || (_g918 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-875",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.4,
    y1: 159.89,
    x2: 8.51,
    y2: 159.9
  }))), _g919 || (_g919 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-876",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.9,
    y1: 156.73,
    x2: 7.47,
    y2: 156.73
  }))), _g920 || (_g920 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-877",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.54,
    y1: 159.89,
    x2: 9.3,
    y2: 159.9
  }))), _g921 || (_g921 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-878",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.47,
    y1: 156.73,
    x2: 7.14,
    y2: 156.72
  }))), _g922 || (_g922 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-879",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.72,
    y1: 160.45,
    x2: 10.73,
    y2: 160.45
  }))), _g923 || (_g923 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-880",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 114,
    x2: 60.27,
    y2: 107.52
  }))), _g924 || (_g924 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-881",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 163.72,
    x2: 96.47,
    y2: 170.21
  }))), _g925 || (_g925 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-882",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 191.82,
    x2: 112.7,
    y2: 198.31
  }))), _g926 || (_g926 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-883",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 142.11,
    x2: 76.5,
    y2: 135.62
  }))), _g927 || (_g927 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-884",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 219.93,
    x2: 128.92,
    y2: 226.41
  }))), _g928 || (_g928 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-885",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 248.03,
    x2: 145.15,
    y2: 254.51
  }))), _g929 || (_g929 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-886",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 276.13,
    x2: 158.44,
    y2: 277.52
  }))), _g930 || (_g930 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-887",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 104.64,
    x2: 69.01,
    y2: 111.12
  }))), _g931 || (_g931 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-888",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 132.74,
    x2: 85.24,
    y2: 139.22
  }))), _g932 || (_g932 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-889",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 167.33,
    x2: 99.03,
    y2: 163.1
  }))), _g933 || (_g933 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-890",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 223.53,
    x2: 130.17,
    y2: 217.04
  }))), _g934 || (_g934 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-891",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 195.43,
    x2: 113.95,
    y2: 188.94
  }))), _g935 || (_g935 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-892",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 251.63,
    x2: 146.4,
    y2: 245.15
  }))), _g936 || (_g936 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-893",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 173.09,
    x2: 112.7,
    y2: 179.58
  }))), _g937 || (_g937 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-894",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 123.37,
    x2: 76.5,
    y2: 116.89
  }))), _g938 || (_g938 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-895",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 201.19,
    x2: 128.92,
    y2: 207.68
  }))), _g939 || (_g939 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-896",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 229.29,
    x2: 145.15,
    y2: 235.78
  }))), _g940 || (_g940 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-897",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 114,
    x2: 85.24,
    y2: 120.49
  }))), _g941 || (_g941 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-898",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 148.59,
    x2: 97.72,
    y2: 142.11
  }))), _g942 || (_g942 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-899",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 204.79,
    x2: 130.17,
    y2: 198.31
  }))), _g943 || (_g943 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-900",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 176.69,
    x2: 113.95,
    y2: 170.21
  }))), _g944 || (_g944 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-901",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 232.9,
    x2: 146.4,
    y2: 226.41
  }))), _g945 || (_g945 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-902",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.3,
    y1: 41.81,
    x2: 53.7,
    y2: 65.01
  }))), _g946 || (_g946 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-903",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.53,
    y1: 68.18,
    x2: 64.68,
    y2: 84.03
  }))), _g947 || (_g947 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-904",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.47,
    y1: 91.2,
    x2: 90.56,
    y2: 91.68
  }))), _g948 || (_g948 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-905",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.49,
    y1: 58.08,
    x2: 87.4,
    y2: 57.47
  }))), _g949 || (_g949 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-45",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "76.01 1 75.98 0.78 75.89 0.59 75.76 0.42 75.58 0.29 75.36 0.2 75.1 0.15 74.82 0.14 74.52 0.18 74.29 0.24"
  }))), _g950 || (_g950 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-906",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.3,
    y1: 41.46,
    x2: 86.14,
    y2: 40.29
  }))), _g951 || (_g951 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-907",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 39.88,
    x2: 86.02,
    y2: 38.66
  }))), _g952 || (_g952 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-908",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.18,
    y1: 38.91,
    x2: 86.02,
    y2: 37.7
  }))), _g953 || (_g953 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-909",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.21,
    y1: 38.9,
    x2: 86.14,
    y2: 38.39
  }))), _g954 || (_g954 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-910",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.3,
    y1: 39.02,
    x2: 86.14,
    y2: 37.77
  }))), _g955 || (_g955 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-911",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.23,
    y1: 197.59,
    x2: 101.23,
    y2: 192.22
  }))), _g956 || (_g956 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-912",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.23,
    y1: 185.66,
    x2: 101.23,
    y2: 173.49
  }))), _g957 || (_g957 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-913",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.23,
    y1: 166.93,
    x2: 101.23,
    y2: 163.08
  }))), _g958 || (_g958 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-914",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 88.64,
    x2: 101.95,
    y2: 1
  }))), _g959 || (_g959 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-915",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.83,
    y1: 160.14,
    x2: 104.83,
    y2: 158.69
  }))), _g960 || (_g960 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-916",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.83,
    y1: 148.59,
    x2: 104.83,
    y2: 135.62
  }))), _g961 || (_g961 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-917",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.83,
    y1: 129.86,
    x2: 104.83,
    y2: 116.89
  }))), _g962 || (_g962 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-918",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 204.79,
    x2: 106.28,
    y2: 191.82
  }))), _g963 || (_g963 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-919",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 186.06,
    x2: 106.28,
    y2: 173.09
  }))), _g964 || (_g964 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-920",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 167.33,
    x2: 106.28,
    y2: 162.99
  }))), _g965 || (_g965 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-921",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 160.11,
    x2: 106.28,
    y2: 158.67
  }))), _g966 || (_g966 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-922",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 148.59,
    x2: 106.28,
    y2: 135.62
  }))), _g967 || (_g967 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-923",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 129.86,
    x2: 106.28,
    y2: 116.89
  }))), _g968 || (_g968 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-924",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 111.12,
    x2: 106.28,
    y2: 97.76
  }))), _g969 || (_g969 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-925",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.01,
    y1: 96.51,
    x2: 108.01,
    y2: 111.12
  }))), _g970 || (_g970 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-926",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.01,
    y1: 116.89,
    x2: 108.01,
    y2: 129.86
  }))), _g971 || (_g971 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-927",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.01,
    y1: 135.62,
    x2: 108.01,
    y2: 148.59
  }))), _g972 || (_g972 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-928",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.89,
    y1: 82.76,
    x2: 108.89,
    y2: 4.34
  }))), _g973 || (_g973 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-929",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.62,
    y1: 4.97,
    x2: 110.62,
    y2: 82.3
  }))), _g974 || (_g974 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-930",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.89,
    y1: 201.44,
    x2: 110.89,
    y2: 195.18
  }))), _g975 || (_g975 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-931",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.75,
    y1: 68.9,
    x2: 102.75,
    y2: 68.61
  }))), _g976 || (_g976 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-932",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.75,
    y1: 68.61,
    x2: 102.75,
    y2: 67.89
  }))), _g977 || (_g977 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-933",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.75,
    y1: 68.61,
    x2: 102.75,
    y2: 67.89
  }))), _g978 || (_g978 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-934",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.74,
    y1: 76.54,
    x2: 102.74,
    y2: 76.07
  }))), _g979 || (_g979 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-935",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.72,
    y1: 85.18,
    x2: 102.72,
    y2: 84.17
  }))), _g980 || (_g980 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-936",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.72,
    y1: 85.18,
    x2: 102.72,
    y2: 84.86
  }))), _g981 || (_g981 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-937",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.72,
    y1: 84.86,
    x2: 102.72,
    y2: 84.17
  }))), _g982 || (_g982 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-938",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.85,
    y1: 108.67,
    x2: 136.66,
    y2: 89.94
  }))), _g983 || (_g983 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-939",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.66,
    y1: 88.21,
    x2: 151.06,
    y2: 65.01
  }))), _g984 || (_g984 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-940",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 273.25,
    x2: 36.56,
    y2: 266.76
  }))), _g985 || (_g985 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-941",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 245.15,
    x2: 52.78,
    y2: 238.66
  }))), _g986 || (_g986 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-942",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 217.04,
    x2: 69.01,
    y2: 210.56
  }))), _g987 || (_g987 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-943",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 188.94,
    x2: 85.24,
    y2: 182.46
  }))), _g988 || (_g988 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-944",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.05,
    y1: 65.01,
    x2: 138.66,
    y2: 89.94
  }))), _g989 || (_g989 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-945",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 98.15,
    x2: 126.84,
    y2: 110.4
  }))), _g990 || (_g990 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-946",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 132.74,
    x2: 117.69,
    y2: 126.25
  }))), _g991 || (_g991 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-947",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 152.89,
    y1: 68.18,
    x2: 153.89,
    y2: 66.45
  }))), _g992 || (_g992 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-948",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 282.61,
    x2: 27.82,
    y2: 289.1
  }))), _g993 || (_g993 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-949",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 226.41,
    x2: 60.27,
    y2: 232.9
  }))), _g994 || (_g994 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-950",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 254.51,
    x2: 44.05,
    y2: 261
  }))), _g995 || (_g995 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-951",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 142.11,
    x2: 108.95,
    y2: 148.59
  }))), _g996 || (_g996 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-952",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 170.21,
    x2: 92.73,
    y2: 176.69
  }))), _g997 || (_g997 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-953",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 198.31,
    x2: 76.5,
    y2: 204.79
  }))), _g998 || (_g998 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-954",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 114,
    x2: 125.18,
    y2: 120.49
  }))), _g999 || (_g999 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-955",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 291.98,
    x2: 36.56,
    y2: 285.5
  }))), _g1000 || (_g1000 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-956",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 263.88,
    x2: 52.78,
    y2: 257.4
  }))), _g1001 || (_g1001 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-957",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 235.78,
    x2: 69.01,
    y2: 229.29
  }))), _g1002 || (_g1002 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-958",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 207.68,
    x2: 85.24,
    y2: 201.19
  }))), _g1003 || (_g1003 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-959",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 179.58,
    x2: 101.46,
    y2: 173.09
  }))), _g1004 || (_g1004 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-960",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 151.47,
    x2: 117.69,
    y2: 144.99
  }))), _g1005 || (_g1005 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-961",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 123.37,
    x2: 133.92,
    y2: 116.89
  }))), _g1006 || (_g1006 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-962",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.56,
    y1: 301.35,
    x2: 27.82,
    y2: 307.83
  }))), _g1007 || (_g1007 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-963",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 245.15,
    x2: 60.27,
    y2: 251.63
  }))), _g1008 || (_g1008 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-964",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 273.25,
    x2: 44.05,
    y2: 279.73
  }))), _g1009 || (_g1009 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-965",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.52,
    y1: 162.88,
    x2: 108.95,
    y2: 167.33
  }))), _g1010 || (_g1010 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-966",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 188.94,
    x2: 92.73,
    y2: 195.43
  }))), _g1011 || (_g1011 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-967",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 217.04,
    x2: 76.5,
    y2: 223.53
  }))), _g1012 || (_g1012 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-968",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 104.64,
    x2: 141.41,
    y2: 111.12
  }))), _g1013 || (_g1013 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-969",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 132.74,
    x2: 125.18,
    y2: 139.22
  }))), _g1014 || (_g1014 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-970",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.12,
    y1: 265.89,
    x2: 26.96,
    y2: 257.4
  }))), _g1015 || (_g1015 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-971",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.13,
    y1: 242.26,
    x2: 42.61,
    y2: 237.94
  }))), _g1016 || (_g1016 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-972",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.27,
    y1: 134.84,
    x2: 9.39,
    y2: 134.84
  }))), _g1017 || (_g1017 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-973",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 139.22,
    x2: 150.15,
    y2: 139.22
  }))), _g1018 || (_g1018 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-974",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 139.22,
    x2: 117.69,
    y2: 139.22
  }))), _g1019 || (_g1019 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-975",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 139.22,
    x2: 27.82,
    y2: 139.22
  }))), _g1020 || (_g1020 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-976",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 139.22,
    x2: 60.27,
    y2: 139.22
  }))), _g1021 || (_g1021 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-977",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 135.62,
    x2: 71.69,
    y2: 135.62
  }))), _g1022 || (_g1022 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-978",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.96,
    y1: 135.62,
    x2: 69.01,
    y2: 135.62
  }))), _g1023 || (_g1023 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-979",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 135.62,
    x2: 38.83,
    y2: 135.62
  }))), _g1024 || (_g1024 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-980",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 135.62,
    x2: 36.56,
    y2: 135.62
  }))), _g1025 || (_g1025 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-981",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 135.62,
    x2: 106.28,
    y2: 135.62
  }))), _g1026 || (_g1026 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-982",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.01,
    y1: 135.62,
    x2: 108.95,
    y2: 135.62
  }))), _g1027 || (_g1027 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-983",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 135.62,
    x2: 139.13,
    y2: 135.62
  }))), _g1028 || (_g1028 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-984",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 135.62,
    x2: 141.41,
    y2: 135.62
  }))), _g1029 || (_g1029 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-985",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.23,
    y1: 134.82,
    x2: 11.73,
    y2: 134.82
  }))), _g1030 || (_g1030 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-986",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.13,
    y1: 134.82,
    x2: 7.81,
    y2: 134.82
  }))), _g1031 || (_g1031 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-987",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.71,
    y1: 134.35,
    x2: 8.7,
    y2: 134.35
  }))), _g1032 || (_g1032 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-988",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 129.86,
    x2: 140.86,
    y2: 129.86
  }))), _g1033 || (_g1033 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-989",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.13,
    y1: 129.86,
    x2: 133.92,
    y2: 129.86
  }))), _g1034 || (_g1034 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-990",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 129.86,
    x2: 108.01,
    y2: 129.86
  }))), _g1035 || (_g1035 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-991",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 129.86,
    x2: 101.46,
    y2: 129.86
  }))), _g1036 || (_g1036 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-992",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 129.86,
    x2: 37.1,
    y2: 129.86
  }))), _g1037 || (_g1037 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-993",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.83,
    y1: 129.86,
    x2: 44.05,
    y2: 129.86
  }))), _g1038 || (_g1038 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-994",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 129.86,
    x2: 69.96,
    y2: 129.86
  }))), _g1039 || (_g1039 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-995",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 129.86,
    x2: 76.5,
    y2: 129.86
  }))), _g1040 || (_g1040 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-996",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.9,
    y1: 126.97,
    x2: 35.66,
    y2: 126.97
  }))), _g1041 || (_g1041 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-997",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.27,
    y1: 126.25,
    x2: 52.78,
    y2: 126.25
  }))), _g1042 || (_g1042 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-998",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.82,
    y1: 126.25,
    x2: 20.33,
    y2: 126.25
  }))), _g1043 || (_g1043 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-999",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 126.25,
    x2: 125.18,
    y2: 126.25
  }))), _g1044 || (_g1044 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1000",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 126.25,
    x2: 157.63,
    y2: 126.25
  }))), _g1045 || (_g1045 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1001",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.39,
    y1: 134.84,
    x2: 10.69,
    y2: 134.84
  }))), _g1046 || (_g1046 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1002",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.68,
    y1: 82.3,
    x2: 56.53,
    y2: 66.45
  }))), _g1047 || (_g1047 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1003",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.7,
    y1: 65.01,
    x2: 41.17,
    y2: 39.84
  }))), _g1048 || (_g1048 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1004",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 126.25,
    x2: 96.47,
    y2: 132.74
  }))), _g1049 || (_g1049 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1005",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 182.46,
    x2: 128.92,
    y2: 188.94
  }))), _g1050 || (_g1050 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1006",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 210.56,
    x2: 145.15,
    y2: 217.04
  }))), _g1051 || (_g1051 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1007",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.7,
    y1: 55.78,
    x2: 55.7,
    y2: 59.24
  }))), _g1052 || (_g1052 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1008",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 129.86,
    x2: 97.72,
    y2: 123.37
  }))), _g1053 || (_g1053 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1009",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 186.06,
    x2: 130.17,
    y2: 179.58
  }))), _g1054 || (_g1054 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1010",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 214.16,
    x2: 146.4,
    y2: 207.68
  }))), _g1055 || (_g1055 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1011",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.7,
    y1: 47.71,
    x2: 53.7,
    y2: 44.26
  }))), _g1056 || (_g1056 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1012",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.73,
    y1: 107.52,
    x2: 96.47,
    y2: 114
  }))), _g1057 || (_g1057 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1013",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 135.62,
    x2: 112.7,
    y2: 142.11
  }))), _g1058 || (_g1058 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1014",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 163.72,
    x2: 128.92,
    y2: 170.21
  }))), _g1059 || (_g1059 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1015",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 191.82,
    x2: 145.15,
    y2: 198.31
  }))), _g1060 || (_g1060 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1016",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.7,
    y1: 38.49,
    x2: 55.7,
    y2: 41.95
  }))), _g1061 || (_g1061 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1017",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 111.12,
    x2: 97.34,
    y2: 103.97
  }))), _g1062 || (_g1062 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1018",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 167.33,
    x2: 130.98,
    y2: 162.24
  }))), _g1063 || (_g1063 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1019",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 139.22,
    x2: 113.95,
    y2: 132.74
  }))), _g1064 || (_g1064 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1020",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 195.43,
    x2: 146.4,
    y2: 188.94
  }))), _g1065 || (_g1065 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1021",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 94.13,
    x2: 93.2,
    y2: 94.73
  }))), _g1066 || (_g1066 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1022",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 95.84,
    x2: 93.2,
    y2: 96.5
  }))), _g1067 || (_g1067 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1023",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 90.24,
    x2: 91.95,
    y2: 90.69
  }))), _g1068 || (_g1068 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1024",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.89,
    y1: 41.38,
    x2: 81.64,
    y2: 40.71
  }))), _g1069 || (_g1069 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1025",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.7,
    y1: 38.68,
    x2: 81.64,
    y2: 38.52
  }))), _g1070 || (_g1070 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1026",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.49,
    y1: 68.11,
    x2: 87.4,
    y2: 67.83
  }))), _g1071 || (_g1071 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1027",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 53.77,
    x2: 84.76,
    y2: 52.99
  }))), _g1072 || (_g1072 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1028",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 59.01,
    x2: 86.02,
    y2: 58.43
  }))), _g1073 || (_g1073 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1029",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.66,
    y1: 95.09,
    x2: 91.82,
    y2: 95.71
  }))), _g1074 || (_g1074 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1030",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 46.32,
    x2: 84.76,
    y2: 45.28
  }))), _g1075 || (_g1075 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1031",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.3,
    y1: 54.44,
    x2: 86.14,
    y2: 53.7
  }))), _g1076 || (_g1076 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1032",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.97,
    y1: 41.11,
    x2: 84.76,
    y2: 40.1
  }))), _g1077 || (_g1077 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1033",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.79,
    y1: 38.04,
    x2: 84.76,
    y2: 37.87
  }))), _g1078 || (_g1078 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1034",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 50.34,
    x2: 86.02,
    y2: 49.46
  }))), _g1079 || (_g1079 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1035",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.3,
    y1: 46.74,
    x2: 86.14,
    y2: 45.75
  }))), _g1080 || (_g1080 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1036",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 43.78,
    x2: 86.02,
    y2: 42.69
  }))), _g1081 || (_g1081 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1037",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.27,
    y1: 59.24,
    x2: 122.27,
    y2: 47.71
  }))), _g1082 || (_g1082 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1038",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.27,
    y1: 41.95,
    x2: 122.27,
    y2: 9.49
  }))), _g1083 || (_g1083 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1039",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 124.27,
    y1: 10.28,
    x2: 124.27,
    y2: 38.49
  }))), _g1084 || (_g1084 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1040",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 124.27,
    y1: 44.26,
    x2: 124.27,
    y2: 55.78
  }))), _g1085 || (_g1085 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1041",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.77,
    y1: 180.62,
    x2: 130.77,
    y2: 178.53
  }))), _g1086 || (_g1086 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1042",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 131.06,
    y1: 199.85,
    x2: 131.06,
    y2: 196.77
  }))), _g1087 || (_g1087 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1043",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 132.79,
    y1: 182.17,
    x2: 132.79,
    y2: 175.04
  }))), _g1088 || (_g1088 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1044",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.1,
    y1: 248.03,
    x2: 135.1,
    y2: 261
  }))), _g1089 || (_g1089 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1045",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.1,
    y1: 266.76,
    x2: 135.1,
    y2: 279.73
  }))), _g1090 || (_g1090 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1046",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.25,
    y1: 191.82,
    x2: 136.25,
    y2: 204.79
  }))), _g1091 || (_g1091 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1047",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.8,
    y1: 39.84,
    x2: 136.8,
    y2: 15.14
  }))), _g1092 || (_g1092 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1048",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.53,
    y1: 15.78,
    x2: 138.53,
    y2: 39.84
  }))), _g1093 || (_g1093 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1049",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.13,
    y1: 148.59,
    x2: 139.13,
    y2: 135.62
  }))), _g1094 || (_g1094 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1050",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.13,
    y1: 129.86,
    x2: 139.13,
    y2: 116.89
  }))), _g1095 || (_g1095 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1051",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.04,
    y1: 82.3,
    x2: 162.04,
    y2: 84.03
  }))), _g1096 || (_g1096 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1052",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.82,
    y1: 310.72,
    x2: 36.56,
    y2: 304.23
  }))), _g1097 || (_g1097 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1053",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 282.61,
    x2: 52.78,
    y2: 276.13
  }))), _g1098 || (_g1098 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1054",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 254.51,
    x2: 69.01,
    y2: 248.03
  }))), _g1099 || (_g1099 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1055",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 226.41,
    x2: 85.24,
    y2: 219.93
  }))), _g1100 || (_g1100 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1056",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 198.31,
    x2: 101.46,
    y2: 191.82
  }))), _g1101 || (_g1101 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1057",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 170.21,
    x2: 117.69,
    y2: 163.72
  }))), _g1102 || (_g1102 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1058",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 142.11,
    x2: 133.92,
    y2: 135.62
  }))), _g1103 || (_g1103 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1059",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 114,
    x2: 164.71,
    y2: 82.3
  }))), _g1104 || (_g1104 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1060",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.43,
    y1: 82.76,
    x2: 152.14,
    y2: 107.52
  }))), _g1105 || (_g1105 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1061",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 263.88,
    x2: 60.27,
    y2: 270.37
  }))), _g1106 || (_g1106 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1062",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 291.98,
    x2: 44.05,
    y2: 298.47
  }))), _g1107 || (_g1107 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1063",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 179.58,
    x2: 108.95,
    y2: 186.06
  }))), _g1108 || (_g1108 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1064",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 207.68,
    x2: 92.73,
    y2: 214.16
  }))), _g1109 || (_g1109 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1065",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 235.78,
    x2: 76.5,
    y2: 242.26
  }))), _g1110 || (_g1110 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1066",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 123.37,
    x2: 141.41,
    y2: 129.86
  }))), _g1111 || (_g1111 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1067",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.53,
    y1: 308.64,
    x2: 39.39,
    y2: 308.89
  }))), _g1112 || (_g1112 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1068",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 301.35,
    x2: 52.78,
    y2: 294.86
  }))), _g1113 || (_g1113 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1069",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 273.25,
    x2: 69.01,
    y2: 266.76
  }))), _g1114 || (_g1114 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1070",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 245.15,
    x2: 85.24,
    y2: 238.66
  }))), _g1115 || (_g1115 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1071",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 217.04,
    x2: 101.46,
    y2: 210.56
  }))), _g1116 || (_g1116 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1072",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 188.94,
    x2: 117.69,
    y2: 182.46
  }))), _g1117 || (_g1117 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1073",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 132.74,
    x2: 150.15,
    y2: 126.25
  }))), _g1118 || (_g1118 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1074",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.17,
    y1: 301.91,
    x2: 50.27,
    y2: 303.48
  }))), _g1119 || (_g1119 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1075",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 282.61,
    x2: 60.27,
    y2: 289.1
  }))), _g1120 || (_g1120 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1076",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.79,
    y1: 310.72,
    x2: 44.05,
    y2: 317.2
  }))), _g1121 || (_g1121 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1077",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 198.31,
    x2: 108.95,
    y2: 204.79
  }))), _g1122 || (_g1122 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1078",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 226.41,
    x2: 92.73,
    y2: 232.9
  }))), _g1123 || (_g1123 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1079",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 254.51,
    x2: 76.5,
    y2: 261
  }))), _g1124 || (_g1124 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1080",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 142.11,
    x2: 141.41,
    y2: 148.59
  }))), _g1125 || (_g1125 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1081",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 170.21,
    x2: 125.18,
    y2: 176.69
  }))), _g1126 || (_g1126 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1082",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 161.38,
    y1: 114,
    x2: 157.63,
    y2: 120.49
  }))), _g1127 || (_g1127 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1083",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.63,
    y1: 238.66,
    x2: 52.26,
    y2: 241.6
  }))), _g1128 || (_g1128 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1084",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.87,
    y1: 253.28,
    x2: 36.66,
    y2: 261
  }))), _g1129 || (_g1129 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1085",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.88,
    y1: 261,
    x2: 42.87,
    y2: 256.04
  }))), _g1130 || (_g1130 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1086",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.48,
    y1: 241.6,
    x2: 56.85,
    y2: 238.66
  }))), _g1131 || (_g1131 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1087",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.16,
    y1: 110.77,
    x2: 4,
    y2: 110.83
  }))), _g1132 || (_g1132 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1088",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.99,
    y1: 122.65,
    x2: 38.83,
    y2: 122.65
  }))), _g1133 || (_g1133 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1089",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 122.65,
    x2: 35.66,
    y2: 122.65
  }))), _g1134 || (_g1134 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1090",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 120.49,
    x2: 150.15,
    y2: 120.49
  }))), _g1135 || (_g1135 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1091",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 120.49,
    x2: 117.69,
    y2: 120.49
  }))), _g1136 || (_g1136 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1092",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 120.49,
    x2: 27.82,
    y2: 120.49
  }))), _g1137 || (_g1137 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1093",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 120.49,
    x2: 60.27,
    y2: 120.49
  }))), _g1138 || (_g1138 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1094",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.5,
    y1: 116.89,
    x2: 71.69,
    y2: 116.89
  }))), _g1139 || (_g1139 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1095",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.96,
    y1: 116.89,
    x2: 69.01,
    y2: 116.89
  }))), _g1140 || (_g1140 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1096",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.05,
    y1: 116.89,
    x2: 38.83,
    y2: 116.89
  }))), _g1141 || (_g1141 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1097",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.1,
    y1: 116.89,
    x2: 36.56,
    y2: 116.89
  }))), _g1142 || (_g1142 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1098",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.46,
    y1: 116.89,
    x2: 106.28,
    y2: 116.89
  }))), _g1143 || (_g1143 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1099",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.01,
    y1: 116.89,
    x2: 108.95,
    y2: 116.89
  }))), _g1144 || (_g1144 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1100",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 116.89,
    x2: 139.13,
    y2: 116.89
  }))), _g1145 || (_g1145 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1101",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 116.89,
    x2: 141.41,
    y2: 116.89
  }))), _g1146 || (_g1146 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1102",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.67,
    y1: 114.67,
    x2: 5.54,
    y2: 114.67
  }))), _g1147 || (_g1147 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1103",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.61,
    y1: 114.09,
    x2: 6.2,
    y2: 114.09
  }))), _g1148 || (_g1148 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1104",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 111.12,
    x2: 133.92,
    y2: 111.12
  }))), _g1149 || (_g1149 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1105",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 111.12,
    x2: 108.01,
    y2: 111.12
  }))), _g1150 || (_g1150 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1106",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.28,
    y1: 111.12,
    x2: 101.46,
    y2: 111.12
  }))), _g1151 || (_g1151 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1107",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 111.12,
    x2: 44.05,
    y2: 111.12
  }))), _g1152 || (_g1152 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1108",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.01,
    y1: 111.12,
    x2: 69.96,
    y2: 111.12
  }))), _g1153 || (_g1153 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1109",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.69,
    y1: 111.12,
    x2: 76.5,
    y2: 111.12
  }))), _g1154 || (_g1154 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1110",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.23,
    y1: 110.77,
    x2: 5.16,
    y2: 110.77
  }))), _g1155 || (_g1155 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1111",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.72,
    y1: 107.57,
    x2: 4.87,
    y2: 107.57
  }))), _g1156 || (_g1156 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1112",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 107.52,
    x2: 27.82,
    y2: 107.52
  }))), _g1157 || (_g1157 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1113",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.78,
    y1: 107.52,
    x2: 60.27,
    y2: 107.52
  }))), _g1158 || (_g1158 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1114",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 107.52,
    x2: 125.18,
    y2: 107.52
  }))), _g1159 || (_g1159 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1115",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 107.52,
    x2: 157.63,
    y2: 107.52
  }))), _g1160 || (_g1160 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1116",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 84.1,
    x2: 93.2,
    y2: 84.36
  }))), _g1161 || (_g1161 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1117",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 86.02,
    x2: 93.2,
    y2: 86.34
  }))), _g1162 || (_g1162 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1118",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 69.11,
    x2: 86.02,
    y2: 68.86
  }))), _g1163 || (_g1163 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1119",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.83,
    y1: 95.44,
    x2: 96.32,
    y2: 96.17
  }))), _g1164 || (_g1164 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1120",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.47,
    y1: 80.8,
    x2: 90.56,
    y2: 80.94
  }))), _g1165 || (_g1165 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1121",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 64.93,
    x2: 84.76,
    y2: 64.53
  }))), _g1166 || (_g1166 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1122",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.95,
    y1: 116.89,
    x2: 112.7,
    y2: 123.37
  }))), _g1167 || (_g1167 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1123",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 144.99,
    x2: 128.92,
    y2: 151.47
  }))), _g1168 || (_g1168 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1124",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 173.09,
    x2: 145.15,
    y2: 179.58
  }))), _g1169 || (_g1169 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1125",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 148.59,
    x2: 130.17,
    y2: 142.11
  }))), _g1170 || (_g1170 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1126",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.69,
    y1: 120.49,
    x2: 113.95,
    y2: 114
  }))), _g1171 || (_g1171 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1127",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 176.69,
    x2: 146.4,
    y2: 170.21
  }))), _g1172 || (_g1172 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1128",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.01,
    y1: 96.51,
    x2: 112.7,
    y2: 104.64
  }))), _g1173 || (_g1173 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1129",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.18,
    y1: 126.25,
    x2: 128.92,
    y2: 132.74
  }))), _g1174 || (_g1174 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1130",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 129.86,
    x2: 130.17,
    y2: 123.37
  }))), _g1175 || (_g1175 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1131",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 123.18,
    y1: 107.52,
    x2: 108.89,
    y2: 82.76
  }))), _g1176 || (_g1176 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1132",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.13,
    y1: 54.24,
    x2: 81.64,
    y2: 53.39
  }))), _g1177 || (_g1177 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1133",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 63.07,
    x2: 84.76,
    y2: 62.61
  }))), _g1178 || (_g1178 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1134",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.01,
    y1: 44.99,
    x2: 80.41,
    y2: 43.71
  }))), _g1179 || (_g1179 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1135",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.13,
    y1: 46.94,
    x2: 81.64,
    y2: 45.8
  }))), _g1180 || (_g1180 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1136",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.01,
    y1: 41.24,
    x2: 80.41,
    y2: 39.81
  }))), _g1181 || (_g1181 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1137",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.67,
    y1: 39.52,
    x2: 80.41,
    y2: 38.87
  }))), _g1182 || (_g1182 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1138",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.96,
    y1: 277.68,
    x2: 164.96,
    y2: 277.56
  }))), _g1183 || (_g1183 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1139",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 116.89,
    x2: 140.86,
    y2: 129.86
  }))), _g1184 || (_g1184 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1140",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 135.62,
    x2: 140.86,
    y2: 148.59
  }))), _g1185 || (_g1185 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1141",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 157.49,
    x2: 140.86,
    y2: 158.93
  }))), _g1186 || (_g1186 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1142",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 161.81,
    x2: 140.86,
    y2: 167.33
  }))), _g1187 || (_g1187 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1143",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 173.09,
    x2: 140.86,
    y2: 186.06
  }))), _g1188 || (_g1188 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1144",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.86,
    y1: 191.82,
    x2: 140.86,
    y2: 204.79
  }))), _g1189 || (_g1189 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1145",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.3,
    y1: 118.44,
    x2: 142.3,
    y2: 128.3
  }))), _g1190 || (_g1190 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1146",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.3,
    y1: 137.18,
    x2: 142.3,
    y2: 145.71
  }))), _g1191 || (_g1191 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1147",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.74,
    y1: 236.5,
    x2: 143.74,
    y2: 233.35
  }))), _g1192 || (_g1192 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1148",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.74,
    y1: 200.74,
    x2: 143.74,
    y2: 195.88
  }))), _g1193 || (_g1193 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1149",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.74,
    y1: 182.01,
    x2: 143.74,
    y2: 177.14
  }))), _g1194 || (_g1194 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1150",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.74,
    y1: 163.27,
    x2: 143.74,
    y2: 161.68
  }))), _g1195 || (_g1195 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1151",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.74,
    y1: 158.79,
    x2: 143.74,
    y2: 157.35
  }))), _g1196 || (_g1196 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1152",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 147.39,
    y1: 171.95,
    x2: 147.39,
    y2: 170.22
  }))), _g1197 || (_g1197 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1153",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 148.83,
    y1: 171.95,
    x2: 148.83,
    y2: 170.22
  }))), _g1198 || (_g1198 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1154",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 149.92,
    y1: 171.95,
    x2: 149.92,
    y2: 170.22
  }))), _g1199 || (_g1199 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1155",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.06,
    y1: 55.78,
    x2: 151.06,
    y2: 44.26
  }))), _g1200 || (_g1200 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1156",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.06,
    y1: 38.49,
    x2: 151.06,
    y2: 20.1
  }))), _g1201 || (_g1201 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1157",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.59,
    y1: 279.02,
    x2: 152.59,
    y2: 276.13
  }))), _g1202 || (_g1202 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1158",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.05,
    y1: 20.74,
    x2: 153.05,
    y2: 41.95
  }))), _g1203 || (_g1203 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1159",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.05,
    y1: 47.71,
    x2: 153.05,
    y2: 59.24
  }))), _g1204 || (_g1204 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1160",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 126.25,
    x2: 157.63,
    y2: 139.22
  }))), _g1205 || (_g1205 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1161",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.48,
    y1: 299.24,
    x2: 59.93,
    y2: 300.18
  }))), _g1206 || (_g1206 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1162",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.04,
    y1: 320.08,
    x2: 52.78,
    y2: 313.6
  }))), _g1207 || (_g1207 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1163",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 291.98,
    x2: 69.01,
    y2: 285.5
  }))), _g1208 || (_g1208 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1164",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 263.88,
    x2: 85.24,
    y2: 257.4
  }))), _g1209 || (_g1209 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1165",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 235.78,
    x2: 101.46,
    y2: 229.29
  }))), _g1210 || (_g1210 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1166",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 207.68,
    x2: 117.69,
    y2: 201.19
  }))), _g1211 || (_g1211 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1167",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 179.58,
    x2: 133.92,
    y2: 173.09
  }))), _g1212 || (_g1212 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1168",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.29,
    y1: 307.83,
    x2: 59.82,
    y2: 306.91
  }))), _g1213 || (_g1213 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1169",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 301.35,
    x2: 60.27,
    y2: 307.83
  }))), _g1214 || (_g1214 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1170",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 217.04,
    x2: 108.95,
    y2: 223.53
  }))), _g1215 || (_g1215 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1171",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 245.15,
    x2: 92.73,
    y2: 251.63
  }))), _g1216 || (_g1216 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1172",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 273.25,
    x2: 76.5,
    y2: 279.73
  }))), _g1217 || (_g1217 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1173",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 144.69,
    y1: 161.63,
    x2: 141.41,
    y2: 167.33
  }))), _g1218 || (_g1218 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1174",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 188.94,
    x2: 125.18,
    y2: 195.43
  }))), _g1219 || (_g1219 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1175",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 310.72,
    x2: 69.01,
    y2: 304.23
  }))), _g1220 || (_g1220 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1176",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 282.61,
    x2: 85.24,
    y2: 276.13
  }))), _g1221 || (_g1221 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1177",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 254.51,
    x2: 101.46,
    y2: 248.03
  }))), _g1222 || (_g1222 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1178",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 226.41,
    x2: 117.69,
    y2: 219.93
  }))), _g1223 || (_g1223 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1179",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 198.31,
    x2: 133.92,
    y2: 191.82
  }))), _g1224 || (_g1224 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1180",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 170.21,
    x2: 150.15,
    y2: 163.72
  }))), _g1225 || (_g1225 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1181",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.4,
    y1: 321.07,
    x2: 59.82,
    y2: 320.35
  }))), _g1226 || (_g1226 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1182",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.58,
    y1: 305.18,
    x2: 69.1,
    y2: 304.28
  }))), _g1227 || (_g1227 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1183",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.12,
    y1: 304.23,
    x2: 71.58,
    y2: 306.91
  }))), _g1228 || (_g1228 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1184",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.02,
    y1: 320.08,
    x2: 60.27,
    y2: 326.57
  }))), _g1229 || (_g1229 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1185",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 235.78,
    x2: 108.95,
    y2: 242.26
  }))), _g1230 || (_g1230 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1186",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 263.88,
    x2: 92.73,
    y2: 270.37
  }))), _g1231 || (_g1231 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1187",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 291.98,
    x2: 76.5,
    y2: 298.47
  }))), _g1232 || (_g1232 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1188",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 179.58,
    x2: 141.41,
    y2: 186.06
  }))), _g1233 || (_g1233 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1189",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 207.68,
    x2: 125.18,
    y2: 214.16
  }))), _g1234 || (_g1234 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1190",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.4,
    y1: 317.2,
    x2: 71.46,
    y2: 313.63
  }))), _g1235 || (_g1235 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1191",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.72,
    y1: 107.57,
    x2: 4.07,
    y2: 107.71
  }))), _g1236 || (_g1236 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1192",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.72,
    y1: 107.57,
    x2: 4.72,
    y2: 107.57
  }))), _g1237 || (_g1237 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1193",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 98.15,
    x2: 133.92,
    y2: 98.15
  }))), _g1238 || (_g1238 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1194",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.56,
    y1: 98.15,
    x2: 44.05,
    y2: 98.15
  }))), _g1239 || (_g1239 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1195",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.26,
    y1: 97.29,
    x2: 84.66,
    y2: 97.29
  }))), _g1240 || (_g1240 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1196",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 89.7,
    y1: 97.29,
    x2: 93.31,
    y2: 97.29
  }))), _g1241 || (_g1241 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1197",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 85.18,
    x2: 100.51,
    y2: 85.18
  }))), _g1242 || (_g1242 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1198",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 85.18,
    x2: 76.01,
    y2: 85.18
  }))), _g1243 || (_g1243 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1199",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 73.46,
    x2: 84.76,
    y2: 73.36
  }))), _g1244 || (_g1244 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1200",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 79.8,
    x2: 91.95,
    y2: 79.91
  }))), _g1245 || (_g1245 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1201",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.83,
    y1: 85.82,
    x2: 96.32,
    y2: 86.18
  }))), _g1246 || (_g1246 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1202",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.13,
    y1: 63.35,
    x2: 81.64,
    y2: 62.84
  }))), _g1247 || (_g1247 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1203",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.43,
    y1: 43.09,
    x2: 87.44,
    y2: 43.11
  }))), _g1248 || (_g1248 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1204",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.43,
    y1: 43.09,
    x2: 87.44,
    y2: 43.11
  }))), _g1249 || (_g1249 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1205",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 135.62,
    x2: 145.15,
    y2: 142.11
  }))), _g1250 || (_g1250 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1206",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 114,
    x2: 110.62,
    y2: 82.3
  }))), _g1251 || (_g1251 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1207",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.28,
    y1: 84.03,
    x2: 112.28,
    y2: 82.3
  }))), _g1252 || (_g1252 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1208",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.92,
    y1: 111.12,
    x2: 130.17,
    y2: 104.64
  }))), _g1253 || (_g1253 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1209",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 139.22,
    x2: 146.4,
    y2: 132.74
  }))), _g1254 || (_g1254 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1210",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.41,
    y1: 116.89,
    x2: 145.15,
    y2: 123.37
  }))), _g1255 || (_g1255 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1211",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.15,
    y1: 120.49,
    x2: 146.4,
    y2: 114
  }))), _g1256 || (_g1256 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1212",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.44,
    y1: 66.45,
    x2: 122.43,
    y2: 68.18
  }))), _g1257 || (_g1257 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1213",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 148.48,
    y1: 110.41,
    x2: 141.41,
    y2: 98.15
  }))), _g1258 || (_g1258 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1214",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.66,
    y1: 89.94,
    x2: 122.27,
    y2: 65.01
  }))), _g1259 || (_g1259 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1215",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.71,
    y1: 217.76,
    x2: 167.18,
    y2: 214.9
  }))), _g1260 || (_g1260 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1216",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.7,
    y1: 217.77,
    x2: 167.18,
    y2: 214.9
  }))), _g1261 || (_g1261 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1217",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.37,
    y1: 217.76,
    x2: 167.44,
    y2: 218.13
  }))), _g1262 || (_g1262 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1218",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.37,
    y1: 217.76,
    x2: 167.44,
    y2: 218.13
  }))), _g1263 || (_g1263 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1219",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.94,
    y1: 220.94,
    x2: 168.11,
    y2: 221.85
  }))), _g1264 || (_g1264 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1220",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.94,
    y1: 220.94,
    x2: 168.11,
    y2: 221.86
  }))), _g1265 || (_g1265 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1221",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.8,
    y1: 223.96,
    x2: 162.73,
    y2: 223.53
  }))), _g1266 || (_g1266 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1222",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.95,
    y1: 224.4,
    x2: 171.72,
    y2: 222.85
  }))), _g1267 || (_g1267 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1223",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.08,
    y1: 225.26,
    x2: 171.95,
    y2: 224.4
  }))), _g1268 || (_g1268 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1224",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.15,
    y1: 211.66,
    x2: 168.12,
    y2: 211.41
  }))), _g1269 || (_g1269 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1225",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.15,
    y1: 211.66,
    x2: 168.12,
    y2: 211.41
  }))), _g1270 || (_g1270 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-46",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "176.93 236.5 176.8 235.18 176.46 232.18"
  }))), _g1271 || (_g1271 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1226",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.09,
    y1: 242.9,
    x2: 171.11,
    y2: 243.09
  }))), _g1272 || (_g1272 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1227",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.93,
    y1: 236.5,
    x2: 177.07,
    y2: 237.86
  }))), _g1273 || (_g1273 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1228",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.09,
    y1: 242.9,
    x2: 171.11,
    y2: 243.09
  }))), _g1274 || (_g1274 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-47",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "172.26 195.09 171.73 187.07 171.23 176.28"
  }))), _g1275 || (_g1275 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1229",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.64,
    y1: 245.62,
    x2: 177.63,
    y2: 245.37
  }))), _g1276 || (_g1276 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1230",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.63,
    y1: 245.37,
    x2: 177.64,
    y2: 245.62
  }))), _g1277 || (_g1277 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1231",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.82,
    y1: 251.56,
    x2: 177.64,
    y2: 245.62
  }))), _g1278 || (_g1278 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-48",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "171.23 176.28 171.12 172 171.04 165.43 171.09 159.32 171.23 153.43 171.42 147.56 171.64 141.58 171.88 135.39 172.16 128.79 172.5 121.52 172.88 114.65"
  }))), _g1279 || (_g1279 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1232",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 164.7,
    y1: 50.93,
    x2: 164.7,
    y2: 50.6
  }))), _g1280 || (_g1280 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1233",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 164.7,
    y1: 50.93,
    x2: 164.7,
    y2: 50.6
  }))), _g1281 || (_g1281 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1234",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.68,
    y1: 225.26,
    x2: 162.68,
    y2: 224.97
  }))), _g1282 || (_g1282 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1235",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.7,
    y1: 82.3,
    x2: 164.7,
    y2: 25.23
  }))), _g1283 || (_g1283 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1236",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.43,
    y1: 26.4,
    x2: 166.43,
    y2: 82.76
  }))), _g1284 || (_g1284 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1237",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.93,
    y1: 146.34,
    x2: 163.95,
    y2: 145.71
  }))), _g1285 || (_g1285 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1238",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.93,
    y1: 146.34,
    x2: 163.95,
    y2: 145.71
  }))), _g1286 || (_g1286 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-49",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "172.88 114.65 173.08 111.42 173.41 106.49 173.76 101.55 174.11 96.53 174.45 91.38 174.66 87.88"
  }))), _g1287 || (_g1287 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1239",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.88,
    y1: 114.65,
    x2: 172.88,
    y2: 114.65
  }))), _g1288 || (_g1288 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1240",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 167.26,
    y1: 134.94,
    x2: 167.28,
    y2: 134.84
  }))), _g1289 || (_g1289 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1241",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 164.74,
    y1: 134.06,
    x2: 164.58,
    y2: 134.92
  }))), _g1290 || (_g1290 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1242",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 164.66,
    y1: 134.46,
    x2: 164.6,
    y2: 134.84
  }))), _g1291 || (_g1291 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1243",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 162.61,
    y1: 144.82,
    x2: 162.45,
    y2: 145.6
  }))), _g1292 || (_g1292 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1244",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.27,
    y1: 329.45,
    x2: 69.01,
    y2: 322.97
  }))), _g1293 || (_g1293 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1245",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 301.35,
    x2: 85.24,
    y2: 294.86
  }))), _g1294 || (_g1294 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1246",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 273.25,
    x2: 101.46,
    y2: 266.76
  }))), _g1295 || (_g1295 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1247",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 245.15,
    x2: 117.69,
    y2: 238.66
  }))), _g1296 || (_g1296 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1248",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 217.04,
    x2: 133.92,
    y2: 210.56
  }))), _g1297 || (_g1297 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1249",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 188.94,
    x2: 150.15,
    y2: 182.46
  }))), _g1298 || (_g1298 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1250",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.76,
    y1: 299.24,
    x2: 83.22,
    y2: 300.18
  }))), _g1299 || (_g1299 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1251",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.46,
    y1: 315.36,
    x2: 73.39,
    y2: 317.2
  }))), _g1300 || (_g1300 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1252",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 254.51,
    x2: 108.95,
    y2: 261
  }))), _g1301 || (_g1301 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1253",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 282.61,
    x2: 92.73,
    y2: 289.1
  }))), _g1302 || (_g1302 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1254",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 310.72,
    x2: 76.5,
    y2: 317.2
  }))), _g1303 || (_g1303 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1255",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 198.31,
    x2: 141.41,
    y2: 204.79
  }))), _g1304 || (_g1304 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1256",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 226.41,
    x2: 125.18,
    y2: 232.9
  }))), _g1305 || (_g1305 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1257",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 320.08,
    x2: 85.24,
    y2: 313.6
  }))), _g1306 || (_g1306 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1258",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 291.98,
    x2: 101.46,
    y2: 285.5
  }))), _g1307 || (_g1307 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1259",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 263.88,
    x2: 117.69,
    y2: 257.4
  }))), _g1308 || (_g1308 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1260",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 235.78,
    x2: 133.92,
    y2: 229.29
  }))), _g1309 || (_g1309 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1261",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 207.68,
    x2: 150.15,
    y2: 201.19
  }))), _g1310 || (_g1310 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1262",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.75,
    y1: 300.18,
    x2: 91.86,
    y2: 305.18
  }))), _g1311 || (_g1311 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1263",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 273.25,
    x2: 108.95,
    y2: 279.73
  }))), _g1312 || (_g1312 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1264",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 301.35,
    x2: 92.73,
    y2: 307.83
  }))), _g1313 || (_g1313 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1265",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.25,
    y1: 329.45,
    x2: 76.5,
    y2: 335.94
  }))), _g1314 || (_g1314 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1266",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 217.04,
    x2: 141.41,
    y2: 223.53
  }))), _g1315 || (_g1315 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1267",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 245.15,
    x2: 125.18,
    y2: 251.63
  }))), _g1316 || (_g1316 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-50",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.08 107.71 4 107.73 3.87 107.79 3.78 107.87 3.7 107.95 3.64 108.03 3.6 108.12 3.56 108.21 3.52 108.31 3.49 108.43 3.46 108.55 3.44 108.7 3.43 108.75"
  }))), _g1317 || (_g1317 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1268",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.83,
    y1: 73.53,
    x2: 96.32,
    y2: 73.41
  }))), _g1318 || (_g1318 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1269",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 75.43,
    x2: 93.2,
    y2: 75.39
  }))), _g1319 || (_g1319 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1270",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 67.89,
    x2: 100.51,
    y2: 67.89
  }))), _g1320 || (_g1320 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1271",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 67.89,
    x2: 76.01,
    y2: 67.89
  }))), _g1321 || (_g1321 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1272",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 67.31,
    x2: 100.51,
    y2: 67.31
  }))), _g1322 || (_g1322 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1273",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.01,
    y1: 67.31,
    x2: 77.45,
    y2: 67.31
  }))), _g1323 || (_g1323 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1274",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 75.43,
    x2: 84.76,
    y2: 75.39
  }))), _g1324 || (_g1324 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1275",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.13,
    y1: 73.53,
    x2: 81.64,
    y2: 73.41
  }))), _g1325 || (_g1325 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1276",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.51,
    y1: 42.79,
    x2: 99.07,
    y2: 41.35
  }))), _g1326 || (_g1326 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1277",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 124.27,
    y1: 65.01,
    x2: 137.66,
    y2: 88.21
  }))), _g1327 || (_g1327 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1278",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.66,
    y1: 89.94,
    x2: 149.48,
    y2: 108.68
  }))), _g1328 || (_g1328 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1279",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 107.52,
    x2: 161.38,
    y2: 114
  }))), _g1329 || (_g1329 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1280",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.14,
    y1: 219.12,
    x2: 173.85,
    y2: 217.04
  }))), _g1330 || (_g1330 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1281",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.01,
    y1: 218.16,
    x2: 173.85,
    y2: 217.04
  }))), _g1331 || (_g1331 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1282",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.48,
    y1: 224.44,
    x2: 175.35,
    y2: 223.45
  }))), _g1332 || (_g1332 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1283",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.35,
    y1: 216,
    x2: 174.48,
    y2: 217.04
  }))), _g1333 || (_g1333 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1284",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.7,
    y1: 210.56,
    x2: 173.83,
    y2: 211.68
  }))), _g1334 || (_g1334 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-51",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.72 210.56 173.44 208.07 173.25 206.24"
  }))), _g1335 || (_g1335 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1285",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 168.63,
    y1: 31.07,
    x2: 168.64,
    y2: 31.2
  }))), _g1336 || (_g1336 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-52",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.85 44.73 173.81 44.3 173.66 43.06 173.46 41.78 173.21 40.46 172.92 39.1 172.79 38.57"
  }))), _g1337 || (_g1337 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1286",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 173.78,
    y1: 44.67,
    x2: 173.85,
    y2: 45.38
  }))), _g1338 || (_g1338 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1287",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 172.03,
    y1: 39.55,
    x2: 171.96,
    y2: 38.68
  }))), _g1339 || (_g1339 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1288",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 172.03,
    y1: 39.55,
    x2: 171.96,
    y2: 38.68
  }))), _g1340 || (_g1340 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1289",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.57,
    y1: 259.91,
    x2: 177.82,
    y2: 251.56
  }))), _g1341 || (_g1341 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1290",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.2,
    y1: 260.2,
    x2: 177.18,
    y2: 260.37
  }))), _g1342 || (_g1342 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1291",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.2,
    y1: 260.2,
    x2: 177.18,
    y2: 260.37
  }))), _g1343 || (_g1343 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1292",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.69,
    y1: 268,
    x2: 177.57,
    y2: 259.91
  }))), _g1344 || (_g1344 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1293",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 165.54,
    y1: 271.2,
    x2: 165.55,
    y2: 271.09
  }))), _g1345 || (_g1345 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1294",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 165.54,
    y1: 271.2,
    x2: 165.55,
    y2: 271.09
  }))), _g1346 || (_g1346 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1295",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.19,
    y1: 275.8,
    x2: 176.69,
    y2: 268
  }))), _g1347 || (_g1347 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1296",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.6,
    y1: 271.09,
    x2: 175.58,
    y2: 271.19
  }))), _g1348 || (_g1348 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1297",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.49,
    y1: 338.82,
    x2: 85.24,
    y2: 332.33
  }))), _g1349 || (_g1349 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1298",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 310.72,
    x2: 101.46,
    y2: 304.23
  }))), _g1350 || (_g1350 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1299",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 282.61,
    x2: 117.69,
    y2: 276.13
  }))), _g1351 || (_g1351 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1300",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 254.51,
    x2: 133.92,
    y2: 248.03
  }))), _g1352 || (_g1352 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1301",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 226.41,
    x2: 150.15,
    y2: 219.93
  }))), _g1353 || (_g1353 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1302",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 291.98,
    x2: 108.95,
    y2: 298.47
  }))), _g1354 || (_g1354 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1303",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 320.08,
    x2: 92.73,
    y2: 326.57
  }))), _g1355 || (_g1355 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1304",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 235.78,
    x2: 141.41,
    y2: 242.26
  }))), _g1356 || (_g1356 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1305",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 263.88,
    x2: 125.18,
    y2: 270.37
  }))), _g1357 || (_g1357 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1306",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.39,
    y1: 306.91,
    x2: 103.51,
    y2: 311.9
  }))), _g1358 || (_g1358 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1307",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.5,
    y1: 313.63,
    x2: 109.38,
    y2: 308.64
  }))), _g1359 || (_g1359 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1308",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.72,
    y1: 329.45,
    x2: 101.46,
    y2: 322.97
  }))), _g1360 || (_g1360 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1309",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 301.35,
    x2: 117.69,
    y2: 294.86
  }))), _g1361 || (_g1361 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1310",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 273.25,
    x2: 133.92,
    y2: 266.76
  }))), _g1362 || (_g1362 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1311",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 245.15,
    x2: 150.15,
    y2: 238.66
  }))), _g1363 || (_g1363 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1312",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.03,
    y1: 300.18,
    x2: 115.65,
    y2: 304.3
  }))), _g1364 || (_g1364 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1313",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 310.72,
    x2: 108.95,
    y2: 317.2
  }))), _g1365 || (_g1365 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1314",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 254.51,
    x2: 141.41,
    y2: 261
  }))), _g1366 || (_g1366 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1315",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 282.61,
    x2: 125.18,
    y2: 289.1
  }))), _g1367 || (_g1367 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1316",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.14,
    y1: 306.91,
    x2: 121.03,
    y2: 301.91
  }))), _g1368 || (_g1368 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1317",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.95,
    y1: 320.08,
    x2: 117.69,
    y2: 313.6
  }))), _g1369 || (_g1369 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1318",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 291.98,
    x2: 133.92,
    y2: 285.5
  }))), _g1370 || (_g1370 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1319",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 263.88,
    x2: 150.15,
    y2: 257.4
  }))), _g1371 || (_g1371 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1320",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.03,
    y1: 313.63,
    x2: 115.15,
    y2: 318.62
  }))), _g1372 || (_g1372 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1321",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.26,
    y1: 286.92,
    x2: 19.32,
    y2: 287.34
  }))), _g1373 || (_g1373 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1322",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 64.05,
    x2: 76.01,
    y2: 64.05
  }))), _g1374 || (_g1374 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1323",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.51,
    y1: 64.05,
    x2: 101.95,
    y2: 64.05
  }))), _g1375 || (_g1375 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1324",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 60.59,
    x2: 100.51,
    y2: 60.59
  }))), _g1376 || (_g1376 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1325",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.01,
    y1: 60.59,
    x2: 77.45,
    y2: 60.59
  }))), _g1377 || (_g1377 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1326",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 50.61,
    x2: 76.44,
    y2: 50.61
  }))), _g1378 || (_g1378 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1327",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.51,
    y1: 50.61,
    x2: 101.52,
    y2: 50.61
  }))), _g1379 || (_g1379 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1328",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.04,
    y1: 84.03,
    x2: 152.89,
    y2: 68.18
  }))), _g1380 || (_g1380 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1329",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.06,
    y1: 65.01,
    x2: 137.66,
    y2: 41.81
  }))), _g1381 || (_g1381 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1330",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.53,
    y1: 39.84,
    x2: 153.05,
    y2: 65.01
  }))), _g1382 || (_g1382 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1331",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.89,
    y1: 66.45,
    x2: 163.04,
    y2: 82.3
  }))), _g1383 || (_g1383 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1332",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.05,
    y1: 59.24,
    x2: 151.06,
    y2: 55.78
  }))), _g1384 || (_g1384 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1333",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.06,
    y1: 44.26,
    x2: 153.05,
    y2: 47.71
  }))), _g1385 || (_g1385 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1334",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.05,
    y1: 41.95,
    x2: 151.06,
    y2: 38.49
  }))), _g1386 || (_g1386 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-53",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "168.17 28.17 168.12 28 168.05 27.83 167.99 27.68 167.98 27.66"
  }))), _g1387 || (_g1387 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-54",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "172.79 38.57 172.69 38.19 172.55 37.81 172.4 37.45 172.21 37.13 172.01 36.85 171.77 36.63 171.5 36.48 171.43 36.45"
  }))), _g1388 || (_g1388 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-55",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "168.77 31.18 168.68 30.52 168.56 29.81 168.4 29.06 168.2 28.28 168.17 28.17"
  }))), _g1389 || (_g1389 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1335",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 175.6,
    y1: 271.09,
    x2: 175.58,
    y2: 271.19
  }))), _g1390 || (_g1390 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-56",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "170.48 290.37 173.1 283.26 175.19 275.8"
  }))), _g1391 || (_g1391 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1336",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.35,
    y1: 288.38,
    x2: 170.25,
    y2: 288.62
  }))), _g1392 || (_g1392 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1337",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.7,
    y1: 329.45,
    x2: 108.95,
    y2: 335.94
  }))), _g1393 || (_g1393 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1338",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 273.25,
    x2: 141.41,
    y2: 279.73
  }))), _g1394 || (_g1394 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1339",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 301.35,
    x2: 125.18,
    y2: 307.83
  }))), _g1395 || (_g1395 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1340",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.14,
    y1: 320.35,
    x2: 121.03,
    y2: 315.36
  }))), _g1396 || (_g1396 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1341",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.17,
    y1: 310.72,
    x2: 133.92,
    y2: 304.23
  }))), _g1397 || (_g1397 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1342",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 282.61,
    x2: 150.15,
    y2: 276.13
  }))), _g1398 || (_g1398 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1343",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.82,
    y1: 311.84,
    x2: 132.67,
    y2: 308.64
  }))), _g1399 || (_g1399 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1344",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 291.98,
    x2: 141.41,
    y2: 298.47
  }))), _g1400 || (_g1400 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1345",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.92,
    y1: 320.08,
    x2: 125.18,
    y2: 326.57
  }))), _g1401 || (_g1401 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1346",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.06,
    y1: 269.63,
    x2: 157.63,
    y2: 270.37
  }))), _g1402 || (_g1402 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1347",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.96,
    y1: 281.75,
    x2: 150.07,
    y2: 285.01
  }))), _g1403 || (_g1403 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1348",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.98,
    y1: 304.23,
    x2: 138.43,
    y2: 305.18
  }))), _g1404 || (_g1404 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1349",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.4,
    y1: 301.35,
    x2: 150.15,
    y2: 294.86
  }))), _g1405 || (_g1405 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1350",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.73,
    y1: 37.87,
    x2: 84.76,
    y2: 37.87
  }))), _g1406 || (_g1406 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1351",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.73,
    y1: 37.87,
    x2: 84.76,
    y2: 37.87
  }))), _g1407 || (_g1407 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1352",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.64,
    y1: 38.52,
    x2: 81.63,
    y2: 38.52
  }))), _g1408 || (_g1408 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1353",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.64,
    y1: 38.52,
    x2: 81.63,
    y2: 38.52
  }))), _g1409 || (_g1409 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1354",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 78.89,
    y1: 41.35,
    x2: 79.76,
    y2: 41.35
  }))), _g1410 || (_g1410 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1355",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.21,
    y1: 41.35,
    x2: 99.07,
    y2: 41.35
  }))), _g1411 || (_g1411 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1356",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.34,
    y1: 38.52,
    x2: 96.32,
    y2: 38.52
  }))), _g1412 || (_g1412 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1357",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.34,
    y1: 38.52,
    x2: 96.32,
    y2: 38.52
  }))), _g1413 || (_g1413 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1358",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.2,
    y1: 37.87,
    x2: 93.23,
    y2: 37.87
  }))), _g1414 || (_g1414 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1359",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.2,
    y1: 37.87,
    x2: 93.23,
    y2: 37.87
  }))), _g1415 || (_g1415 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-57",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "167.98 27.67 167.85 27.4 167.41 26.64 166.84 25.8 166.15 24.92 165.33 24.02 164.51 23.25"
  }))), _g1416 || (_g1416 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1360",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 167.98,
    y1: 27.67,
    x2: 167.98,
    y2: 27.66
  }))), _g1417 || (_g1417 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1361",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.35,
    y1: 288.38,
    x2: 170.25,
    y2: 288.62
  }))), _g1418 || (_g1418 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1362",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 145.15,
    y1: 310.72,
    x2: 141.41,
    y2: 317.2
  }))), _g1419 || (_g1419 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1363",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.84,
    y1: 287.02,
    x2: 157.63,
    y2: 289.1
  }))), _g1420 || (_g1420 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1364",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.63,
    y1: 294.86,
    x2: 150.15,
    y2: 307.83
  }))), _g1421 || (_g1421 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-58",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "160.46 308.71 163.87 303.45 167.39 297.1 170.48 290.37"
  }))), _g1422 || (_g1422 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1365",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.54,
    y1: 36.45,
    x2: 6.54,
    y2: 36.45
  }))), _g1423 || (_g1423 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-59",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.19 36.28 7.06 36.31 6.84 36.37 6.64 36.42 6.54 36.45"
  }))), _g1424 || (_g1424 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1366",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 24.66,
    x2: 100.51,
    y2: 24.66
  }))), _g1425 || (_g1425 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1367",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 24.66,
    x2: 76.01,
    y2: 24.66
  }))), _g1426 || (_g1426 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1368",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.45,
    y1: 23.54,
    x2: 76.01,
    y2: 23.54
  }))), _g1427 || (_g1427 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1369",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.51,
    y1: 23.54,
    x2: 101.95,
    y2: 23.54
  }))), _g1428 || (_g1428 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-60",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "171.43 36.45 171.3 36.42 171.09 36.36 170.88 36.31 170.78 36.28"
  }))), _g1429 || (_g1429 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1370",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 159.38,
    y1: 20.39,
    x2: 159.29,
    y2: 20.37
  }))), _g1430 || (_g1430 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-61",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "159.29 20.37 153.21 18.45 146.34 16.15 139.34 13.66 132.26 10.99 125.12 8.17 117.89 5.3 110.52 2.53 103.67 0.24"
  }))), _g1431 || (_g1431 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1371",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 151.06,
    y1: 20.79,
    x2: 150.88,
    y2: 20.73
  }))), _g1432 || (_g1432 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-62",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "159.89 20.56 159.64 20.48 159.38 20.39"
  }))), _g1433 || (_g1433 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1372",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.95,
    y1: 5.2,
    x2: 100.51,
    y2: 4.69
  }))), _g1434 || (_g1434 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1373",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 108.89,
    y1: 4.96,
    x2: 108.74,
    y2: 4.91
  }))), _g1435 || (_g1435 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1374",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.89,
    y1: 4.34,
    x2: 109.18,
    y2: 4.44
  }))), _g1436 || (_g1436 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-63",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "170.77 36.28 170.62 36.22 170.28 36.03 169.87 35.71 169.41 35.27 169.14 34.98"
  }))), _g1437 || (_g1437 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1375",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 138.7,
    y1: 15.95,
    x2: 138.53,
    y2: 15.89
  }))), _g1438 || (_g1438 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1376",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 110.78,
    y1: 5.17,
    x2: 110.62,
    y2: 5.11
  }))), _g1439 || (_g1439 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1377",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 136.8,
    y1: 15.81,
    x2: 136.61,
    y2: 15.74
  }))), _g1440 || (_g1440 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1378",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.44,
    y1: 10.5,
    x2: 124.27,
    y2: 10.43
  }))), _g1441 || (_g1441 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1379",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.27,
    y1: 9.49,
    x2: 122.6,
    y2: 9.62
  }))), _g1442 || (_g1442 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1380",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 122.27,
    y1: 10.14,
    x2: 122.04,
    y2: 10.05
  }))), _g1443 || (_g1443 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-64",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "164.51 23.25 164.14 22.94 163.25 22.27 162.3 21.66 161.3 21.14 160.26 20.7 159.89 20.56"
  }))), _g1444 || (_g1444 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1381",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.51,
    y1: 23.25,
    x2: 164.51,
    y2: 23.25
  }))), _g1445 || (_g1445 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-65",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "103.67 0.24 103.43 0.18 103.13 0.14 102.84 0.15 102.58 0.21 102.36 0.3 102.18 0.45 102.05 0.62 101.97 0.83 101.95 1.01"
  }))), _g1446 || (_g1446 = /*#__PURE__*/React.createElement("g", {
    id: "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.71,449.32q.49-3.24,1-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1447 || (_g1447 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-2",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.46,447.11c-.13-.7-.26-1.41-.38-2.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1448 || (_g1448 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-3",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.19,421.22q-.25-6.5-.6-13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1449 || (_g1449 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-4",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.51,458q-.48-3.25-1-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1450 || (_g1450 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-5",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210,376.8c-.27-1.7-.55-3.39-.84-5.09",
    transform: "translate(-199.25 -225.79)"
  }))), _g1451 || (_g1451 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-6",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.31,495.42q-.35-6.12-.79-12.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g1452 || (_g1452 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-7",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.16,453.54l-.27-2.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1453 || (_g1453 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-8",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.81,460.13c-.31-2.17-.64-4.33-1-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1454 || (_g1454 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-9",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.26,460.13c-.32-2.17-.64-4.33-1-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1455 || (_g1455 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-10",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.93,376.49c-.24-1.59-.49-3.19-.74-4.78",
    transform: "translate(-199.25 -225.79)"
  }))), _g1456 || (_g1456 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-11",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.87,441.79q.27-2.16.51-4.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1457 || (_g1457 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-12",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.17,416.79c.07-.41.14-.83.2-1.25",
    transform: "translate(-199.25 -225.79)"
  }))), _g1458 || (_g1458 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-13",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.62,403.2c0-.38,0-.77-.05-1.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g1459 || (_g1459 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-14",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.38,417c.17-1,.33-2,.49-3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1460 || (_g1460 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-15",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.47,427.68c.07-.72.14-1.43.2-2.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1461 || (_g1461 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-16",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204,432q.24-2.17.45-4.35",
    transform: "translate(-199.25 -225.79)"
  }))), _g1462 || (_g1462 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-17",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204,434.19c.13-1.07.25-2.14.37-3.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1463 || (_g1463 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-18",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.41,431c.12-1.1.24-2.19.35-3.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1464 || (_g1464 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-19",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,301.2l-3.12,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1465 || (_g1465 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-20",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,301.18l-3.12,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1466 || (_g1466 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-21",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.42,456.83c-.13-1.06-.27-2.12-.41-3.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1467 || (_g1467 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-22",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.71,458c-.18-1.48-.36-3-.55-4.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1468 || (_g1468 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-23",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.31,442.84c.21-1.43.41-2.86.61-4.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1469 || (_g1469 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-24",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.94,442.84c.32-2.16.62-4.33.89-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1470 || (_g1470 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-25",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.09,377.57c-.06-.36-.11-.72-.16-1.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1471 || (_g1471 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-26",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.17,440.67q.47-3.24.86-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1472 || (_g1472 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-27",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.91,449.32q.09-2.16.15-4.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1473 || (_g1473 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-28",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.21,455.36c-.2-1.29-.41-2.59-.64-3.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g1474 || (_g1474 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-29",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.83,460.13c-.13-1.1-.27-2.2-.41-3.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1475 || (_g1475 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-30",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.64,466.61q-.42-3.24-.91-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1476 || (_g1476 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-31",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.37,335.31c-.05-.4-.09-.79-.15-1.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1477 || (_g1477 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-32",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.41,336.56l-.09-.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1478 || (_g1478 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-33",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.32,335.74c0-.13,0-.26,0-.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1479 || (_g1479 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-34",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363,372.94a365.72,365.72,0,0,0,7.06-109.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g1480 || (_g1480 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-35",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.84,371.51A364.75,364.75,0,0,0,368,257",
    transform: "translate(-199.25 -225.79)"
  }))), _g1481 || (_g1481 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-36",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364,373.07q1.35-6.13,2.48-12.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g1482 || (_g1482 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-37",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.29,260.94c-.13-1.32-.26-2.63-.4-3.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g1483 || (_g1483 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-38",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.68,361.54l.15-.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g1484 || (_g1484 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-39",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.79,314.43c0-.46,0-.91.08-1.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1485 || (_g1485 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-40",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.57,323.08c.17-.53.34-1.05.5-1.58",
    transform: "translate(-199.25 -225.79)"
  }))), _g1486 || (_g1486 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-41",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.24,323l.21-.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g1487 || (_g1487 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-42",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.76,323.08c.15-.48.3-1,.44-1.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g1488 || (_g1488 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-43",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.2,231.26l-1.44-.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1489 || (_g1489 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-44",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.2,233.7l-1.44-.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1490 || (_g1490 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-45",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.86,466.61q-.32-3.24-.74-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1491 || (_g1491 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-46",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.08,468.77q-.3-3.24-.7-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1492 || (_g1492 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-47",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.71,468.77c-.16-1.81-.35-3.62-.57-5.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1493 || (_g1493 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-48",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.09,475.26q-.21-3.25-.56-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1494 || (_g1494 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-49",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.12,477.42c-.11-2.16-.28-4.33-.5-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1495 || (_g1495 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-50",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.53,477.42c-.11-2.16-.27-4.33-.49-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1496 || (_g1496 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-51",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.55,492.55c.16-2.15.27-4.32.3-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1497 || (_g1497 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-52",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.14,501.9a8.74,8.74,0,0,0-4.39,2.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g1498 || (_g1498 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-53",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.63,504.81a5.61,5.61,0,0,0-5.61,5.61,5.48,5.48,0,0,0,.49,2.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1499 || (_g1499 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-54",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.7,475.26c-.05-1.45-.13-2.91-.22-4.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1500 || (_g1500 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-55",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.16,492.55q.22-3.24.33-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1501 || (_g1501 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-56",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.79,425.54c-.07-1.55-.16-3.11-.28-4.66",
    transform: "translate(-199.25 -225.79)"
  }))), _g1502 || (_g1502 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-57",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.5,433.07c0-.14,0-.28,0-.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1503 || (_g1503 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-58",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.22,334.12c0-.22-.05-.43-.08-.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1504 || (_g1504 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-59",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.14,378c0-.15,0-.29,0-.44",
    transform: "translate(-199.25 -225.79)"
  }))), _g1505 || (_g1505 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-60",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.18,378.82a7.32,7.32,0,0,0,0-.81",
    transform: "translate(-199.25 -225.79)"
  }))), _g1506 || (_g1506 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-61",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.33,379.56a.75.75,0,0,0,.07-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1507 || (_g1507 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-62",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.48,470.9q-.06-1.06-.15-2.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1508 || (_g1508 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-63",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.25,477.42c0-1.06-.06-2.13-.11-3.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1509 || (_g1509 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-64",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374,494.71c.2-2.15.35-4.32.45-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1510 || (_g1510 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-65",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.59,494.71c.15-1.6.27-3.21.38-4.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1511 || (_g1511 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-66",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.14,474.23c-.05-1.1-.11-2.2-.18-3.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1512 || (_g1512 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-67",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.11,506.64l.21-1.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1513 || (_g1513 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-68",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.61,512c.47-2.15.9-4.32,1.28-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1514 || (_g1514 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-69",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366,512q.61-2.67,1.12-5.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1515 || (_g1515 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-70",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.34,468.69c0-.6-.11-1.21-.17-1.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1516 || (_g1516 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-71",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.55,468.7c-.07-.8-.14-1.59-.22-2.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1517 || (_g1517 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-72",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.59,509.85q.65-3.24,1.14-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1518 || (_g1518 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-73",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.7,468.75q-.15-2.55-.39-5.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1519 || (_g1519 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-74",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.88,501.2c.33-2.15.6-4.32.83-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1520 || (_g1520 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-75",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.67,473.61c-.07-1.58-.18-3.15-.31-4.72",
    transform: "translate(-199.25 -225.79)"
  }))), _g1521 || (_g1521 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-76",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.51,503.36c.38-2.15.69-4.31,1-6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1522 || (_g1522 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-77",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.07,473.44c0-.38,0-.76-.07-1.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1523 || (_g1523 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-78",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.87,230.76l-1.45-.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1524 || (_g1524 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-79",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.5,437.47c0-1.1,0-2.19-.08-3.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1525 || (_g1525 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-80",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373,440.65c0-1.43-.12-2.87-.21-4.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1526 || (_g1526 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-81",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.5,440.67c0-1.07,0-2.13,0-3.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1527 || (_g1527 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-82",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.43,434.19q.31-3.24.48-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1528 || (_g1528 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-83",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.65,435.14a3.09,3.09,0,0,0,.14.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1529 || (_g1529 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-84",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.79,435.46a2.4,2.4,0,0,0,.11.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g1530 || (_g1530 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-85",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.39,432v.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1531 || (_g1531 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-86",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.56,435.39l.12.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1532 || (_g1532 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-87",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.18,434.67a1.09,1.09,0,0,0,.17.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1533 || (_g1533 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-88",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222,416.75a1.59,1.59,0,0,0,2.24-.06,1.58,1.58,0,1,0-2.3-2.18l0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1534 || (_g1534 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-89",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211,435.48h.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1535 || (_g1535 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-90",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.12,435.3h.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1536 || (_g1536 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-91",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.45,483.91q.06-3.26,0-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1537 || (_g1537 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-92",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.94,472.32c0-.3,0-.61-.05-.91",
    transform: "translate(-199.25 -225.79)"
  }))), _g1538 || (_g1538 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-93",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377,474.18c0-.62,0-1.24-.07-1.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g1539 || (_g1539 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-94",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.9,475.26c0-2.17-.07-4.34-.2-6.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g1540 || (_g1540 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-95",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372,486.07c.07-2.16.08-4.33,0-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1541 || (_g1541 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-96",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.13,501.42c.2-1.16.37-2.32.53-3.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1542 || (_g1542 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-97",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.05,475.54c0-.45,0-.91,0-1.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1543 || (_g1543 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-98",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.07,477.31c0-.59,0-1.18,0-1.77",
    transform: "translate(-199.25 -225.79)"
  }))), _g1544 || (_g1544 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-99",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.51,486.07c.06-1.79.09-3.59.07-5.38",
    transform: "translate(-199.25 -225.79)"
  }))), _g1545 || (_g1545 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-100",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.13,474.62l-.06-1.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g1546 || (_g1546 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-101",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.66,497.94l.12-.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g1547 || (_g1547 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-102",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.58,480.69c0-.37,0-.74,0-1.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1548 || (_g1548 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-103",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.46,494.71c.25.74.51,1.46.79,2.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g1549 || (_g1549 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-104",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.21,477.42c.13,1.1.29,2.19.49,3.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1550 || (_g1550 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-105",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.7,480.69c.19,1.08.41,2.15.66,3.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g1551 || (_g1551 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-106",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.89,479.58a57,57,0,0,0,1.08,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1552 || (_g1552 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-107",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.1,445.44c-.12-.87-.24-1.74-.37-2.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g1553 || (_g1553 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-108",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206,474.23c.09.34.19.69.3,1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1554 || (_g1554 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-109",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.06,479.77c0-.82,0-1.64,0-2.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g1555 || (_g1555 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-110",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377,480.76c0-.33,0-.66,0-1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1556 || (_g1556 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-111",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.84,485.4c.1-1.55.16-3.09.2-4.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1557 || (_g1557 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-112",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.44,486q.3-3.19.4-6.41",
    transform: "translate(-199.25 -225.79)"
  }))), _g1558 || (_g1558 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-113",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.06,486.16c.05-.79.1-1.58.13-2.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1559 || (_g1559 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-114",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.31,462.29c-.11,1.44-.17,2.88-.19,4.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1560 || (_g1560 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-115",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.85,512c.29.47.58.94.88,1.41",
    transform: "translate(-199.25 -225.79)"
  }))), _g1561 || (_g1561 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-116",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.47,512c.44.7.9,1.4,1.37,2.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1562 || (_g1562 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-117",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.12,466.61c0,.72,0,1.44,0,2.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1563 || (_g1563 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-118",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.87,494.71l.17.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1564 || (_g1564 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-119",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.43,448.26q-.15-1.41-.33-2.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1565 || (_g1565 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-120",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.53,449.32c0-.35-.06-.71-.1-1.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1566 || (_g1566 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-121",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.64,460.13q-.1,1.65-.12,3.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1567 || (_g1567 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-122",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.52,463.43q0,1.59,0,3.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g1568 || (_g1568 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-123",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.1,442.84q0-1.09-.06-2.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1569 || (_g1569 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-124",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.26,507.83c.62-.76,1.23-1.53,1.82-2.31",
    transform: "translate(-199.25 -225.79)"
  }))), _g1570 || (_g1570 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-125",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.23,451.72c.44,1.07.91,2.13,1.4,3.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1571 || (_g1571 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-126",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.7,470.94c.48.86,1,1.71,1.51,2.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g1572 || (_g1572 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-127",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.64,436.35c.1.31.21.62.32.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g1573 || (_g1573 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-128",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.15,381.05a1.64,1.64,0,0,0,0,.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g1574 || (_g1574 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-129",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.44,386.7c0,.14,0,.27,0,.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1575 || (_g1575 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-130",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.25,340.28l0,.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1576 || (_g1576 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-131",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.5,384.72c.32,0,.64.06,1,.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1577 || (_g1577 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-132",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.44,373.07l0,.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1578 || (_g1578 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-133",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.63,371.51A14.41,14.41,0,0,0,228,382.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g1579 || (_g1579 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-134",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.46,372.94a14.43,14.43,0,0,0,13.35,11.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1580 || (_g1580 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-135",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.78,371.47c.05.23.11.45.17.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g1581 || (_g1581 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-136",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.77,371.39v.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1582 || (_g1582 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-137",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.74,388a5.84,5.84,0,0,0-1.29,3.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1583 || (_g1583 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-138",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.23,348.44a5.75,5.75,0,0,0,5.33-3.57",
    transform: "translate(-199.25 -225.79)"
  }))), _g1584 || (_g1584 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-139",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.8,404.09a1.6,1.6,0,0,0,1.38-1.78,1.91,1.91,0,0,0-.11-.41",
    transform: "translate(-199.25 -225.79)"
  }))), _g1585 || (_g1585 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-140",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.42,408a1,1,0,0,0,.59.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g1586 || (_g1586 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-141",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.7,230.77l-1.44.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1587 || (_g1587 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-142",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.7,233.21l-1.44.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1588 || (_g1588 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-143",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,299.2l-3.12-.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g1589 || (_g1589 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-144",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,299.15l-3.12.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g1590 || (_g1590 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-145",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.08,299.32l-2.88-.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1591 || (_g1591 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-146",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,299.25l-2.88.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1592 || (_g1592 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-147",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.34,460.13q-.42,3.24-.74,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1593 || (_g1593 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-148",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.09,462.29c-.28,2.16-.51,4.32-.71,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1594 || (_g1594 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-149",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.32,463.35c-.22,1.8-.41,3.61-.57,5.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1595 || (_g1595 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-150",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.94,468.77q-.36,3.24-.57,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1596 || (_g1596 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-151",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.84,470.94c-.21,2.15-.38,4.32-.5,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1597 || (_g1597 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-152",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.42,470.94c-.21,2.15-.38,4.32-.49,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1598 || (_g1598 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-153",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.61,486.07c0,2.16.14,4.33.31,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1599 || (_g1599 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-154",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.41,537.59c.4-.52.79-1.05,1.18-1.58",
    transform: "translate(-199.25 -225.79)"
  }))), _g1600 || (_g1600 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-155",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.09,540.5c.79-1,1.57-1.92,2.32-2.91",
    transform: "translate(-199.25 -225.79)"
  }))), _g1601 || (_g1601 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-156",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.54,543.43c.87-1,1.72-1.93,2.55-2.93",
    transform: "translate(-199.25 -225.79)"
  }))), _g1602 || (_g1602 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-157",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.33,545.74c.75-.75,1.49-1.53,2.21-2.31",
    transform: "translate(-199.25 -225.79)"
  }))), _g1603 || (_g1603 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-158",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.31,555.57l.38-.25",
    transform: "translate(-199.25 -225.79)"
  }))), _g1604 || (_g1604 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-159",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.92,548.07c.82-.76,1.62-1.53,2.41-2.33",
    transform: "translate(-199.25 -225.79)"
  }))), _g1605 || (_g1605 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-160",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.69,555.32c1.46-1,2.89-2,4.27-3.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1606 || (_g1606 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-161",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.09,550.55c1-.81,1.91-1.63,2.83-2.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1607 || (_g1607 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-162",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.2,536.71l.21-.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1608 || (_g1608 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-163",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.05,536.52l.21.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1609 || (_g1609 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-164",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343,552.25c.72-.55,1.43-1.12,2.13-1.7",
    transform: "translate(-199.25 -225.79)"
  }))), _g1610 || (_g1610 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-165",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.51,512.71c.27.61.55,1.22.84,1.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1611 || (_g1611 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-166",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.11,514.53c.29-.6.57-1.21.85-1.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1612 || (_g1612 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-167",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.93,514.9l.18-.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1613 || (_g1613 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-168",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.35,514.53l.18.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1614 || (_g1614 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-169",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.71,504.08a8.74,8.74,0,0,0-4.39-2.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g1615 || (_g1615 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-170",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357,512.71a5.62,5.62,0,0,0-5.13-7.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g1616 || (_g1616 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-171",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,295.63h-3.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1617 || (_g1617 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-172",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.63,492.55q.5-3.18.8-6.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1618 || (_g1618 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-173",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.1,492.68q.5-3.63.74-7.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1619 || (_g1619 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-174",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.12,523.64c.48-.9.95-1.8,1.4-2.71",
    transform: "translate(-199.25 -225.79)"
  }))), _g1620 || (_g1620 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-175",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.28,492l.09.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1621 || (_g1621 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-176",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207,514.41c.91,2.21,1.9,4.39,3,6.52",
    transform: "translate(-199.25 -225.79)"
  }))), _g1622 || (_g1622 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-177",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.52,520.93c1.07-2.13,2.07-4.31,3-6.52",
    transform: "translate(-199.25 -225.79)"
  }))), _g1623 || (_g1623 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-178",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.37,492.68c.2,1.44.43,2.87.69,4.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1624 || (_g1624 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-179",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.39,497c.27-1.44.5-2.9.71-4.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1625 || (_g1625 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-180",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.18,503.78c.63-2.25,1.18-4.51,1.65-6.8",
    transform: "translate(-199.25 -225.79)"
  }))), _g1626 || (_g1626 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-181",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.63,497c.47,2.29,1,4.55,1.65,6.8",
    transform: "translate(-199.25 -225.79)"
  }))), _g1627 || (_g1627 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-182",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.28,503.78c.58,2,1.22,4.07,1.93,6.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1628 || (_g1628 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-183",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.25,509.85c.71-2,1.35-4,1.93-6.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1629 || (_g1629 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-184",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.89,451.48c-.05-.41-.1-.83-.16-1.25",
    transform: "translate(-199.25 -225.79)"
  }))), _g1630 || (_g1630 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-185",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.73,450.23c0,.42-.11.84-.16,1.25",
    transform: "translate(-199.25 -225.79)"
  }))), _g1631 || (_g1631 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-186",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.92,510.29A95.59,95.59,0,0,0,375.39,497",
    transform: "translate(-199.25 -225.79)"
  }))), _g1632 || (_g1632 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-187",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.08,497.07a92.94,92.94,0,0,0,3.47,13.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g1633 || (_g1633 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-188",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.7,534.46l.78-1.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g1634 || (_g1634 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-189",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.59,536l1.11-1.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g1635 || (_g1635 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-190",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.4,486.16c.15,2.14.37,4.28.66,6.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1636 || (_g1636 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-191",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.4,492.56c.3-2.12.52-4.26.66-6.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1637 || (_g1637 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-192",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.26,511.71c.19.51.39,1,.59,1.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1638 || (_g1638 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-193",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.61,513.24c.21-.51.4-1,.6-1.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1639 || (_g1639 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-194",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.21,511.71c.22-.59.43-1.17.64-1.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g1640 || (_g1640 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-195",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.61,510c.21.59.42,1.17.65,1.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g1641 || (_g1641 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-196",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.17,505.51q.66,2.24,1.44,4.44",
    transform: "translate(-199.25 -225.79)"
  }))), _g1642 || (_g1642 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-197",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.85,510c.51-1.45,1-2.92,1.43-4.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1643 || (_g1643 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-198",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.52,552.4q3.44-1.42,6.75-3.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1644 || (_g1644 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-199",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.19,549.27q3.31,1.71,6.76,3.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1645 || (_g1645 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-200",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318,552.4a86.13,86.13,0,0,0,8.79-4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1646 || (_g1646 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-201",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.7,548.36a87.13,87.13,0,0,0,8.79,4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1647 || (_g1647 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-202",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249,544.53a83.06,83.06,0,0,0,11.82,5.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1648 || (_g1648 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-203",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.61,550.06a83.06,83.06,0,0,0,11.82-5.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1649 || (_g1649 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-204",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.26,536.71A76.76,76.76,0,0,0,240,543",
    transform: "translate(-199.25 -225.79)"
  }))), _g1650 || (_g1650 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-205",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.48,543a76.76,76.76,0,0,0,7.72-6.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1651 || (_g1651 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-206",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.48,543a75.68,75.68,0,0,0,8.54-6.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g1652 || (_g1652 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-207",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.44,536.09A75.68,75.68,0,0,0,241,543",
    transform: "translate(-199.25 -225.79)"
  }))), _g1653 || (_g1653 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-208",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,293.62h-3.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1654 || (_g1654 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-209",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.88,449.29c.21-1.42.39-2.86.53-4.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1655 || (_g1655 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-210",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.05,445c.14,1.43.32,2.87.53,4.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1656 || (_g1656 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-211",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.23,448.27c.37-1.8.67-3.61.92-5.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1657 || (_g1657 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-212",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.31,442.84c.25,1.82.55,3.63.92,5.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1658 || (_g1658 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-213",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.58,449.29c.08.55.17,1.09.26,1.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1659 || (_g1659 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-214",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.62,450.93c.09-.55.18-1.09.26-1.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1660 || (_g1660 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-215",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.25,455.36l0,.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1661 || (_g1661 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-216",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.18,455.79l0-.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1662 || (_g1662 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-217",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.52,451.48c0-.18.07-.37.1-.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g1663 || (_g1663 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-218",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.84,450.93c0,.18.07.37.1.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g1664 || (_g1664 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-219",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367,449.32c.08-.35.15-.7.22-1.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g1665 || (_g1665 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-220",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.23,448.27c.07.35.15.7.22,1.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g1666 || (_g1666 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-221",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.14,451.48l.09.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g1667 || (_g1667 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-222",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.75,468.89q-.18,3.18-.19,6.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1668 || (_g1668 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-223",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.45,474.32l0,.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g1669 || (_g1669 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-224",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.42,475.26c0,1.28,0,2.57,0,3.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g1670 || (_g1670 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-225",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.74,442.84c-.14.86-.26,1.73-.37,2.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g1671 || (_g1671 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-226",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.4,479.12c0,.54,0,1.08,0,1.62",
    transform: "translate(-199.25 -225.79)"
  }))), _g1672 || (_g1672 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-227",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.62,479.58q.1,3.23.4,6.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1673 || (_g1673 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-228",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.42,480.74c0,1.62.11,3.24.22,4.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g1674 || (_g1674 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-229",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.37,445.44c-.13.94-.24,1.88-.34,2.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1675 || (_g1675 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-230",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202,448.26c0,.35-.07.71-.1,1.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1676 || (_g1676 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-231",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,486.16q.3,3.21.8,6.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1677 || (_g1677 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-232",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.64,485.61c.14,2.15.36,4.29.64,6.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1678 || (_g1678 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-233",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.94,520.93c.45.91.92,1.81,1.41,2.71",
    transform: "translate(-199.25 -225.79)"
  }))), _g1679 || (_g1679 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-234",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.27,483.79c0,.79.08,1.58.13,2.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1680 || (_g1680 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-235",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376,463.43q0-1.65-.12-3.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1681 || (_g1681 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-236",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.34,466.61c0-1.44-.08-2.88-.19-4.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1682 || (_g1682 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-237",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.91,466.61c0-1.06,0-2.12,0-3.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g1683 || (_g1683 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-238",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.74,513.42l.87-1.41",
    transform: "translate(-199.25 -225.79)"
  }))), _g1684 || (_g1684 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-239",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.62,514.09c.47-.68.93-1.38,1.37-2.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1685 || (_g1685 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-240",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.33,468.77c0-.72,0-1.44,0-2.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1686 || (_g1686 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-241",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.21,496.9c.28-.73.54-1.45.79-2.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1687 || (_g1687 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-242",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.77,480.69q.28-1.62.48-3.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1688 || (_g1688 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-243",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.1,483.91c.25-1.07.48-2.14.67-3.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g1689 || (_g1689 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-244",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.49,486.07a54.9,54.9,0,0,0,1.08-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1690 || (_g1690 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-245",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.42,495.18l.17-.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1691 || (_g1691 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-246",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.21,475.26c.1-.34.2-.69.29-1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1692 || (_g1692 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-247",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.25,473.49c.53-.84,1-1.69,1.51-2.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g1693 || (_g1693 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-248",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.2,255.37l-1.44-.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g1694 || (_g1694 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-249",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.7,255.15l-1.44.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g1695 || (_g1695 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-250",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.72,293.9c-1,0-2,0-3,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1696 || (_g1696 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-251",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,290.52c-1-.09-2.08-.15-3.12-.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1697 || (_g1697 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-252",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,290.32c-1,.05-2.08.11-3.12.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1698 || (_g1698 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-253",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,285.08c-1.05,0-2.11,0-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1699 || (_g1699 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-254",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,283.26c-1.05,0-2.11,0-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1700 || (_g1700 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-255",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.37,391.9a7.56,7.56,0,0,0-10.27,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1701 || (_g1701 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-256",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.73,411.29a7.57,7.57,0,0,0,10.69.32l.32-.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1702 || (_g1702 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-257",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.19,410.49a6.68,6.68,0,0,0,10.08,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1703 || (_g1703 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-258",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.91,397.46a6.68,6.68,0,0,0-13.36,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1704 || (_g1704 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-259",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.89,397.46a6.66,6.66,0,0,0-13.32,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1705 || (_g1705 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-260",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.2,410.47a6.66,6.66,0,0,0,9.4.66q.34-.31.66-.66",
    transform: "translate(-199.25 -225.79)"
  }))), _g1706 || (_g1706 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-261",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268,230.23l-1.45.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1707 || (_g1707 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-262",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,470.9c-.09,1.45-.16,2.91-.22,4.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1708 || (_g1708 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-263",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201,486.07q.1,3.24.33,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1709 || (_g1709 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-264",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.13,468.77,200,470.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g1710 || (_g1710 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-265",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.32,474.21c0,1.07-.08,2.14-.11,3.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g1711 || (_g1711 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-266",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202,488.23c.1,2.16.25,4.33.45,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1712 || (_g1712 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-267",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.5,489.89c.1,1.61.22,3.22.37,4.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1713 || (_g1713 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-268",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.5,470.94q-.1,1.63-.18,3.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1714 || (_g1714 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-269",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.14,505.52l.21,1.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1715 || (_g1715 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-270",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.57,505.52c.38,2.17.81,4.34,1.28,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1716 || (_g1716 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-271",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204,434.19c0,1.09-.06,2.18-.08,3.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1717 || (_g1717 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-272",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.35,506.64c.34,1.8.72,3.59,1.12,5.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1718 || (_g1718 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-273",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.29,466.87c-.06.61-.11,1.22-.17,1.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1719 || (_g1719 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-274",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.13,466.31c-.08.8-.15,1.59-.22,2.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1720 || (_g1720 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-275",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.63,436.35c-.09,1.43-.16,2.87-.21,4.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1721 || (_g1721 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-276",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.73,503.36q.5,3.25,1.14,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1722 || (_g1722 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-277",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.15,463.65q-.24,2.55-.39,5.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1723 || (_g1723 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-278",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.75,494.71c.23,2.17.51,4.34.84,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1724 || (_g1724 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-279",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204,437.47c0,1.06,0,2.13,0,3.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1725 || (_g1725 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-280",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.11,468.89c-.14,1.57-.24,3.14-.32,4.72",
    transform: "translate(-199.25 -225.79)"
  }))), _g1726 || (_g1726 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-281",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.59,428.42c.11,1.93.25,3.85.44,5.77",
    transform: "translate(-199.25 -225.79)"
  }))), _g1727 || (_g1727 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-282",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.05,477.42q-.11,3.24,0,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1728 || (_g1728 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-283",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.42,440.65c0,.73,0,1.46-.06,2.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1729 || (_g1729 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-284",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209,496.88q.4,3.25,1,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1730 || (_g1730 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-285",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.56,471.62c-.05.9-.08,1.8-.11,2.7",
    transform: "translate(-199.25 -225.79)"
  }))), _g1731 || (_g1731 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-286",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.46,472.3c0,.38-.05.75-.07,1.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1732 || (_g1732 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-287",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.44,479.58c0,2.16,0,4.33.05,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1733 || (_g1733 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-288",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.8,497.94c.16,1.16.34,2.32.53,3.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1734 || (_g1734 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-289",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.39,473.43c0,.08,0,.16,0,.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g1735 || (_g1735 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-290",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.88,480.69c0,1.79,0,3.59.08,5.38",
    transform: "translate(-199.25 -225.79)"
  }))), _g1736 || (_g1736 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-291",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.68,497l.12.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g1737 || (_g1737 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-292",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.89,479.58c0,.37,0,.74,0,1.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1738 || (_g1738 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-293",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.34,388.15c0,.13,0,.26,0,.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1739 || (_g1739 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-294",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350,384.8l.78-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1740 || (_g1740 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-295",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364,373.18l0-.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1741 || (_g1741 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-296",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.47,382.87a14.41,14.41,0,0,0,13.37-11.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1742 || (_g1742 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-297",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.65,384.26A14.42,14.42,0,0,0,363,372.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g1743 || (_g1743 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-298",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.51,372.15c.06-.23.12-.45.17-.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g1744 || (_g1744 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-299",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.68,371.47l0-.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1745 || (_g1745 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-300",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332,391.08a5.84,5.84,0,0,0-1.29-3.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g1746 || (_g1746 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-301",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.17,397.61a2.88,2.88,0,0,0,2-3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1747 || (_g1747 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-302",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.3,396a1.44,1.44,0,0,0,1.14-1.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g1748 || (_g1748 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-303",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.05,408.78a1.39,1.39,0,0,0-.18-.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1749 || (_g1749 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-304",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.45,408.88A1,1,0,0,0,332,408",
    transform: "translate(-199.25 -225.79)"
  }))), _g1750 || (_g1750 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-305",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.72,322.46c0-.16.11-.33.17-.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g1751 || (_g1751 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-306",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.14,333.48c0-.18,0-.36-.08-.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1752 || (_g1752 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-307",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.28,335.35c0-.12,0-.24,0-.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1753 || (_g1753 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-308",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.39,262.09l-.09,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1754 || (_g1754 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-309",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.3,262.12l-.44.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1755 || (_g1755 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-310",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204,332.34s0-.08,0-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1756 || (_g1756 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-311",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.37,335.31c0,.05,0,.1,0,.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g1757 || (_g1757 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-312",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.88,336.72a.41.41,0,0,1,0,.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1758 || (_g1758 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-313",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.25,336.62a.38.38,0,0,1,0,.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1759 || (_g1759 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-314",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.73,261.52l.29-.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1760 || (_g1760 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-315",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.51,262.06l-.12,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1761 || (_g1761 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-316",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213,250.7l-.46.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1762 || (_g1762 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-317",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.2,250.58l-.23.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1763 || (_g1763 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-318",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.21,253.83s0,.07,0,.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1764 || (_g1764 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-319",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.1,262.87,205,263",
    transform: "translate(-199.25 -225.79)"
  }))), _g1765 || (_g1765 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-320",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.86,262.24h-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1766 || (_g1766 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-321",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206,262.24h0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1767 || (_g1767 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-322",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.48,264.34c-.11.46-.22.92-.31,1.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g1768 || (_g1768 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-323",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.51,251.08l-.39.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g1769 || (_g1769 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-324",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.29,252.58l-.72.56",
    transform: "translate(-199.25 -225.79)"
  }))), _g1770 || (_g1770 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-325",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.57,269.21q-.06.39-.09.78",
    transform: "translate(-199.25 -225.79)"
  }))), _g1771 || (_g1771 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-326",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.48,270c0,.16,0,.31,0,.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1772 || (_g1772 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-327",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.57,253.14l-.23.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1773 || (_g1773 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-328",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218,246.22l-.09,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1774 || (_g1774 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-329",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.14,248.79l-.1,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1775 || (_g1775 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-330",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.86,248.24l-.1,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1776 || (_g1776 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-331",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.72,283.87c-1,0-2,0-3,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1777 || (_g1777 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-332",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,275.92c-1.05,0-2.11,0-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1778 || (_g1778 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-333",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,274.45c-1.05-.05-2.11-.05-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1779 || (_g1779 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-334",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,272.82c-1-.22-2.07-.38-3.12-.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g1780 || (_g1780 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-335",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,271.6c-1-.23-2.07-.4-3.12-.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1781 || (_g1781 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-336",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,271.07c-1.05.13-2.09.3-3.12.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1782 || (_g1782 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-337",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.94,323.55a15.84,15.84,0,0,0,8.94,6.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g1783 || (_g1783 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-338",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.58,329.76a15.84,15.84,0,0,0,8.94-6.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g1784 || (_g1784 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-339",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.54,323.46c.3,0,.59,0,.89,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1785 || (_g1785 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-340",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283,323.42c.29,0,.59,0,.88,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1786 || (_g1786 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-341",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.5,314.23c0,.14,0,.28,0,.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1787 || (_g1787 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-342",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302,314.66c0-.15,0-.29,0-.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1788 || (_g1788 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-343",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.26,314.43a8.65,8.65,0,0,0,8.65,8.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g1789 || (_g1789 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-344",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.55,323.08a8.65,8.65,0,0,0,8.65-8.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g1790 || (_g1790 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-345",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.7,273c0,.29,0,.59-.06.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g1791 || (_g1791 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-346",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.64,273.88l0,.38",
    transform: "translate(-199.25 -225.79)"
  }))), _g1792 || (_g1792 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-347",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.51,325.39H289",
    transform: "translate(-199.25 -225.79)"
  }))), _g1793 || (_g1793 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-348",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,268.9c-1.05,0-2.11,0-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1794 || (_g1794 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-349",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,267.89c-1.05-.05-2.11-.05-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1795 || (_g1795 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-350",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,267.23q-1.54-.37-3.12-.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g1796 || (_g1796 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-351",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,266.63q-1.58.22-3.12.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g1797 || (_g1797 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-352",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,266.5a30.16,30.16,0,0,0-3.12-.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g1798 || (_g1798 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-353",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,265.89a30.16,30.16,0,0,0-3.12.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g1799 || (_g1799 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-354",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.72,275.33a29.62,29.62,0,0,0-3,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1800 || (_g1800 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-355",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,264.59a27.76,27.76,0,0,0-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1801 || (_g1801 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-356",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,264.12a27.76,27.76,0,0,0-3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1802 || (_g1802 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-357",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,263.84a27.88,27.88,0,0,0-3.12.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g1803 || (_g1803 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-358",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,264.49a27.42,27.42,0,0,0-3.12-.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g1804 || (_g1804 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-359",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,263.67a27.33,27.33,0,0,0-3.09.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1805 || (_g1805 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-360",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,264.31a27.33,27.33,0,0,0-3.09-.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1806 || (_g1806 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-361",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.22,264.42a29.16,29.16,0,0,0-4.42-.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g1807 || (_g1807 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-362",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.13,263.34a26.77,26.77,0,0,0-3.8,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1808 || (_g1808 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-363",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.66,263.5a28.79,28.79,0,0,0-4.41.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g1809 || (_g1809 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-364",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,272.11l-.28,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1810 || (_g1810 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-365",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.48,272.15l-.28,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1811 || (_g1811 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-366",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,272.15l-.21,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1812 || (_g1812 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-367",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.69,272.19l-.21,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1813 || (_g1813 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-368",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.93,272.69c-.74-.2-1.48-.37-2.24-.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g1814 || (_g1814 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-369",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.77,272.19c-.75.13-1.5.3-2.24.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g1815 || (_g1815 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-370",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.92,266.22l-.91.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1816 || (_g1816 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-371",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.54,264.67l-.24,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1817 || (_g1817 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-372",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.16,264.71l-.23,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1818 || (_g1818 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-373",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.45,266.64l-.91-.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1819 || (_g1819 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-374",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.7,275a8.82,8.82,0,0,0-1.44,2.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1820 || (_g1820 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-375",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.2,277.26a8.56,8.56,0,0,0-1.44-2.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1821 || (_g1821 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-376",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,312.14c1,0,2.08-.1,3.12-.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1822 || (_g1822 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-377",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,312c1,.07,2.08.13,3.12.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1823 || (_g1823 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-378",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,315.56c1.05,0,2.11,0,3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1824 || (_g1824 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-379",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,317.47c1.05,0,2.11,0,3.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1825 || (_g1825 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-380",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.51,325.85h.72",
    transform: "translate(-199.25 -225.79)"
  }))), _g1826 || (_g1826 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-381",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.23,325.85H289",
    transform: "translate(-199.25 -225.79)"
  }))), _g1827 || (_g1827 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-382",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.74,317c1,0,2,0,3,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1828 || (_g1828 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-383",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.2,253.93c0,.15-.09.3-.13.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g1829 || (_g1829 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-384",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.07,254.38a3.9,3.9,0,0,0-.12.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g1830 || (_g1830 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-385",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.78,252.87l-.59.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1831 || (_g1831 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-386",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.43,253.76l-.23.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1832 || (_g1832 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-387",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.7,253.57l-.27.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1833 || (_g1833 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-388",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.19,253.23l-.49.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g1834 || (_g1834 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-389",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.93,246.25l-.42.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1835 || (_g1835 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-390",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.51,246.38l-.09,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1836 || (_g1836 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-391",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.41,248.55l-.59.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1837 || (_g1837 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-392",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.42,246.41l-.07,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1838 || (_g1838 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-393",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.35,246.44a10.78,10.78,0,0,0-1.07.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1839 || (_g1839 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-394",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.5,249.29c-.27.25-.54.5-.8.77",
    transform: "translate(-199.25 -225.79)"
  }))), _g1840 || (_g1840 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-395",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.65,256.32l-.06.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g1841 || (_g1841 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-396",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.82,249l-.32.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1842 || (_g1842 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-397",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.44,265.68l-.2.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1843 || (_g1843 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-398",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.22,265.88l-.2-.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1844 || (_g1844 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-399",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.46,264.12l-.07.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1845 || (_g1845 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-400",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.07,264.18l-.07-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1846 || (_g1846 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-401",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.82,267.36l-.19-.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1847 || (_g1847 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-402",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.3,249.62a3,3,0,0,0,.4.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1848 || (_g1848 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-403",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.8,263.5a2.48,2.48,0,0,0-.61,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1849 || (_g1849 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-404",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.27,263.49a2.49,2.49,0,0,0-.61,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1850 || (_g1850 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-405",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.78,264.33l-.19,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1851 || (_g1851 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-406",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.87,264.31l-.19,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1852 || (_g1852 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-407",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,306.73h3.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1853 || (_g1853 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-408",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.74,306.59c1,0,2,0,3,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1854 || (_g1854 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-409",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.48,264.34l.78.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1855 || (_g1855 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-410",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,310.15c1,0,2.08-.07,3.12-.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1856 || (_g1856 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-411",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,310c1,.06,2.08.1,3.12.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1857 || (_g1857 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-412",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.51,262.21l-.44-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1858 || (_g1858 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-413",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.1,264.81c0-.16-.08-.31-.11-.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1859 || (_g1859 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-414",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.29,265.68c-.06-.29-.13-.58-.19-.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g1860 || (_g1860 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-415",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.34,251.32l-.38-.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g1861 || (_g1861 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-416",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.89,253.14l-.72-.56",
    transform: "translate(-199.25 -225.79)"
  }))), _g1862 || (_g1862 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-417",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373,270.46q0-.56-.12-1.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1863 || (_g1863 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-418",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.12,253.33l-.23-.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1864 || (_g1864 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-419",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.53,246.25l-.09,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1865 || (_g1865 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-420",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.6,262.24l-.09,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1866 || (_g1866 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-421",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.42,248.82l-.1,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1867 || (_g1867 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-422",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.71,248.27l-.11,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1868 || (_g1868 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-423",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.4,254.38c0-.15-.09-.3-.13-.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g1869 || (_g1869 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-424",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.52,254.84l-.12-.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g1870 || (_g1870 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-425",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.27,253.23l-.59-.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1871 || (_g1871 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-426",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.27,253.93l-.23-.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1872 || (_g1872 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-427",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367,253.76l-.27-.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1873 || (_g1873 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-428",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.77,253.57l-.5-.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g1874 || (_g1874 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-429",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359,246.38l-.43-.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1875 || (_g1875 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-430",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359,246.41l-.08,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1876 || (_g1876 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-431",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.64,249l-.59-.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1877 || (_g1877 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-432",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.11,246.44l-.07,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1878 || (_g1878 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-433",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.18,246.86a10.78,10.78,0,0,0-1.07-.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g1879 || (_g1879 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-434",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.76,250.06c-.26-.27-.53-.52-.8-.77",
    transform: "translate(-199.25 -225.79)"
  }))), _g1880 || (_g1880 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-435",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.88,256.86c0-.18-.05-.36-.07-.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g1881 || (_g1881 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-436",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364,249.29l-.32-.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g1882 || (_g1882 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-437",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.07,262.09l-.12,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1883 || (_g1883 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-438",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364,251l-.46-.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1884 || (_g1884 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-439",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.49,250.7l-.22-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1885 || (_g1885 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-440",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.27,253.93s0-.07,0-.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1886 || (_g1886 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-441",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.55,262.72l-.13,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1887 || (_g1887 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-442",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.83,267.23l-.18.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g1888 || (_g1888 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-443",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.12,262.11l-.05,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1889 || (_g1889 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-444",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.76,249.82a3.11,3.11,0,0,0,.41-.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1890 || (_g1890 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-445",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.48,263.05a1.4,1.4,0,0,0-.1-.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1891 || (_g1891 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-446",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.1,342.19c.07.66.14,1.31.22,2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1892 || (_g1892 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-447",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.33,358.23l.24,2.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g1893 || (_g1893 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-448",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,321.63l.45,1.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g1894 || (_g1894 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-449",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,322l.18.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g1895 || (_g1895 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-450",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.6,264.4l.39-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1896 || (_g1896 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-451",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.23,388q6.86-.27,13.71-.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g1897 || (_g1897 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-452",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.52,387.42q6.85.34,13.71.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g1898 || (_g1898 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-453",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.27,388.9q6.25-.07,12.5-.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g1899 || (_g1899 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-454",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.69,388.67q6.26.15,12.5.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g1900 || (_g1900 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-455",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.38,385.93q7.92.13,15.85.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1901 || (_g1901 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-456",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.23,386.07q7.93,0,15.85-.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1902 || (_g1902 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-457",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.16,523.12h6.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g1903 || (_g1903 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-458",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.7,523.11l6.62,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1904 || (_g1904 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-459",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,304.69h3.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g1905 || (_g1905 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-460",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.14,248.79q2.52-.76,5-1.57",
    transform: "translate(-199.25 -225.79)"
  }))), _g1906 || (_g1906 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-461",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.69,241.57l1.44-.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1907 || (_g1907 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-462",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.34,246.52q6.21-2,12.35-4.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1908 || (_g1908 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-463",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.16,246.54l1.66-.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g1909 || (_g1909 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-464",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.3,246.61q2.64.84,5.3,1.63",
    transform: "translate(-199.25 -225.79)"
  }))), _g1910 || (_g1910 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-465",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.86,248.24q2.65-.8,5.3-1.63",
    transform: "translate(-199.25 -225.79)"
  }))), _g1911 || (_g1911 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-466",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.94,451.48c-.34,2.16-.66,4.32-1,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1912 || (_g1912 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-467",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.94,483.19q-.45,6.1-.78,12.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g1913 || (_g1913 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-468",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.57,451.48l-.27,2.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1914 || (_g1914 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-469",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.62,453.64c-.33,2.16-.66,4.32-1,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1915 || (_g1915 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-470",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.18,453.64q-.51,3.24-1,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1916 || (_g1916 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-471",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.45,453.64c-.14,1.06-.28,2.13-.41,3.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g1917 || (_g1917 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-472",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.3,453.54c-.19,1.47-.37,2.95-.55,4.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1918 || (_g1918 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-473",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.89,451.48c-.22,1.29-.44,2.59-.64,3.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g1919 || (_g1919 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-474",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.73,460.13q-.49,3.24-.9,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1920 || (_g1920 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-475",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201,456.83c-.14,1.1-.28,2.2-.4,3.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1921 || (_g1921 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-476",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.46,378.12c0,.84,0,1.69,0,2.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g1922 || (_g1922 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-477",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.66,381.11l0,1.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g1923 || (_g1923 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-478",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.92,382.83c0,.23,0,.45,0,.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g1924 || (_g1924 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-479",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.65,382.59c0,.52,0,1.05,0,1.57",
    transform: "translate(-199.25 -225.79)"
  }))), _g1925 || (_g1925 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-480",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.74,377.76c0,.88,0,1.76,0,2.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g1926 || (_g1926 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-481",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.93,383.51c0,.26,0,.52,0,.78",
    transform: "translate(-199.25 -225.79)"
  }))), _g1927 || (_g1927 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-482",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.18,390.36c.07,1.37.16,2.74.26,4.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1928 || (_g1928 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-483",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.16,389.93c0,.14,0,.29,0,.43",
    transform: "translate(-199.25 -225.79)"
  }))), _g1929 || (_g1929 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-484",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.91,389.6q.19,3.88.56,7.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g1930 || (_g1930 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-485",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.22,356.9c0,.44.07.89.11,1.33",
    transform: "translate(-199.25 -225.79)"
  }))), _g1931 || (_g1931 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-486",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.91,340.48c.06.57.12,1.14.19,1.71",
    transform: "translate(-199.25 -225.79)"
  }))), _g1932 || (_g1932 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-487",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.4,263.21a366.37,366.37,0,0,0,7.06,109.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g1933 || (_g1933 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-488",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.45,257a364.45,364.45,0,0,0,6.18,114.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1934 || (_g1934 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-489",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210,360.73q1.14,6.19,2.49,12.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g1935 || (_g1935 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-490",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206,333.59c.06.61.13,1.22.2,1.82",
    transform: "translate(-199.25 -225.79)"
  }))), _g1936 || (_g1936 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-491",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.24,335.41l.21,1.91",
    transform: "translate(-199.25 -225.79)"
  }))), _g1937 || (_g1937 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-492",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.57,257c-.14,1.32-.27,2.63-.39,3.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g1938 || (_g1938 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-493",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.63,360.71c.05.28.11.55.16.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g1939 || (_g1939 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-494",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.6,313.13c0,.46.05.93.08,1.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1940 || (_g1940 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-495",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.89,359.35c.05.36.09.73.14,1.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g1941 || (_g1941 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-496",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,322.3l.21.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g1942 || (_g1942 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-497",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,321.5l.5,1.58",
    transform: "translate(-199.25 -225.79)"
  }))), _g1943 || (_g1943 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-498",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.08,437.47c.16,1.44.34,2.88.52,4.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1944 || (_g1944 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-499",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.79,425.54c.07.71.13,1.42.2,2.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1945 || (_g1945 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-500",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372,427.68c.15,1.45.29,2.9.45,4.35",
    transform: "translate(-199.25 -225.79)"
  }))), _g1946 || (_g1946 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-501",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.05,431c.12,1.07.24,2.13.37,3.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g1947 || (_g1947 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-502",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.7,427.7c.12,1.1.23,2.19.35,3.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1948 || (_g1948 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-503",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.4,437.45c.24,1.8.49,3.59.75,5.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g1949 || (_g1949 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-504",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.63,436.35c.28,2.16.57,4.33.89,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g1950 || (_g1950 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-505",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.43,434.19q.39,3.24.86,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1951 || (_g1951 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-506",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.7,328.56c.14,1.48.28,3,.43,4.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g1952 || (_g1952 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-507",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.8,329.08c.1,1.05.2,2.1.31,3.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g1953 || (_g1953 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-508",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.79,340.46l.12,1.25",
    transform: "translate(-199.25 -225.79)"
  }))), _g1954 || (_g1954 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-509",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.63,327.24c.06.61.11,1.22.17,1.84",
    transform: "translate(-199.25 -225.79)"
  }))), _g1955 || (_g1955 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-510",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.18,445c-.23,1.44-.46,2.88-.7,4.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g1956 || (_g1956 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-511",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.39,445l-.39,2.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g1957 || (_g1957 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-512",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.48,336.27l.36,3.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1958 || (_g1958 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-513",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.77,442.84q.48,3.24,1,6.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g1959 || (_g1959 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-514",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.87,408.25q-.35,6.48-.59,13",
    transform: "translate(-199.25 -225.79)"
  }))), _g1960 || (_g1960 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-515",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.3,247.22q2.51.81,5,1.57",
    transform: "translate(-199.25 -225.79)"
  }))), _g1961 || (_g1961 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-516",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.33,241l1.44.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g1962 || (_g1962 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-517",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.77,242.24c4.1,1.5,8.21,2.93,12.36,4.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g1963 || (_g1963 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-518",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.64,246l1.66.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g1964 || (_g1964 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.26,336.72l-.21,0-.16.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1965 || (_g1965 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-2",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.36,422.19a9.71,9.71,0,0,0,.37,2.63,10.57,10.57,0,0,0,1.13,2.52,14.13,14.13,0,0,0,1.89,2.41,20.55,20.55,0,0,0,2.64,2.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g1966 || (_g1966 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-3",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.57,360.74l-.1,0-.24.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g1967 || (_g1967 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-4",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.38,388.55q.35,3.49.58,7c.09,1.24.17,2.47.24,3.7l.21,4.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g1968 || (_g1968 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-5",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.42,403.3c.1,2.15.21,4.29.31,6.44q.18,3.66.32,7.32t.25,7.62c.06,2.45.09,4.91.08,7.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g1969 || (_g1969 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-6",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.4,379.44a.22.22,0,0,1,0-.08.58.58,0,0,1,.23-.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g1970 || (_g1970 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-7",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.33,379.56l-1,0h-3.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g1971 || (_g1971 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-8",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.89,359.35c-.33-2.52-.62-5.05-.91-7.58s-.55-5-.81-7.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g1972 || (_g1972 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1382",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.92,
    y1: 118.43,
    x2: 5.79,
    y2: 117.17
  }))), _g1973 || (_g1973 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1383",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.79,
    y1: 117.17,
    x2: 5.66,
    y2: 115.92
  }))), _g1974 || (_g1974 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-9",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.34,388.15c-.11-.15-.22-.29-.34-.43a2.45,2.45,0,0,0-.31-.34,1.27,1.27,0,0,0-.29-.21.78.78,0,0,0-.3-.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g1975 || (_g1975 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1384",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.81,
    y1: 134.82,
    x2: 7.06,
    y2: 134.89
  }))), _g1976 || (_g1976 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1385",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.06,
    y1: 134.89,
    x2: 6.32,
    y2: 134.95
  }))), _g1977 || (_g1977 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-10",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.19,356.52c-.15-1.66-.28-3.32-.44-5s-.31-3.3-.47-5-.33-3.3-.5-4.94-.34-3.29-.52-4.93",
    transform: "translate(-199.25 -225.79)"
  }))), _g1978 || (_g1978 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-11",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.67,388.42l-.1-.05a.69.69,0,0,1-.23-.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g1979 || (_g1979 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-12",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.67,388.51c.24,2.46.45,4.92.61,7.38s.3,4.93.42,7.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g1980 || (_g1980 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1386",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.45,
    y1: 177.5,
    x2: 10.16,
    y2: 177.51
  }))), _g1981 || (_g1981 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1387",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.13,
    y1: 162.76,
    x2: 9.43,
    y2: 162.72
  }))), _g1982 || (_g1982 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-13",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.7,403.29c.25,4.83.49,9.66.67,14.49s.31,9.53.31,14.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g1983 || (_g1983 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1388",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.43,
    y1: 206.29,
    x2: 11.14,
    y2: 206.25
  }))), _g1984 || (_g1984 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1389",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.43,
    y1: 206.29,
    x2: 11.43,
    y2: 206.35
  }))), _g1985 || (_g1985 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1390",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.43,
    y1: 206.35,
    x2: 11.14,
    y2: 206.32
  }))), _g1986 || (_g1986 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-14",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.68,432.14v1l0,.85c0,.12,0,.24,0,.36v.32a1.09,1.09,0,0,1-.12.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g1987 || (_g1987 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-15",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.61,435.1a.42.42,0,0,1-.18.17.43.43,0,0,1-.25,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1988 || (_g1988 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-16",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.89,336.83c-.17.28-.33.57-.49.86a17.6,17.6,0,0,0-1.15,2.59",
    transform: "translate(-199.25 -225.79)"
  }))), _g1989 || (_g1989 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-17",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.22,340.39a13.89,13.89,0,0,0-.63,2.62,13.4,13.4,0,0,0-.12,2.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g1990 || (_g1990 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-18",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.89,336.83c.38,3.27.72,6.54,1,9.82s.62,6.6.92,9.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g1991 || (_g1991 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1391",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.6,
    y1: 130.76,
    x2: 5.75,
    y2: 132.47
  }))), _g1992 || (_g1992 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1392",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.75,
    y1: 132.47,
    x2: 5.98,
    y2: 135.02
  }))), _g1993 || (_g1993 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-19",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.23,360.81c.07.78.15,1.55.23,2.33s.15,1.55.23,2.32.16,1.55.25,2.33.18,1.55.28,2.32.19,1.55.29,2.33.21,1.55.31,2.33l.3,2.33c.09.78.19,1.56.28,2.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g1994 || (_g1994 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1393",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.41,
    y1: 113.36,
    x2: 5.22,
    y2: 111.41
  }))), _g1995 || (_g1995 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-20",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.28,381.05l.15,0,.13-.08a.69.69,0,0,0,.11-.13,1,1,0,0,0,.11-.17c.09-.16.17-.32.25-.49l.3-.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g1996 || (_g1996 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1394",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.42,
    y1: 108.81,
    x2: 3.46,
    y2: 108.55
  }))), _g1997 || (_g1997 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-21",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.71,334.34a1.33,1.33,0,0,1,0-.19l.06-.14a.41.41,0,0,1,.05-.09s0,0,0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g1998 || (_g1998 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-22",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.91,333.9s0,0,0,0a.22.22,0,0,1,0,.08s0,.08,0,.13l0,.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g1999 || (_g1999 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-23",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.9,334.31c0,.17-.05.34-.07.51a4.87,4.87,0,0,0,0,.66",
    transform: "translate(-199.25 -225.79)"
  }))), _g2000 || (_g2000 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-24",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.79,335.48v.3c0,.31.05.63.09.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g2001 || (_g2001 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-25",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.68,379.15l.55-.22a5.21,5.21,0,0,0,.52-.28,2.2,2.2,0,0,0,.25-.17,1.37,1.37,0,0,0,.22-.2,1,1,0,0,0,.16-.24.63.63,0,0,0,.05-.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2002 || (_g2002 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-26",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.68,379.15c-.35-3.08-.78-6.14-1.15-9.22s-.68-6.12-1-9.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g2003 || (_g2003 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-27",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.43,377.74c-.37-2.86-.77-5.72-1.17-8.59s-.82-5.69-1.2-8.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g2004 || (_g2004 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1395",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.99,
    y1: 109.2,
    x2: 4.9,
    y2: 108.56
  }))), _g2005 || (_g2005 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-28",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.15,334.35l-.06-.42c0-.05,0-.11,0-.17l0-.14a.43.43,0,0,0,0-.11s0-.05,0-.08l0-.05h0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2006 || (_g2006 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-29",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.39,432.11c0,.23,0,.45,0,.68v.63l0,.57c0,.15,0,.31,0,.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g2007 || (_g2007 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-30",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.4,434.45c0,.06,0,.12,0,.17a.83.83,0,0,1,0,.15l-.06.11a.24.24,0,0,1-.09.08.58.58,0,0,1-.5,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2008 || (_g2008 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-31",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.7,435l-.09,0a1.3,1.3,0,0,1-.26-.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2009 || (_g2009 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-32",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.18,434.67a3.06,3.06,0,0,1-.35-.37,4.94,4.94,0,0,1-.3-.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g2010 || (_g2010 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1396",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.93,
    y1: 209.7,
    x2: 12.12,
    y2: 209.67
  }))), _g2011 || (_g2011 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-33",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.37,435.46a1,1,0,0,0,.51-.35,2.35,2.35,0,0,0,.23-.32,2.68,2.68,0,0,0,.19-.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g2012 || (_g2012 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-34",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.3,434.37a5.34,5.34,0,0,0,.26-1,7.68,7.68,0,0,0,.09-1.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g2013 || (_g2013 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-35",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.74,389.77a.64.64,0,0,0-.11-.3,1.7,1.7,0,0,0-.22-.24l-.26-.19-.28-.16a8.26,8.26,0,0,0-1.2-.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g2014 || (_g2014 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-36",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.57,402.05c-.06-1-.11-2.05-.17-3.08-.18-3.07-.39-6.14-.66-9.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2015 || (_g2015 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-37",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.65,432.23c0-2.45,0-4.89-.09-7.34s-.14-4.79-.24-7.18c-.2-4.84-.45-9.67-.7-14.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g2016 || (_g2016 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-38",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.25,336.62c0-.21,0-.42,0-.63s0-.4,0-.6,0-.36,0-.54,0-.31,0-.47l0-.2,0-.18a.77.77,0,0,1,0-.15s0-.09,0-.13,0-.07,0-.1a.2.2,0,0,0,0-.07s0-.05,0-.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g2017 || (_g2017 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-39",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.25,336.62l-.2,0a.85.85,0,0,0-.17.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2018 || (_g2018 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-40",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.13,263.34a2.42,2.42,0,0,1,.47.07,3.68,3.68,0,0,1,.47.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g2019 || (_g2019 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-41",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.25,264.42l-.15.05a3.49,3.49,0,0,0-.44.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2020 || (_g2020 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-42",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.66,269.5l.3-.61c.29-.56.6-1.12.93-1.66",
    transform: "translate(-199.25 -225.79)"
  }))), _g2021 || (_g2021 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-43",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,266.63c.22.28.43.56.63.86s.43.65.63,1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2022 || (_g2022 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-44",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.19,268.48q.3-.51.63-1c.2-.3.41-.58.63-.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g2023 || (_g2023 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-45",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,267.23c.11.17.21.35.31.52.33.58.64,1.16.93,1.75",
    transform: "translate(-199.25 -225.79)"
  }))), _g2024 || (_g2024 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-46",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,279.18c-.1-.28-.2-.55-.31-.82-.29-.77-.6-1.53-.92-2.29",
    transform: "translate(-199.25 -225.79)"
  }))), _g2025 || (_g2025 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-47",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.66,276.07l.3-.85q.45-1.2.93-2.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g2026 || (_g2026 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-48",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,272.82l.77-.15c.78-.15,1.56-.26,2.35-.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g2027 || (_g2027 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-49",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,272.31c.11.23.21.46.31.7.34.74.65,1.49.95,2.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g2028 || (_g2028 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-50",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,271.54c.1-.23.21-.47.32-.7.29-.66.61-1.3.94-1.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g2029 || (_g2029 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-51",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,268.9c.11.2.21.41.32.62.33.66.64,1.34.94,2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2030 || (_g2030 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-52",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.19,275.25c.11-.26.21-.52.32-.77.3-.73.61-1.45.94-2.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g2031 || (_g2031 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-53",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,272.82c.11.26.21.52.31.78.32.82.63,1.64.93,2.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g2032 || (_g2032 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-54",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.81,276.07c-.11.25-.21.49-.31.74q-.48,1.17-.93,2.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g2033 || (_g2033 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-55",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,279.49c.1-.31.21-.61.32-.92.3-.89.61-1.77.94-2.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g2034 || (_g2034 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-56",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,275.92l.32.86c.32.9.64,1.81.94,2.71",
    transform: "translate(-199.25 -225.79)"
  }))), _g2035 || (_g2035 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-57",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,266.08q.3-.42.63-.81a8.18,8.18,0,0,1,.63-.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g2036 || (_g2036 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-58",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,264.59a8.18,8.18,0,0,1,.63.68q.33.39.63.81",
    transform: "translate(-199.25 -225.79)"
  }))), _g2037 || (_g2037 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-59",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.66,265.6l.3-.33a6.2,6.2,0,0,1,.93-.78",
    transform: "translate(-199.25 -225.79)"
  }))), _g2038 || (_g2038 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-60",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,263.84a2.8,2.8,0,0,1,.63.23,5,5,0,0,1,.63.38",
    transform: "translate(-199.25 -225.79)"
  }))), _g2039 || (_g2039 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1397",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.56,
    y1: 90.26,
    x2: 96.32,
    y2: 94.43
  }))), _g2040 || (_g2040 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-61",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,320.52l.79-.06c.78-.06,1.56-.15,2.33-.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g2041 || (_g2041 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1398",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.64,
    y1: 94.43,
    x2: 80.41,
    y2: 90.26
  }))), _g2042 || (_g2042 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-62",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,320.22l.77.09c.78.09,1.57.16,2.35.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g2043 || (_g2043 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-63",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.19,264.45a5,5,0,0,1,.63-.38,3,3,0,0,1,.63-.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g2044 || (_g2044 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-64",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,264.49l.31.22a7.83,7.83,0,0,1,.93.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2045 || (_g2045 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-65",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,263.56a3.68,3.68,0,0,1,.47-.15,2.42,2.42,0,0,1,.47-.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2046 || (_g2046 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-66",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.81,264.67l-.15-.08-.44-.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g2047 || (_g2047 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-67",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,288.63c-.1-.33-.2-.66-.31-1-.3-1-.61-1.92-.92-2.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2048 || (_g2048 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-68",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.66,284.76l.3-1c.31-1,.61-2,.93-2.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g2049 || (_g2049 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-69",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,280.8l.77-.11c.78-.11,1.57-.19,2.35-.26",
    transform: "translate(-199.25 -225.79)"
  }))), _g2050 || (_g2050 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-70",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,280.43c.11.3.21.61.31.92.33.95.64,1.91.95,2.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g2051 || (_g2051 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-71",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,312c.1.35.21.69.31,1,.3,1,.61,2,.93,3.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g2052 || (_g2052 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-72",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.66,316.06l.3-1q.48-1.55.93-3.09",
    transform: "translate(-199.25 -225.79)"
  }))), _g2053 || (_g2053 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1399",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.82,
    y1: 85.4,
    x2: 90.56,
    y2: 89.77
  }))), _g2054 || (_g2054 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1400",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.56,
    y1: 80.94,
    x2: 91.82,
    y2: 85.4
  }))), _g2055 || (_g2055 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1401",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.14,
    y1: 85.4,
    x2: 87.4,
    y2: 80.94
  }))), _g2056 || (_g2056 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1402",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.4,
    y1: 89.77,
    x2: 86.14,
    y2: 85.4
  }))), _g2057 || (_g2057 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1403",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.56,
    y1: 79.81,
    x2: 96.32,
    y2: 84.23
  }))), _g2058 || (_g2058 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1404",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.32,
    y1: 75.41,
    x2: 97.56,
    y2: 79.81
  }))), _g2059 || (_g2059 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1405",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.82,
    y1: 74.36,
    x2: 90.56,
    y2: 78.9
  }))), _g2060 || (_g2060 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1406",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.56,
    y1: 69.84,
    x2: 91.82,
    y2: 74.36
  }))), _g2061 || (_g2061 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1407",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.14,
    y1: 74.36,
    x2: 87.4,
    y2: 69.84
  }))), _g2062 || (_g2062 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-73",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.19,284.22l.32-1c.3-.94.62-1.88.94-2.81",
    transform: "translate(-199.25 -225.79)"
  }))), _g2063 || (_g2063 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1408",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.4,
    y1: 78.9,
    x2: 86.14,
    y2: 74.36
  }))), _g2064 || (_g2064 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-74",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,280.43l.79.07c.78.08,1.56.18,2.33.3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2065 || (_g2065 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-75",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.57,280.8c.11.32.21.64.31,1,.32,1,.62,2,.93,3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2066 || (_g2066 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1409",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.41,
    y1: 79.81,
    x2: 81.64,
    y2: 75.41
  }))), _g2067 || (_g2067 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1410",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.64,
    y1: 84.23,
    x2: 80.41,
    y2: 79.81
  }))), _g2068 || (_g2068 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-76",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.81,284.76c-.11.32-.21.63-.31.95-.32,1-.63,2-.93,2.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g2069 || (_g2069 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1411",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.56,
    y1: 69.09,
    x2: 96.32,
    y2: 73.41
  }))), _g2070 || (_g2070 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1412",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.32,
    y1: 64.73,
    x2: 97.56,
    y2: 69.09
  }))), _g2071 || (_g2071 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1413",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.64,
    y1: 73.41,
    x2: 80.41,
    y2: 69.09
  }))), _g2072 || (_g2072 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1414",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.82,
    y1: 63.5,
    x2: 90.56,
    y2: 67.83
  }))), _g2073 || (_g2073 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-77",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,285.08c.11.34.21.69.32,1,.32,1.06.63,2.12.94,3.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g2074 || (_g2074 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1415",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.41,
    y1: 69.09,
    x2: 81.64,
    y2: 64.73
  }))), _g2075 || (_g2075 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-78",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,289.3c.1-.36.21-.72.32-1.08.31-1.05.62-2.1.94-3.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2076 || (_g2076 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1416",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.4,
    y1: 67.83,
    x2: 86.14,
    y2: 63.5
  }))), _g2077 || (_g2077 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-79",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291,269.57l.3.59c.31.64.6,1.29.88,1.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g2078 || (_g2078 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-80",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.07,271.54l-.31.69c-.33.73-.65,1.47-.95,2.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2079 || (_g2079 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-81",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,278.78l.79.08c.78.08,1.56.19,2.33.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g2080 || (_g2080 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-82",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.09,272.72l.28-.53c.26-.48.53-.95.83-1.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g2081 || (_g2081 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-83",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.38,280l.71-.14c.72-.13,1.44-.24,2.17-.33",
    transform: "translate(-199.25 -225.79)"
  }))), _g2082 || (_g2082 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-84",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,279.56c.1-.29.19-.59.29-.89.29-.85.58-1.7.89-2.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g2083 || (_g2083 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-85",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,278.78c-.1-.31-.21-.61-.31-.92-.31-.87-.62-1.74-.95-2.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g2084 || (_g2084 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-86",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.55,272.54l.3.65c.31.71.61,1.42.89,2.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2085 || (_g2085 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-87",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.72,275.33l.3-.74c.28-.69.58-1.38.89-2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2086 || (_g2086 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-88",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.2,279.56l.73.1c.72.1,1.44.22,2.15.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g2087 || (_g2087 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-89",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291,276.13l.3.82c.3.87.6,1.74.88,2.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g2088 || (_g2088 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-90",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.38,289.14l.71-.08c.72-.08,1.45-.15,2.17-.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2089 || (_g2089 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1417",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.01,
    y1: 41.24,
    x2: 81.38,
    y2: 41.44
  }))), _g2090 || (_g2090 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-91",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.31,267l.23-.32a9.3,9.3,0,0,1,.7-.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2091 || (_g2091 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-92",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,288.86c.1-.34.2-.69.29-1,.29-1,.59-2,.89-3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2092 || (_g2092 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-93",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.55,280.23l.3.88c.3.92.6,1.84.89,2.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g2093 || (_g2093 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-94",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.22,265.88a2.73,2.73,0,0,1,.23.25c.25.29.48.59.7.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g2094 || (_g2094 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1418",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.58,
    y1: 41.44,
    x2: 96.95,
    y2: 41.24
  }))), _g2095 || (_g2095 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-95",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.72,283.87l.3-.94c.29-.9.58-1.8.89-2.7",
    transform: "translate(-199.25 -225.79)"
  }))), _g2096 || (_g2096 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-96",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.2,288.86l.73.06c.72.06,1.44.13,2.15.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2097 || (_g2097 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-97",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291,284.8l.3,1c.3,1,.59,2,.88,3.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2098 || (_g2098 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-98",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.22,265l-.17-.07a4.13,4.13,0,0,0-.5-.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g2099 || (_g2099 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-99",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.24,265l.17-.07a4.13,4.13,0,0,1,.5-.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g2100 || (_g2100 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1419",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 69.11,
    x2: 85.01,
    y2: 64.93
  }))), _g2101 || (_g2101 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1420",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 73.46,
    x2: 86.19,
    y2: 69.11
  }))), _g2102 || (_g2102 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-100",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,322.3l.79-.07c.78-.07,1.56-.16,2.33-.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g2103 || (_g2103 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1421",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 97.29,
    x2: 92.99,
    y2: 97.16
  }))), _g2104 || (_g2104 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-101",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,266.5l-.31-.28a4.37,4.37,0,0,0-.92-.62",
    transform: "translate(-199.25 -225.79)"
  }))), _g2105 || (_g2105 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-102",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.81,317.47l.32,1c.3,1,.62,2,.94,3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2106 || (_g2106 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-103",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,321.5c.11-.32.21-.65.32-1,.32-1,.63-2,.94-3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2107 || (_g2107 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-104",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.22,264.42l-.11,0-.33-.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2108 || (_g2108 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1422",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.97,
    y1: 97.16,
    x2: 85.01,
    y2: 97.29
  }))), _g2109 || (_g2109 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-105",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,322l.77.1c.78.1,1.57.17,2.35.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g2110 || (_g2110 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1423",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 69.11,
    x2: 92.95,
    y2: 73.46
  }))), _g2111 || (_g2111 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1424",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 64.93,
    x2: 91.78,
    y2: 69.11
  }))), _g2112 || (_g2112 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1425",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.19,
    y1: 79.8,
    x2: 85.01,
    y2: 75.43
  }))), _g2113 || (_g2113 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-106",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.27,264.45a7.76,7.76,0,0,0-.63.65c-.22.25-.43.52-.63.79",
    transform: "translate(-199.25 -225.79)"
  }))), _g2114 || (_g2114 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-107",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,320.52c-.1-.32-.21-.65-.31-1-.32-1-.64-2-.95-3.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2115 || (_g2115 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-108",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.27,316.48l-.32,1c-.3,1-.62,2-.94,3",
    transform: "translate(-199.25 -225.79)"
  }))), _g2116 || (_g2116 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-109",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,265.89c-.2-.27-.41-.54-.63-.79a6.45,6.45,0,0,0-.63-.65",
    transform: "translate(-199.25 -225.79)"
  }))), _g2117 || (_g2117 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-110",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.66,263.5l-.16,0a3.94,3.94,0,0,0-.49.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2118 || (_g2118 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1426",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 84.1,
    x2: 86.19,
    y2: 79.8
  }))), _g2119 || (_g2119 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1427",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.78,
    y1: 79.8,
    x2: 92.95,
    y2: 84.1
  }))), _g2120 || (_g2120 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1428",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 75.43,
    x2: 91.78,
    y2: 79.8
  }))), _g2121 || (_g2121 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-111",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,271.6c-.1-.2-.2-.39-.31-.57-.29-.52-.59-1-.92-1.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g2122 || (_g2122 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-112",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.81,265.6a3.07,3.07,0,0,0-.31.17,6,6,0,0,0-.93.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2123 || (_g2123 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-113",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.27,268.48l-.32.6c-.33.65-.64,1.32-.94,2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2124 || (_g2124 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-114",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,264.12a4.82,4.82,0,0,0-.63-.35,3.33,3.33,0,0,0-.63-.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g2125 || (_g2125 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-115",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,311.81l-.73,0c-.72,0-1.43-.09-2.15-.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2126 || (_g2126 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-116",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.07,263.56a3.58,3.58,0,0,0-.63.21,4.82,4.82,0,0,0-.63.35",
    transform: "translate(-199.25 -225.79)"
  }))), _g2127 || (_g2127 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1429",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.01,
    y1: 86.02,
    x2: 86.19,
    y2: 90.24
  }))), _g2128 || (_g2128 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-117",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,319.92c.1-.32.2-.63.29-.95.31-1,.6-2,.89-2.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g2129 || (_g2129 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-118",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.68,264.33l-.11,0-.32.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2130 || (_g2130 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-119",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291,316l.3,1c.29,1,.58,1.94.88,2.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g2131 || (_g2131 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-120",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,267.89c-.2-.33-.41-.65-.63-1s-.41-.57-.63-.84",
    transform: "translate(-199.25 -225.79)"
  }))), _g2132 || (_g2132 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1430",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.95,
    y1: 86.02,
    x2: 91.78,
    y2: 90.24
  }))), _g2133 || (_g2133 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-121",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.07,266.08q-.33.41-.63.84c-.22.32-.43.64-.63,1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2134 || (_g2134 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-122",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.08,311.61l-.71.06c-.72.06-1.44.1-2.17.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2135 || (_g2135 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-123",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,321.63l-.73-.08c-.72-.08-1.44-.19-2.15-.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g2136 || (_g2136 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-124",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,263.66l-.16-.05a2.88,2.88,0,0,0-.49-.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2137 || (_g2137 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-125",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.74,317l-.3,1c-.29,1-.58,1.93-.89,2.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2138 || (_g2138 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-126",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.91,320.88l-.3-.94c-.3-1-.6-2-.89-2.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g2139 || (_g2139 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-127",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,271.07l-.31-.69c-.3-.64-.61-1.28-.95-1.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g2140 || (_g2140 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-128",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.08,321.23l-.71.12c-.72.12-1.44.21-2.17.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2141 || (_g2141 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-129",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,288.63l.77-.07c.78-.06,1.57-.12,2.35-.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2142 || (_g2142 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-130",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.27,284.22c-.11.34-.21.68-.32,1-.32,1.05-.63,2.1-.94,3.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2143 || (_g2143 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-131",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.81,269.5c-.11.16-.21.32-.31.48-.33.52-.64,1.07-.93,1.62",
    transform: "translate(-199.25 -225.79)"
  }))), _g2144 || (_g2144 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1431",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.95,
    y1: 90.69,
    x2: 93.2,
    y2: 86.34
  }))), _g2145 || (_g2145 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1432",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.76,
    y1: 86.34,
    x2: 86.02,
    y2: 90.69
  }))), _g2146 || (_g2146 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-132",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,279.18l.77-.12c.78-.12,1.57-.21,2.35-.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2147 || (_g2147 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-133",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,283.26l-.31-1c-.31-.93-.62-1.87-.95-2.8",
    transform: "translate(-199.25 -225.79)"
  }))), _g2148 || (_g2148 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-134",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.07,279.49c-.1.31-.21.61-.31.92-.33.94-.64,1.9-.95,2.85",
    transform: "translate(-199.25 -225.79)"
  }))), _g2149 || (_g2149 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-135",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,288.4l.79.05c.78.05,1.56.11,2.33.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g2150 || (_g2150 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1433",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.95,
    y1: 79.91,
    x2: 93.2,
    y2: 75.39
  }))), _g2151 || (_g2151 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1434",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.2,
    y1: 84.36,
    x2: 91.95,
    y2: 79.91
  }))), _g2152 || (_g2152 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-136",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.78,268.88l.28-.45c.27-.41.55-.8.85-1.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g2153 || (_g2153 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-137",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.45,288.4c-.1-.36-.21-.71-.31-1.07-.31-1-.63-2.08-.95-3.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2154 || (_g2154 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-138",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.55,267.25c.1.12.19.24.28.37a13.24,13.24,0,0,1,.85,1.26",
    transform: "translate(-199.25 -225.79)"
  }))), _g2155 || (_g2155 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1435",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.02,
    y1: 79.91,
    x2: 84.76,
    y2: 84.36
  }))), _g2156 || (_g2156 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1436",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.76,
    y1: 75.39,
    x2: 86.02,
    y2: 79.91
  }))), _g2157 || (_g2157 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-139",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.27,275.25c-.11.28-.21.57-.32.85-.32.89-.64,1.78-.94,2.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g2158 || (_g2158 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-140",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.65,274.45c-.1-.26-.21-.52-.31-.77-.3-.72-.62-1.43-.95-2.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2159 || (_g2159 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1437",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.95,
    y1: 68.86,
    x2: 93.2,
    y2: 64.53
  }))), _g2160 || (_g2160 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-141",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.26,270.79c.1.14.19.29.28.43.3.49.57,1,.83,1.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g2161 || (_g2161 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1438",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.2,
    y1: 73.36,
    x2: 91.95,
    y2: 68.86
  }))), _g2162 || (_g2162 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-142",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,272.11l.29-.68c.28-.63.57-1.25.89-1.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g2163 || (_g2163 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1439",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.02,
    y1: 68.86,
    x2: 84.76,
    y2: 73.36
  }))), _g2164 || (_g2164 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1440",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.76,
    y1: 64.53,
    x2: 86.02,
    y2: 68.86
  }))), _g2165 || (_g2165 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-143",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.13,542.68c1.57.89,3.17,1.72,4.79,2.51,1.23.59,2.47,1.15,3.73,1.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g2166 || (_g2166 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-144",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.64,534.68q2.38,2,5,3.85c.54.38,1.09.75,1.64,1.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2167 || (_g2167 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-145",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.83,534.68q-2.4,2-5,3.85l-1.63,1.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2168 || (_g2168 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-146",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.33,542.68c-1.57.89-3.16,1.72-4.79,2.51-1.23.59-2.47,1.15-3.73,1.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g2169 || (_g2169 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1441",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 161.66,
    y1: 152.03,
    x2: 161.73,
    y2: 148.39
  }))), _g2170 || (_g2170 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1442",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.48,
    y1: 269.05,
    x2: 170.5,
    y2: 268.93
  }))), _g2171 || (_g2171 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1443",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.5,
    y1: 268.93,
    x2: 170.52,
    y2: 268.82
  }))), _g2172 || (_g2172 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-147",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.84,473c0-.24,0-.48,0-.72-.07-1.2-.15-2.4-.25-3.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g2173 || (_g2173 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1444",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.46,
    y1: 268.93,
    x2: 7.45,
    y2: 268.82
  }))), _g2174 || (_g2174 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-148",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.63,473l0-.72c.07-1.2.15-2.4.25-3.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g2175 || (_g2175 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1445",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.24,
    y1: 189.05,
    x2: 25.13,
    y2: 189.75
  }))), _g2176 || (_g2176 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-149",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.24,481.69c0-1.06,0-2.12,0-3.19,0-1.61.07-3.21.16-4.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2177 || (_g2177 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-150",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.22,481.69c0-1.06,0-2.13,0-3.19,0-1.29-.05-2.58-.11-3.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2178 || (_g2178 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1446",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 161.64,
    y1: 228.98,
    x2: 161.54,
    y2: 228.4
  }))), _g2179 || (_g2179 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-151",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.37,418.75q-.48-2.85-.93-5.71c-.07-.49-.15-1-.22-1.46-.17-1.11-.34-2.22-.49-3.33",
    transform: "translate(-199.25 -225.79)"
  }))), _g2180 || (_g2180 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-152",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.05,408.78c.22,1.51.45,3,.68,4.53q.47,2.94,1,5.86c.11.68.23,1.37.35,2.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g2181 || (_g2181 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-153",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.18,394.65c-.06-.92-.12-1.8-.18-2.67,0-.61-.07-1.22-.1-1.82,0-.1,0-.2,0-.29s0-.24,0-.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g2182 || (_g2182 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-154",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.15,541.52c-.91-.61-1.81-1.24-2.7-1.88a73.53,73.53,0,0,1-7.54-6.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g2183 || (_g2183 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1447",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.44,
    y1: 218.13,
    x2: 167.63,
    y2: 219.21
  }))), _g2184 || (_g2184 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-155",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.3,249.62a.41.41,0,0,1-.11-.07l-.31-.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2185 || (_g2185 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1448",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.53,
    y1: 218.13,
    x2: 10.33,
    y2: 219.21
  }))), _g2186 || (_g2186 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-156",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.17,249.62l.11-.07a3.3,3.3,0,0,0,.3-.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2187 || (_g2187 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-157",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.08,464.85c.32-2.75.7-5.49,1.12-8.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2188 || (_g2188 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-158",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.38,464.85c-.31-2.75-.69-5.49-1.12-8.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2189 || (_g2189 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-159",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.32,541.52c.91-.61,1.8-1.24,2.69-1.88a72.47,72.47,0,0,0,7.54-6.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g2190 || (_g2190 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-160",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.47,382.87c-19.83,1-39.68,1.74-59.52,1.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g2191 || (_g2191 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-161",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228,382.87c19.84,1,39.68,1.74,59.52,1.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g2192 || (_g2192 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-162",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.31,246l-3.09-1c-3.11-1-6.19-2.1-9.27-3.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2193 || (_g2193 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1449",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 76.01,
    y1: 2.9,
    x2: 75.98,
    y2: 2.74
  }))), _g2194 || (_g2194 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-163",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.23,228.53a.45.45,0,0,0-.11-.17.71.71,0,0,0-.18-.12.64.64,0,0,0-.45,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2195 || (_g2195 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1450",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.8,
    y1: 15.14,
    x2: 137.09,
    y2: 15.25
  }))), _g2196 || (_g2196 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1451",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84.66,
    y1: 97.29,
    x2: 84.67,
    y2: 97.67
  }))), _g2197 || (_g2197 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-164",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336,241.05q-3.1-1.16-6.19-2.34l-6.16-2.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g2198 || (_g2198 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-165",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.27,314.84c0-.06-.06-.1-.11-.13l-.13,0-.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2199 || (_g2199 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-166",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.87,314.64h-.35",
    transform: "translate(-199.25 -225.79)"
  }))), _g2200 || (_g2200 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1452",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.6,
    y1: 9.62,
    x2: 124.27,
    y2: 10.28
  }))), _g2201 || (_g2201 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-167",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.26,314.43a.15.15,0,0,0-.06-.1l-.08,0-.1,0a1,1,0,0,0-.25,0,1.22,1.22,0,0,0-.27,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2202 || (_g2202 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1453",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.26,
    y1: 26.14,
    x2: 13.98,
    y2: 25.77
  }))), _g2203 || (_g2203 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-168",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.52,235.42l-2.87-1.14c-2.86-1.14-5.73-2.26-8.62-3.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g2204 || (_g2204 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-169",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.26,229a.23.23,0,0,0-.11-.18l-.13-.07-.16-.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g2205 || (_g2205 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-170",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.86,228.67h-.35",
    transform: "translate(-199.25 -225.79)"
  }))), _g2206 || (_g2206 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-171",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.92,246.16h0l0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2207 || (_g2207 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1454",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.73,
    y1: 20.39,
    x2: 18.77,
    y2: 20.43
  }))), _g2208 || (_g2208 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-172",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209,254.84l-.09.37q-.12.56-.21,1.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2209 || (_g2209 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-173",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.18,260.94q-1.16,12.24-1.45,24.54-.15,6.15-.1,12.31t.29,12.34q.51,12.38,1.88,24.71.69,6.23,1.61,12.42c.31,2.1.63,4.19,1,6.28s.7,4.21,1.09,6.31",
    transform: "translate(-199.25 -225.79)"
  }))), _g2210 || (_g2210 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-174",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.14,230.28c-.51-.19-1-.37-1.54-.54q-2.3-.8-4.63-1.52",
    transform: "translate(-199.25 -225.79)"
  }))), _g2211 || (_g2211 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1455",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.72,
    y1: 2.43,
    x2: 102.72,
    y2: 0.53
  }))), _g2212 || (_g2212 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-175",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302,226.32a.15.15,0,0,1,0-.09.22.22,0,0,1,.05-.08l.1-.06.12,0a1.08,1.08,0,0,1,.31,0,1.51,1.51,0,0,1,.37.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2213 || (_g2213 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-176",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.83,251.16c.4-.25.81-.48,1.23-.7a23.81,23.81,0,0,1,4-1.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g2214 || (_g2214 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-177",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.23,251.57a5.79,5.79,0,0,1,.6-.41",
    transform: "translate(-199.25 -225.79)"
  }))), _g2215 || (_g2215 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-178",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.94,226.11c4.69,1.45,9.3,3.15,13.87,4.94,2.3.89,4.59,1.81,6.88,2.72s4.6,1.84,6.9,2.74,4.62,1.78,7,2.64,4.64,1.69,7,2.51q6.93,2.42,13.93,4.56",
    transform: "translate(-199.25 -225.79)"
  }))), _g2216 || (_g2216 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-179",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.6,241.54q3.1-1.17,6.2-2.37c2-.8,4.1-1.62,6.15-2.44",
    transform: "translate(-199.25 -225.79)"
  }))), _g2217 || (_g2217 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-180",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.18,246.86c.26.11.51.23.76.36a14.41,14.41,0,0,1,2.11,1.33",
    transform: "translate(-199.25 -225.79)"
  }))), _g2218 || (_g2218 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-181",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.27,250.58c-.44-.24-.89-.47-1.34-.69a29.14,29.14,0,0,0-4.22-1.62",
    transform: "translate(-199.25 -225.79)"
  }))), _g2219 || (_g2219 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-182",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.17,235.84,258,234.7c2.85-1.14,5.7-2.26,8.57-3.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g2220 || (_g2220 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-183",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.34,251.32l.66.42.64.44",
    transform: "translate(-199.25 -225.79)"
  }))), _g2221 || (_g2221 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-184",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.76,250.06c.18.18.35.37.51.56a14.39,14.39,0,0,1,1.29,1.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2222 || (_g2222 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-185",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.56,252.35l.16.25c.14.24.28.48.4.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2223 || (_g2223 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1456",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.92,
    y1: 26.79,
    x2: 166.75,
    y2: 26.66
  }))), _g2224 || (_g2224 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1457",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.75,
    y1: 26.66,
    x2: 166.39,
    y2: 26.39
  }))), _g2225 || (_g2225 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-186",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.05,254s0,0,0,0h.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2226 || (_g2226 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-187",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.92,226s0,0,0,0v.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2227 || (_g2227 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1458",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 164.7,
    y1: 26.14,
    x2: 163.98,
    y2: 25.77
  }))), _g2228 || (_g2228 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-188",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.45,257s0,0,0,0a.2.2,0,0,1,.13-.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g2229 || (_g2229 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-189",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.14,246.35h0s0,0-.06,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2230 || (_g2230 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-190",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.54,226s0,0,0,0a.13.13,0,0,0,0,.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2231 || (_g2231 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-191",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.76,249l0,0a.17.17,0,0,0-.1,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2232 || (_g2232 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-192",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.32,246.35h.05a.12.12,0,0,1,0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2233 || (_g2233 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-193",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.23,253.45a.43.43,0,0,0-.11-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2234 || (_g2234 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-194",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.42,254l-.05,0h-.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2235 || (_g2235 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-195",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.23,253.45a.43.43,0,0,1,.11-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2236 || (_g2236 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-196",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368,257s0,0,0,0a.2.2,0,0,0-.12-.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g2237 || (_g2237 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-197",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.54,246.16h0l0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2238 || (_g2238 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1459",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 159.23,
    y1: 20.39,
    x2: 159.19,
    y2: 20.43
  }))), _g2239 || (_g2239 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1460",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 159.38,
    y1: 20.39,
    x2: 159.32,
    y2: 20.41
  }))), _g2240 || (_g2240 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1461",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 159.32,
    y1: 20.41,
    x2: 159.28,
    y2: 20.46
  }))), _g2241 || (_g2241 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-198",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.71,249l0,0a.14.14,0,0,1,.09,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2242 || (_g2242 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-199",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.68,361.54c-.15.76-.29,1.52-.44,2.28-.43,2.27-.9,4.53-1.38,6.79",
    transform: "translate(-199.25 -225.79)"
  }))), _g2243 || (_g2243 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1462",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.26,
    y1: 2.88,
    x2: 75.24,
    y2: 2.43
  }))), _g2244 || (_g2244 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-200",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.51,372.15a13.82,13.82,0,0,1-2,4.2,14.23,14.23,0,0,1-3,3.08,14.07,14.07,0,0,1-3.65,2,13.86,13.86,0,0,1-4.16.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2245 || (_g2245 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1463",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.26,
    y1: 25.23,
    x2: 13.26,
    y2: 25.19
  }))), _g2246 || (_g2246 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-201",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.34,253.33a.42.42,0,0,1,0,.1,2.59,2.59,0,0,0-.09.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g2247 || (_g2247 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1464",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 149.5,
    y1: 156.46,
    x2: 149.2,
    y2: 156.48
  }))), _g2248 || (_g2248 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-202",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.45,382.27q-6.88.32-13.78.6c-4.87.2-9.74.39-14.62.54q-15.26.49-30.52.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g2249 || (_g2249 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-203",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.52,254.84c0,.12.06.25.08.37q.12.56.21,1.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2250 || (_g2250 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-204",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.29,260.94q1.14,12.24,1.44,24.54.15,6.15.11,12.31t-.3,12.34q-.51,12.38-1.88,24.71-.69,6.23-1.6,12.42-.46,3.15-1,6.28T364,359.85",
    transform: "translate(-199.25 -225.79)"
  }))), _g2251 || (_g2251 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1465",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.28,
    y1: 97.66,
    x2: 92.49,
    y2: 97.67
  }))), _g2252 || (_g2252 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1466",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.49,
    y1: 97.67,
    x2: 93.29,
    y2: 97.67
  }))), _g2253 || (_g2253 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-205",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.43,323.42a9.29,9.29,0,0,0,1.73-.34,9.17,9.17,0,0,0,1.63-.63,10.41,10.41,0,0,0,1.46-.9,10,10,0,0,0,1.24-1.1,8.65,8.65,0,0,0,1-1.26,9.53,9.53,0,0,0,.75-1.41,9.38,9.38,0,0,0,.71-3.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2254 || (_g2254 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1467",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.26,
    y1: 88.44,
    x2: 75.25,
    y2: 85.18
  }))), _g2255 || (_g2255 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1468",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.24,
    y1: 84.86,
    x2: 75.24,
    y2: 81.64
  }))), _g2256 || (_g2256 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1469",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.24,
    y1: 81.58,
    x2: 75.23,
    y2: 76.54
  }))), _g2257 || (_g2257 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1470",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.23,
    y1: 76.07,
    x2: 75.22,
    y2: 71.49
  }))), _g2258 || (_g2258 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1471",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.22,
    y1: 71.49,
    x2: 75.21,
    y2: 68.61
  }))), _g2259 || (_g2259 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-206",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.46,293.68q0-16.55,0-33.09,0-16,.05-31.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g2260 || (_g2260 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-207",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.47,230.7l1.51-.53q2.25-.78,4.53-1.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g2261 || (_g2261 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-208",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.12,253.33l0,.1a2.59,2.59,0,0,1,.09.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g2262 || (_g2262 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1472",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.7,
    y1: 25.23,
    x2: 164.7,
    y2: 25.19
  }))), _g2263 || (_g2263 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1473",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 164.59,
    y1: 25.27,
    x2: 164.7,
    y2: 25.23
  }))), _g2264 || (_g2264 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1474",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.71,
    y1: 2.88,
    x2: 102.72,
    y2: 2.43
  }))), _g2265 || (_g2265 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-209",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.7,250.06c-.17.18-.35.37-.51.56a15.54,15.54,0,0,0-1.29,1.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2266 || (_g2266 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-210",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.9,252.35c-.05.08-.1.17-.16.25-.14.24-.27.48-.4.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2267 || (_g2267 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1475",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.04,
    y1: 26.79,
    x2: 11.21,
    y2: 26.66
  }))), _g2268 || (_g2268 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1476",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.21,
    y1: 26.66,
    x2: 11.57,
    y2: 26.39
  }))), _g2269 || (_g2269 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-211",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.12,251.32l-.65.42-.65.44",
    transform: "translate(-199.25 -225.79)"
  }))), _g2270 || (_g2270 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-212",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.2,250.58c.43-.24.88-.47,1.33-.69a28.82,28.82,0,0,1,4.23-1.62",
    transform: "translate(-199.25 -225.79)"
  }))), _g2271 || (_g2271 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-213",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.28,246.86c-.26.11-.51.23-.76.36a15,15,0,0,0-2.11,1.33",
    transform: "translate(-199.25 -225.79)"
  }))), _g2272 || (_g2272 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-214",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.23,251.57a4.89,4.89,0,0,0-.6-.41",
    transform: "translate(-199.25 -225.79)"
  }))), _g2273 || (_g2273 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1477",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.91,
    y1: 20.1,
    x2: 26.57,
    y2: 20.21
  }))), _g2274 || (_g2274 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-215",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.63,251.16c-.4-.25-.81-.48-1.22-.7a24.26,24.26,0,0,0-4-1.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g2275 || (_g2275 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-216",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.16,246l3.09-1q4.65-1.54,9.26-3.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2276 || (_g2276 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-217",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.29,235.84l-2.85-1.14c-2.85-1.14-5.7-2.26-8.57-3.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g2277 || (_g2277 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1478",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.17,
    y1: 15.14,
    x2: 40.88,
    y2: 15.25
  }))), _g2278 || (_g2278 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-218",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.42,241.05q3.11-1.16,6.2-2.34l6.15-2.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g2279 || (_g2279 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-219",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.86,241.54q-3.11-1.17-6.19-2.37c-2.06-.8-4.11-1.62-6.16-2.44",
    transform: "translate(-199.25 -225.79)"
  }))), _g2280 || (_g2280 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1479",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.37,
    y1: 9.62,
    x2: 53.7,
    y2: 10.28
  }))), _g2281 || (_g2281 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-220",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255,235.42l2.87-1.14c2.86-1.14,5.73-2.26,8.62-3.32",
    transform: "translate(-199.25 -225.79)"
  }))), _g2282 || (_g2282 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-221",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.32,230.28c.51-.19,1-.37,1.54-.54,1.53-.53,3.08-1,4.63-1.52",
    transform: "translate(-199.25 -225.79)"
  }))), _g2283 || (_g2283 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1480",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.24,
    y1: 2.43,
    x2: 75.25,
    y2: 0.53
  }))), _g2284 || (_g2284 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-222",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.5,226.32a.29.29,0,0,0,0-.09l-.06-.08-.09-.06-.12,0a1.15,1.15,0,0,0-.32,0,1.61,1.61,0,0,0-.37.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2285 || (_g2285 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-223",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.52,226.11c-4.69,1.45-9.3,3.15-13.87,4.94-2.3.89-4.59,1.81-6.88,2.72s-4.59,1.84-6.9,2.74-4.62,1.78-6.94,2.64-4.65,1.69-7,2.51Q225,244.08,218,246.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2286 || (_g2286 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-224",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308,230.7l-1.5-.53q-2.26-.78-4.53-1.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g2287 || (_g2287 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1481",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.71,
    y1: 88.44,
    x2: 102.72,
    y2: 85.18
  }))), _g2288 || (_g2288 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1482",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.72,
    y1: 84.17,
    x2: 102.74,
    y2: 76.54
  }))), _g2289 || (_g2289 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1483",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.74,
    y1: 76.07,
    x2: 102.75,
    y2: 68.9
  }))), _g2290 || (_g2290 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-225",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302,293.68q0-16.55,0-33.09,0-16,0-31.92",
    transform: "translate(-199.25 -225.79)"
  }))), _g2291 || (_g2291 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1484",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.69,
    y1: 97.66,
    x2: 85.47,
    y2: 97.67
  }))), _g2292 || (_g2292 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1485",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.47,
    y1: 97.67,
    x2: 84.67,
    y2: 97.67
  }))), _g2293 || (_g2293 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-226",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283,323.42a10,10,0,0,1-3.37-1,10.41,10.41,0,0,1-1.46-.9,10,10,0,0,1-1.24-1.1,9.38,9.38,0,0,1-1-1.26,8.62,8.62,0,0,1-.74-1.41,9.39,9.39,0,0,1-.72-3.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2294 || (_g2294 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-227",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.93,360.62a1.84,1.84,0,0,1,.41.05.75.75,0,0,1,.13.06s0,0,0,.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2295 || (_g2295 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-228",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.47,323.08l-.1,0-.13.09-.15.12-.15.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2296 || (_g2296 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-229",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.51,384.62l0,0,0-.06-.07-.09-.08-.09-.18-.19-.19-.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2297 || (_g2297 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-230",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228,382.87a.21.21,0,0,1-.12-.05.42.42,0,0,1-.09-.14.66.66,0,0,1-.06-.2.88.88,0,0,1,0-.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g2298 || (_g2298 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-231",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.63,371.51s0,0,0-.06a.24.24,0,0,1,.11-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2299 || (_g2299 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-232",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.48,360.74s0,0,0-.05a.3.3,0,0,1,.11-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2300 || (_g2300 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-233",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.79,361.54c.14.76.28,1.52.43,2.28q.66,3.4,1.38,6.79",
    transform: "translate(-199.25 -225.79)"
  }))), _g2301 || (_g2301 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-234",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215,372.15a13.87,13.87,0,0,0,5,7.28,14.07,14.07,0,0,0,3.65,2,13.86,13.86,0,0,0,4.17.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2302 || (_g2302 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1486",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.47,
    y1: 156.46,
    x2: 28.77,
    y2: 156.48
  }))), _g2303 || (_g2303 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-235",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228,382.27q6.89.32,13.77.6c4.87.2,9.75.39,14.62.54q15.25.49,30.52.54",
    transform: "translate(-199.25 -225.79)"
  }))), _g2304 || (_g2304 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1487",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.59,
    y1: 20.39,
    x2: 18.64,
    y2: 20.41
  }))), _g2305 || (_g2305 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1488",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.64,
    y1: 20.41,
    x2: 18.68,
    y2: 20.46
  }))), _g2306 || (_g2306 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1489",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.06,
    y1: 20.1,
    x2: 151.39,
    y2: 20.21
  }))), _g2307 || (_g2307 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-236",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.26,226.8a.44.44,0,0,0-.06-.23.52.52,0,0,0-.18-.18.58.58,0,0,0-.25-.09.61.61,0,0,0-.27,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2308 || (_g2308 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1490",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 93.31,
    y1: 97.29,
    x2: 93.29,
    y2: 97.67
  }))), _g2309 || (_g2309 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-237",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.19,314.84c0-.06.06-.1.12-.13l.12,0,.16,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2310 || (_g2310 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-238",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.59,314.64H302",
    transform: "translate(-199.25 -225.79)"
  }))), _g2311 || (_g2311 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-239",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.2,314.43a.15.15,0,0,1,.06-.1l.08,0,.1,0a1.09,1.09,0,0,1,.25,0,1.22,1.22,0,0,1,.27,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2312 || (_g2312 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-240",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.2,229a.23.23,0,0,1,.11-.18l.13-.07.16-.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g2313 || (_g2313 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-241",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.6,228.67H302",
    transform: "translate(-199.25 -225.79)"
  }))), _g2314 || (_g2314 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1491",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 101.95,
    y1: 2.9,
    x2: 101.98,
    y2: 2.74
  }))), _g2315 || (_g2315 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-242",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.23,228.53a1,1,0,0,1,.11-.17.76.76,0,0,1,.19-.12.61.61,0,0,1,.44,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2316 || (_g2316 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-243",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.2,226.8a.37.37,0,0,1,.07-.23.42.42,0,0,1,.17-.18.67.67,0,0,1,.53-.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2317 || (_g2317 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-244",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364,360.74s0,0,0-.05a.27.27,0,0,0-.1-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2318 || (_g2318 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-245",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.84,371.51s0,0,0-.06a.3.3,0,0,0-.11-.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2319 || (_g2319 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-246",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.47,382.87a.17.17,0,0,0,.12-.05.42.42,0,0,0,.09-.14.66.66,0,0,0,.06-.2,1.69,1.69,0,0,0,0-.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g2320 || (_g2320 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-247",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289,384.62l0,0,0-.06.07-.09.08-.09.18-.19.19-.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2321 || (_g2321 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-248",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289,323.08l.1,0,.13.09.15.12.16.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2322 || (_g2322 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-249",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.53,360.62a1.84,1.84,0,0,0-.41.05.67.67,0,0,0-.12.06s-.05,0-.05.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2323 || (_g2323 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-250",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.7,328.56c-.12-1.24-.23-2.49-.34-3.73-.32-3.71-.6-7.43-.8-11.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g2324 || (_g2324 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1492",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.47,
    y1: 209.95,
    x2: 13.31,
    y2: 209.71
  }))), _g2325 || (_g2325 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-251",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.56,313.68c-.4-7.23-.55-14.47-.41-21.7q.09-5.39.41-10.77t.81-10.68",
    transform: "translate(-199.25 -225.79)"
  }))), _g2326 || (_g2326 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-252",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.68,381.92s0,0-.05-.06a1.09,1.09,0,0,1,0-.17c0-.08,0-.18,0-.27s0-.24,0-.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g2327 || (_g2327 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-253",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209,386.24s0,0-.06.05a.36.36,0,0,0,0,.07.44.44,0,0,0,0,.1,1.26,1.26,0,0,0,0,.27c0,.12,0,.25,0,.37",
    transform: "translate(-199.25 -225.79)"
  }))), _g2328 || (_g2328 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1493",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.68,
    y1: 224.97,
    x2: 162.66,
    y2: 223.53
  }))), _g2329 || (_g2329 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-254",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.76,228.55a52.2,52.2,0,0,0-5.68-.84c-1.95-.18-3.9-.26-5.85-.26",
    transform: "translate(-199.25 -225.79)"
  }))), _g2330 || (_g2330 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-255",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.08,385.93c15.2-.28,30.39-.9,45.57-1.67",
    transform: "translate(-199.25 -225.79)"
  }))), _g2331 || (_g2331 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1494",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.77,
    y1: 223.53,
    x2: 174.14,
    y2: 219.12
  }))), _g2332 || (_g2332 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-256",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.12,460.13q.25-3.24.24-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g2333 || (_g2333 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-257",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.41,477.42c.15-.53.28-1.07.41-1.61.39-1.61.7-3.24.95-4.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g2334 || (_g2334 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-258",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.71,494.71c.28-.52.54-1,.81-1.59.77-1.6,1.48-3.23,2.1-4.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2335 || (_g2335 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1495",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 165.07,
    y1: 280.61,
    x2: 164.96,
    y2: 277.68
  }))), _g2336 || (_g2336 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-259",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.21,503.35l-.06-1.59c-.07-1.62-.14-3.25-.22-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2337 || (_g2337 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-260",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.85,486.07c.33-.53.64-1.05.95-1.59.91-1.59,1.75-3.22,2.5-4.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g2338 || (_g2338 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-261",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.53,468.77c.18-.53.36-1.06.53-1.6.51-1.61.94-3.24,1.31-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2339 || (_g2339 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-262",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.77,442.84c.17-.54.34-1.08.5-1.62.49-1.61.92-3.23,1.31-4.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g2340 || (_g2340 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-263",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.73,460.13c.25-.53.5-1.06.73-1.6q1.07-2.4,1.92-4.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2341 || (_g2341 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-264",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.12,483.91c-.06-.85-.13-1.7-.2-2.55-.21-2.63-.44-5.25-.67-7.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g2342 || (_g2342 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-265",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.43,509.4c.24-.31.48-.63.71-.95.71-1,1.39-1.93,2-2.93",
    transform: "translate(-199.25 -225.79)"
  }))), _g2343 || (_g2343 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-266",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.81,517.63q-.12-2-.21-4c-.06-1.42-.12-2.83-.17-4.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g2344 || (_g2344 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-267",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365,520.14c.35-.48.71-1,1.05-1.46q1.55-2.2,2.9-4.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g2345 || (_g2345 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-268",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.12,523.64l0-.86c0-.88-.08-1.76-.13-2.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g2346 || (_g2346 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-269",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.73,503.36c.25-.53.49-1.06.72-1.6q1.05-2.4,1.87-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2347 || (_g2347 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1496",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.44,
    y1: 277.52,
    x2: 158.84,
    y2: 287.02
  }))), _g2348 || (_g2348 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-270",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.09,464.45q.15,2.25.33,4.5c.21,2.83.44,5.65.66,8.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g2349 || (_g2349 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-271",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.12,445.72c.1,3.68.27,7.35.47,11l.12,1.95",
    transform: "translate(-199.25 -225.79)"
  }))), _g2350 || (_g2350 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-272",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.1,427c0,1.65-.07,3.3-.09,4.94q-.06,4,0,8",
    transform: "translate(-199.25 -225.79)"
  }))), _g2351 || (_g2351 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-273",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.55,449.26l.54-1.06c.53-1.05,1-2.12,1.52-3.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2352 || (_g2352 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-274",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361,458c0-.72-.1-1.44-.14-2.16-.13-2.18-.24-4.37-.33-6.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g2353 || (_g2353 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-275",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.17,389.51c-.45,4.33-.76,8.66-1,13",
    transform: "translate(-199.25 -225.79)"
  }))), _g2354 || (_g2354 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-276",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.1,270.53q.5,5.34.81,10.68c.2,3.59.34,7.17.41,10.76.13,7.24,0,14.48-.41,21.7",
    transform: "translate(-199.25 -225.79)"
  }))), _g2355 || (_g2355 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-277",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.2,268.49a6.67,6.67,0,0,0-.27-1.93,6.28,6.28,0,0,0-.87-1.83,5.74,5.74,0,0,0-1.52-1.47,5.58,5.58,0,0,0-2-.81",
    transform: "translate(-199.25 -225.79)"
  }))), _g2356 || (_g2356 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-278",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.23,261.68c.7,0,1.4,0,2.09,0a46.63,46.63,0,0,1,6.23.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2357 || (_g2357 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1497",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.23,
    y1: 110.48,
    x2: 5.14,
    y2: 109.67
  }))), _g2358 || (_g2358 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1498",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 161.88,
    y1: 148.03,
    x2: 161.8,
    y2: 151.85
  }))), _g2359 || (_g2359 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-279",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.35,492.55q.45-.78.87-1.59c.84-1.59,1.61-3.22,2.29-4.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2360 || (_g2360 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-280",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.5,474.23c.13-.45.25-.91.36-1.36.33-1.35.62-2.72.85-4.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2361 || (_g2361 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-281",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.71,466.61c.21-.53.41-1.06.6-1.6q.85-2.4,1.5-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2362 || (_g2362 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-282",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363,482c.23-.37.46-.75.68-1.13.67-1.13,1.29-2.29,1.87-3.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g2363 || (_g2363 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-283",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209,437.27l.09.24a6.58,6.58,0,0,0,.29.66",
    transform: "translate(-199.25 -225.79)"
  }))), _g2364 || (_g2364 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-284",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.9,501.06c.17-.35.34-.7.5-1.05.5-1.05,1-2.11,1.39-3.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g2365 || (_g2365 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1499",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.08,
    y1: 225.69,
    x2: 163.01,
    y2: 225.26
  }))), _g2366 || (_g2366 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1500",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.73,
    y1: 223.53,
    x2: 162.38,
    y2: 221.33
  }))), _g2367 || (_g2367 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-285",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.56,501.06c-.17-.35-.34-.7-.5-1.05-.5-1.05-1-2.11-1.39-3.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g2368 || (_g2368 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1501",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.89,
    y1: 225.69,
    x2: 14.96,
    y2: 225.26
  }))), _g2369 || (_g2369 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-286",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.49,482c-.24-.37-.46-.75-.69-1.13-.66-1.13-1.29-2.29-1.87-3.47",
    transform: "translate(-199.25 -225.79)"
  }))), _g2370 || (_g2370 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-287",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.75,466.61c-.21-.53-.41-1.06-.6-1.6q-.85-2.4-1.5-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2371 || (_g2371 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-288",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206,474.23l-.36-1.36c-.33-1.35-.62-2.72-.85-4.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2372 || (_g2372 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-289",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.11,492.55q-.45-.78-.87-1.59a51.68,51.68,0,0,1-2.28-4.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2373 || (_g2373 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-290",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.92,262.45a5.62,5.62,0,0,0-2,.81,5.56,5.56,0,0,0-1.51,1.47,6.06,6.06,0,0,0-.88,1.83,7,7,0,0,0-.27,1.93",
    transform: "translate(-199.25 -225.79)"
  }))), _g2374 || (_g2374 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-291",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.23,261.68c-.7,0-1.39,0-2.09,0a46.29,46.29,0,0,0-6.22.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2375 || (_g2375 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-292",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.29,402.48c-.24-4.31-.55-8.64-1-13",
    transform: "translate(-199.25 -225.79)"
  }))), _g2376 || (_g2376 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-293",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.45,458c0-.58.07-1.15.11-1.72.1-1.73.19-3.47.28-5.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2377 || (_g2377 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-294",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.46,440q0-4,0-8c0-1.64-.06-3.29-.1-4.94",
    transform: "translate(-199.25 -225.79)"
  }))), _g2378 || (_g2378 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-295",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.75,458.69l.12-1.95q.31-5.5.47-11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2379 || (_g2379 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-296",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.38,477.42c.22-2.82.45-5.64.66-8.47q.18-2.25.33-4.5",
    transform: "translate(-199.25 -225.79)"
  }))), _g2380 || (_g2380 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1502",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.13,
    y1: 287.02,
    x2: 19.53,
    y2: 277.52
  }))), _g2381 || (_g2381 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-297",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.69,442.84l-.36-1.16q-.54-1.74-1-3.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g2382 || (_g2382 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-298",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.73,503.36c-.25-.53-.49-1.06-.72-1.6q-1-2.4-1.87-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2383 || (_g2383 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-299",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.5,520.14l-1.05-1.46q-1.53-2.2-2.9-4.51",
    transform: "translate(-199.25 -225.79)"
  }))), _g2384 || (_g2384 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-300",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.35,523.64c0-.29,0-.57,0-.86,0-.88.08-1.76.13-2.64",
    transform: "translate(-199.25 -225.79)"
  }))), _g2385 || (_g2385 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-301",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212,509.4c-.25-.31-.48-.63-.72-.95-.71-1-1.38-1.93-2-2.93",
    transform: "translate(-199.25 -225.79)"
  }))), _g2386 || (_g2386 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-302",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.65,517.63q.12-2,.21-4c.07-1.42.12-2.83.18-4.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g2387 || (_g2387 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-303",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.34,483.91c.07-.85.13-1.7.2-2.55.21-2.63.44-5.25.67-7.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g2388 || (_g2388 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-304",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.73,460.13c-.25-.53-.49-1.06-.73-1.6q-1-2.4-1.92-4.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2389 || (_g2389 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-305",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.94,468.77c-.19-.53-.37-1.06-.54-1.6q-.75-2.42-1.31-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2390 || (_g2390 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-306",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.61,486.07c-.32-.53-.64-1.05-1-1.59a54.94,54.94,0,0,1-2.49-4.9",
    transform: "translate(-199.25 -225.79)"
  }))), _g2391 || (_g2391 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1503",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.9,
    y1: 280.61,
    x2: 13,
    y2: 277.69
  }))), _g2392 || (_g2392 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-307",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.26,503.35l.06-1.59c.06-1.62.13-3.25.21-4.88",
    transform: "translate(-199.25 -225.79)"
  }))), _g2393 || (_g2393 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-308",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.75,494.71c-.27-.52-.54-1-.8-1.59q-1.17-2.4-2.11-4.89",
    transform: "translate(-199.25 -225.79)"
  }))), _g2394 || (_g2394 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-309",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.05,477.42c-.14-.53-.28-1.07-.41-1.61-.39-1.61-.7-3.24-.95-4.87",
    transform: "translate(-199.25 -225.79)"
  }))), _g2395 || (_g2395 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-310",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.34,460.13c-.17-2.16-.24-4.32-.24-6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g2396 || (_g2396 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1504",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.19,
    y1: 223.53,
    x2: 3.82,
    y2: 219.12
  }))), _g2397 || (_g2397 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-311",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.23,227.45c-1.93,0-3.87.09-5.79.27q-1.45.12-2.88.33l-1.44.22-1.42.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2398 || (_g2398 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-312",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.81,384.26c15.18.77,30.37,1.39,45.57,1.67",
    transform: "translate(-199.25 -225.79)"
  }))), _g2399 || (_g2399 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-313",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.83,454.89l.39-.84c.39-.85.76-1.71,1.11-2.57",
    transform: "translate(-199.25 -225.79)"
  }))), _g2400 || (_g2400 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-314",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.51,262.06l.1,0a1.39,1.39,0,0,0,.28-.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2401 || (_g2401 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-315",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.89,261.91l.19-.12a4.88,4.88,0,0,0,.62-.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g2402 || (_g2402 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1505",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.45,
    y1: 35.52,
    x2: 8.8,
    y2: 35.19
  }))), _g2403 || (_g2403 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1506",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.7,
    y1: 36.27,
    x2: 170.45,
    y2: 36.2
  }))), _g2404 || (_g2404 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-316",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.7,262l-.19-.08c-.22-.09-.43-.2-.64-.31",
    transform: "translate(-199.25 -225.79)"
  }))), _g2405 || (_g2405 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1507",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 169.62,
    y1: 35.8,
    x2: 169.2,
    y2: 35.56
  }))), _g2406 || (_g2406 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1508",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 169.16,
    y1: 35.19,
    x2: 169.53,
    y2: 35.54
  }))), _g2407 || (_g2407 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-317",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.78,261.33a5.7,5.7,0,0,0,.62.48,1.83,1.83,0,0,0,.55.25",
    transform: "translate(-199.25 -225.79)"
  }))), _g2408 || (_g2408 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1509",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.72,
    y1: 36.46,
    x2: 6.61,
    y2: 36.44
  }))), _g2409 || (_g2409 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-318",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.39,262.09l-.12,0a1.53,1.53,0,0,0-.27.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2410 || (_g2410 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-319",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.31,555.57a84.26,84.26,0,0,1-11.58,6.32,92.43,92.43,0,0,1-12.4,4.54,94.87,94.87,0,0,1-12.91,2.8,91.06,91.06,0,0,1-13.19,1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2411 || (_g2411 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-320",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.92,510.29c-.69,2-1.46,4.05-2.29,6a96.9,96.9,0,0,1-9.15,17",
    transform: "translate(-199.25 -225.79)"
  }))), _g2412 || (_g2412 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1510",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 160.46,
    y1: 308.71,
    x2: 160.44,
    y2: 308.67
  }))), _g2413 || (_g2413 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-321",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.25,236.46l.35-.18c.36-.16.73-.32,1.1-.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g2414 || (_g2414 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-322",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.49,262.25l-.07,0a1.54,1.54,0,0,0-.3-.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2415 || (_g2415 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-323",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.23,227.74c-1.93,0-3.87.1-5.79.27a55.48,55.48,0,0,0-5.74.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2416 || (_g2416 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1511",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.64,
    y1: 107.59,
    x2: 4.64,
    y2: 107.51
  }))), _g2417 || (_g2417 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1512",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.64,
    y1: 107.51,
    x2: 4.6,
    y2: 106.57
  }))), _g2418 || (_g2418 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1513",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.6,
    y1: 106.57,
    x2: 4.59,
    y2: 106.41
  }))), _g2419 || (_g2419 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-324",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.84,332.2v-.1s0-.05,0-.08v0h0v0l0,0a.19.19,0,0,0,0,.08.36.36,0,0,0,0,.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2420 || (_g2420 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1514",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.71,
    y1: 106.55,
    x2: 4.81,
    y2: 107.15
  }))), _g2421 || (_g2421 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-325",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.42,262.68a2.9,2.9,0,0,1-.41-.16l-.48-.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2422 || (_g2422 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-326",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.92,262.87l-.07,0a1.54,1.54,0,0,0-.3-.11",
    transform: "translate(-199.25 -225.79)"
  }))), _g2423 || (_g2423 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-327",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.06,263.21a1.55,1.55,0,0,0,0-.21.26.26,0,0,0-.1-.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g2424 || (_g2424 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1515",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.12,
    y1: 109.52,
    x2: 5.04,
    y2: 108.73
  }))), _g2425 || (_g2425 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1516",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.04,
    y1: 108.73,
    x2: 4.89,
    y2: 107.22
  }))), _g2426 || (_g2426 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-328",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.32,344.15q.45,4.05,1,8.1c.34,2.71.7,5.42,1.11,8.12",
    transform: "translate(-199.25 -225.79)"
  }))), _g2427 || (_g2427 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1517",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.14,
    y1: 134.58,
    x2: 9.94,
    y2: 145.92
  }))), _g2428 || (_g2428 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-329",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.42,262.68a.63.63,0,0,1,.15-.43.58.58,0,0,1,.38-.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g2429 || (_g2429 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1518",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.68,
    y1: 37.08,
    x2: 170.69,
    y2: 36.93
  }))), _g2430 || (_g2430 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-330",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.93,262.72a.64.64,0,0,1,.15-.28.54.54,0,0,1,.26-.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2431 || (_g2431 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1519",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.09,
    y1: 36.48,
    x2: 171.24,
    y2: 36.46
  }))), _g2432 || (_g2432 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-331",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.44,386.7c0-.14,0-.29,0-.43s0-.22,0-.33l0-.11a.13.13,0,0,1,0-.08s0-.07.07-.07",
    transform: "translate(-199.25 -225.79)"
  }))), _g2433 || (_g2433 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-332",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.06,263.21a.56.56,0,0,1,.15-.41.58.58,0,0,1,.43-.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g2434 || (_g2434 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1520",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.39,
    y1: 36.83,
    x2: 171.58,
    y2: 36.86
  }))), _g2435 || (_g2435 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-333",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.44,385.69a.9.9,0,0,1,.52.21,1.6,1.6,0,0,1,.27.25,2.24,2.24,0,0,1,.27.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g2436 || (_g2436 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1521",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.25,
    y1: 160.7,
    x2: 11.44,
    y2: 160.99
  }))), _g2437 || (_g2437 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-334",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.68,386.78l.09.15c.08.15.16.31.23.48",
    transform: "translate(-199.25 -225.79)"
  }))), _g2438 || (_g2438 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-335",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211,387.41l.09.23a6.46,6.46,0,0,1,.25.78",
    transform: "translate(-199.25 -225.79)"
  }))), _g2439 || (_g2439 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-336",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.34,388.42c0,.1,0,.2.07.3a8,8,0,0,1,.15,1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2440 || (_g2440 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-337",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.19,264.69a.15.15,0,0,1,.09-.14l.12-.06.16-.05a2,2,0,0,1,.35,0,1.07,1.07,0,0,1,.3.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2441 || (_g2441 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-338",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.56,389.68l.27,3.09c.25,3.09.43,6.19.6,9.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2442 || (_g2442 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-339",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.18,378.82a4,4,0,0,1,0,.49,7.56,7.56,0,0,1-.17,1.34",
    transform: "translate(-199.25 -225.79)"
  }))), _g2443 || (_g2443 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-340",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210,380.65a4.3,4.3,0,0,1-.42,1.17,2,2,0,0,1-.25.39,1.18,1.18,0,0,1-.27.23",
    transform: "translate(-199.25 -225.79)"
  }))), _g2444 || (_g2444 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-341",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.07,382.44l-.07,0a.45.45,0,0,1-.2,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2445 || (_g2445 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-342",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.48,360.54l0,0,.09,0a1.43,1.43,0,0,1,.29,0l.35.06.27.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2446 || (_g2446 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-343",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.39,382.51l0,0,0-.06a.94.94,0,0,1-.06-.24l-.06-.39c0-.18,0-.35,0-.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g2447 || (_g2447 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-344",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.23,570.21a93.13,93.13,0,0,1-20.63-2.37,98.29,98.29,0,0,1-10-2.84,93.21,93.21,0,0,1-9.62-3.92,83.74,83.74,0,0,1-9.08-5c-1.45-.93-2.88-1.91-4.27-2.94s-2.74-2.11-4-3.23a76.85,76.85,0,0,1-7.39-7.27,85.14,85.14,0,0,1-6.42-8.15",
    transform: "translate(-199.25 -225.79)"
  }))), _g2448 || (_g2448 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-345",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363,372.94l0,0,.08,0a1.41,1.41,0,0,1,.29,0,1.87,1.87,0,0,1,.34.08,1.33,1.33,0,0,1,.28.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2449 || (_g2449 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1522",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.35,
    y1: 36.44,
    x2: 171.24,
    y2: 36.46
  }))), _g2450 || (_g2450 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1523",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.16,
    y1: 109.48,
    x2: 5.08,
    y2: 108.69
  }))), _g2451 || (_g2451 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1524",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.08,
    y1: 108.61,
    x2: 4.93,
    y2: 107.17
  }))), _g2452 || (_g2452 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-346",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.63,327.24c-.09-1.06-.19-2.13-.28-3.19-.26-3.17-.49-6.35-.67-9.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g2453 || (_g2453 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-347",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.6,313.13c-.37-7-.51-14.07-.38-21.11q.09-5.24.38-10.47t.77-10.4",
    transform: "translate(-199.25 -225.79)"
  }))), _g2454 || (_g2454 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1525",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.58,
    y1: 113.46,
    x2: 5.38,
    y2: 111.51
  }))), _g2455 || (_g2455 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1526",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.38,
    y1: 111.51,
    x2: 5.26,
    y2: 110.42
  }))), _g2456 || (_g2456 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-348",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349.65,384.26a.19.19,0,0,1,.13,0,.43.43,0,0,1,.11.12.89.89,0,0,1,.08.17.83.83,0,0,1,0,.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2457 || (_g2457 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1527",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.03,
    y1: 117.71,
    x2: 5.84,
    y2: 115.95
  }))), _g2458 || (_g2458 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-349",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.81,384.26a.17.17,0,0,0-.12,0,.25.25,0,0,0-.11.12.53.53,0,0,0-.08.17.85.85,0,0,0,0,.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2459 || (_g2459 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1528",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.27,
    y1: 134.84,
    x2: 8.18,
    y2: 134.19
  }))), _g2460 || (_g2460 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1529",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.18,
    y1: 134.19,
    x2: 8.07,
    y2: 133.41
  }))), _g2461 || (_g2461 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-350",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.32,359.2c-.36-2.52-.72-5-1-7.56s-.63-5-.92-7.53",
    transform: "translate(-199.25 -225.79)"
  }))), _g2462 || (_g2462 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-351",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.46,372.94s0,0,0,0l-.08,0a1.43,1.43,0,0,0-.29,0,2.09,2.09,0,0,0-.34.08,1.08,1.08,0,0,0-.27.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2463 || (_g2463 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-352",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.25,264.61c-.92,11.36-1.32,22.78-1.2,34.18q.09,8.7.59,17.38c.33,5.81.79,11.63,1.4,17.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g2464 || (_g2464 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-353",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.45,337.32q.68,5.82,1.54,11.6c.58,3.91,1.24,7.82,1.95,11.71",
    transform: "translate(-199.25 -225.79)"
  }))), _g2465 || (_g2465 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-354",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211,360.54l0,0-.08,0a1.38,1.38,0,0,0-.29,0,2,2,0,0,0-.35.06l-.28.1",
    transform: "translate(-199.25 -225.79)"
  }))), _g2466 || (_g2466 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-355",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.28,264.69a.18.18,0,0,0-.1-.14l-.12-.06-.16-.05a2,2,0,0,0-.35,0,.94.94,0,0,0-.29.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2467 || (_g2467 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-356",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.57,269.21q0-.43.12-.87c.13-.88.29-1.75.48-2.63",
    transform: "translate(-199.25 -225.79)"
  }))), _g2468 || (_g2468 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-357",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.4,263.21a.49.49,0,0,0-.15-.41.58.58,0,0,0-.43-.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g2469 || (_g2469 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1530",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.57,
    y1: 36.83,
    x2: 6.39,
    y2: 36.86
  }))), _g2470 || (_g2470 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1531",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.29,
    y1: 37.08,
    x2: 7.28,
    y2: 36.93
  }))), _g2471 || (_g2471 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-358",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.53,262.72a.62.62,0,0,0-.14-.28.57.57,0,0,0-.27-.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2472 || (_g2472 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1532",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.88,
    y1: 36.48,
    x2: 6.72,
    y2: 36.46
  }))), _g2473 || (_g2473 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-359",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.1,270.52s0,0,0,0a.07.07,0,0,0-.06,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2474 || (_g2474 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-360",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207,262.68a.58.58,0,0,0-.15-.43.56.56,0,0,0-.38-.19",
    transform: "translate(-199.25 -225.79)"
  }))), _g2475 || (_g2475 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-361",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.83,262.65l-.05-.12a.69.69,0,0,0-.21-.24",
    transform: "translate(-199.25 -225.79)"
  }))), _g2476 || (_g2476 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1533",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.32,
    y1: 36.5,
    x2: 171.24,
    y2: 36.46
  }))), _g2477 || (_g2477 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-362",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.21,264.47a2.51,2.51,0,0,1,0-.27c0-.23-.07-.47-.12-.7",
    transform: "translate(-199.25 -225.79)"
  }))), _g2478 || (_g2478 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-363",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.05,263.5l-.06-.26a4,4,0,0,0-.16-.59",
    transform: "translate(-199.25 -225.79)"
  }))), _g2479 || (_g2479 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-364",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.6,262.24l.15.05a1.3,1.3,0,0,1,.45.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g2480 || (_g2480 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1534",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.95,
    y1: 36.86,
    x2: 172.13,
    y2: 37.1
  }))), _g2481 || (_g2481 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-365",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.48,263.05a.75.75,0,0,1,.07.12,2.32,2.32,0,0,1,.18.39",
    transform: "translate(-199.25 -225.79)"
  }))), _g2482 || (_g2482 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-366",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.73,263.56a1.34,1.34,0,0,1,.07.18c.07.2.13.4.19.6",
    transform: "translate(-199.25 -225.79)"
  }))), _g2483 || (_g2483 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1535",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.21,
    y1: 159.01,
    x2: 27.53,
    y2: 159.02
  }))), _g2484 || (_g2484 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1536",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.53,
    y1: 159.02,
    x2: 28.43,
    y2: 159.06
  }))), _g2485 || (_g2485 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-367",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.67,384.85c3.49.17,7,.32,10.45.47q8.37.36,16.75.64,8.75.3,17.5.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g2486 || (_g2486 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-368",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.37,386.41c1.32,0,2.63,0,3.95.06q6,.09,11.91.08",
    transform: "translate(-199.25 -225.79)"
  }))), _g2487 || (_g2487 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-369",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.46,373.18a14.79,14.79,0,0,0,5,8.1,15.12,15.12,0,0,0,3.74,2.3,15.29,15.29,0,0,0,4.34,1.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2488 || (_g2488 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-370",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.51,360.63c.27,1.85.54,3.69.83,5.54.14.92.29,1.84.43,2.77s.28,1.85.41,2.77",
    transform: "translate(-199.25 -225.79)"
  }))), _g2489 || (_g2489 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-371",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.23,386.55h4q5.94,0,11.88-.13",
    transform: "translate(-199.25 -225.79)"
  }))), _g2490 || (_g2490 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-372",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.09,386.41c3.89-.06,7.77-.16,11.65-.27,10.94-.3,21.87-.77,32.8-1.27",
    transform: "translate(-199.25 -225.79)"
  }))), _g2491 || (_g2491 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1537",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 149.29,
    y1: 159.08,
    x2: 150.43,
    y2: 159.02
  }))), _g2492 || (_g2492 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1538",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 150.43,
    y1: 159.02,
    x2: 150.75,
    y2: 159.01
  }))), _g2493 || (_g2493 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-373",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.78,384.74a15.16,15.16,0,0,0,8.2-3.41,15.06,15.06,0,0,0,3-3.43,14.72,14.72,0,0,0,2-4.72",
    transform: "translate(-199.25 -225.79)"
  }))), _g2494 || (_g2494 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-374",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.53,360.63c.59-3.28,1.15-6.57,1.66-9.86s1-6.5,1.38-9.76",
    transform: "translate(-199.25 -225.79)"
  }))), _g2495 || (_g2495 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-375",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.57,341q1.2-9.52,1.88-19.09t.9-19.06q.19-9.45-.07-18.91t-1-18.61",
    transform: "translate(-199.25 -225.79)"
  }))), _g2496 || (_g2496 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1539",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 172.35,
    y1: 38.61,
    x2: 172.16,
    y2: 38.65
  }))), _g2497 || (_g2497 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1540",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 172.16,
    y1: 38.65,
    x2: 171.96,
    y2: 38.68
  }))), _g2498 || (_g2498 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-376",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.29,265.68c.06.3.13.61.19.92.17.91.32,1.83.43,2.75",
    transform: "translate(-199.25 -225.79)"
  }))), _g2499 || (_g2499 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-377",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.1,271.17c.31,3.45.57,6.91.76,10.38s.32,7,.39,10.45q.18,10.53-.38,21.06",
    transform: "translate(-199.25 -225.79)"
  }))), _g2500 || (_g2500 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-378",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.64,262.65l-.06.17a5.8,5.8,0,0,0-.17.72",
    transform: "translate(-199.25 -225.79)"
  }))), _g2501 || (_g2501 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-379",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.41,263.54a1.42,1.42,0,0,0,0,.2c-.05.24-.08.49-.11.73",
    transform: "translate(-199.25 -225.79)"
  }))), _g2502 || (_g2502 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-380",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207,381.92s-.05,0-.06-.06a.55.55,0,0,1,0-.17,1.86,1.86,0,0,1-.05-.27c0-.12,0-.24-.05-.36",
    transform: "translate(-199.25 -225.79)"
  }))), _g2503 || (_g2503 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1541",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.27,
    y1: 134.85,
    x2: 8.19,
    y2: 134.35
  }))), _g2504 || (_g2504 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1542",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.19,
    y1: 134.35,
    x2: 8.03,
    y2: 133.3
  }))), _g2505 || (_g2505 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-381",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.27,359.09c-.17-1.25-.35-2.51-.53-3.76s-.34-2.49-.5-3.73c-.33-2.48-.64-5-.92-7.45",
    transform: "translate(-199.25 -225.79)"
  }))), _g2506 || (_g2506 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-382",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206,262.25a.36.36,0,0,0-.16.11.55.55,0,0,0-.13.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g2507 || (_g2507 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1543",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.43,
    y1: 36.75,
    x2: 6.39,
    y2: 36.86
  }))), _g2508 || (_g2508 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1544",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.77,
    y1: 161.31,
    x2: 7.79,
    y2: 161.03
  }))), _g2509 || (_g2509 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-383",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207,386.82c0-.14,0-.29.07-.43a.37.37,0,0,1,0-.11s0,0,.06,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2510 || (_g2510 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1545",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.07,
    y1: 118.35,
    x2: 6.1,
    y2: 118.32
  }))), _g2511 || (_g2511 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-384",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.91,340.48h0a.05.05,0,0,1,0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2512 || (_g2512 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-385",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.88,340.17h0s0,0,0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2513 || (_g2513 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-386",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.48,336.27s0,0,0,0l0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2514 || (_g2514 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1546",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.12,
    y1: 109.52,
    x2: 5.16,
    y2: 109.48
  }))), _g2515 || (_g2515 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-387",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.42,264.36h0s0,0,0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2516 || (_g2516 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1547",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.54,
    y1: 36.45,
    x2: 6.61,
    y2: 36.44
  }))), _g2517 || (_g2517 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1548",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.5,
    y1: 308.71,
    x2: 17.52,
    y2: 308.67
  }))), _g2518 || (_g2518 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1549",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.24,
    y1: 177.41,
    x2: 13.29,
    y2: 178.57
  }))), _g2519 || (_g2519 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-388",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.54,404.36c.24,4.74.48,9.49.67,14.24s.31,9.36.3,14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2520 || (_g2520 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-389",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.5,433.07c0,.07,0,.14,0,.22s0,.42-.06.63",
    transform: "translate(-199.25 -225.79)"
  }))), _g2521 || (_g2521 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-390",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.42,433.92l-.06.34a5.78,5.78,0,0,1-.23.91",
    transform: "translate(-199.25 -225.79)"
  }))), _g2522 || (_g2522 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-391",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.13,435.17l-.08.21a3.87,3.87,0,0,1-.25.55",
    transform: "translate(-199.25 -225.79)"
  }))), _g2523 || (_g2523 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1550",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.55,
    y1: 210.14,
    x2: 13.34,
    y2: 210.47
  }))), _g2524 || (_g2524 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-392",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.59,436.26a2.74,2.74,0,0,1-.32.36,1.67,1.67,0,0,1-.35.24.89.89,0,0,1-.35.11.87.87,0,0,1-.36,0,1.39,1.39,0,0,1-.69-.4,2,2,0,0,1-.33-.38,3,3,0,0,1-.29-.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g2525 || (_g2525 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-393",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.77,534.46a97.57,97.57,0,0,1-12.22-24.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2526 || (_g2526 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-394",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.21,496.9l-.43,1.08c-.45,1.09-.93,2.16-1.44,3.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2527 || (_g2527 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-395",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.56,451.48l.66,1.65c.69,1.64,1.44,3.26,2.26,4.84",
    transform: "translate(-199.25 -225.79)"
  }))), _g2528 || (_g2528 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1551",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.35,
    y1: 219.21,
    x2: 12.32,
    y2: 225.69
  }))), _g2529 || (_g2529 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-396",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.51,503.36c-.17.26-.35.52-.53.77-.54.77-1.09,1.53-1.66,2.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2530 || (_g2530 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1552",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.2,
    y1: 36.28,
    x2: 7.27,
    y2: 36.27
  }))), _g2531 || (_g2531 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-397",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372,486.07c-.22.55-.45,1.1-.68,1.65-.71,1.64-1.49,3.26-2.35,4.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2532 || (_g2532 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1553",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.43,
    y1: 36.45,
    x2: 171.35,
    y2: 36.44
  }))), _g2533 || (_g2533 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-398",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.76,228.85c-.94-.19-1.88-.35-2.83-.49a58.91,58.91,0,0,0-8.7-.62",
    transform: "translate(-199.25 -225.79)"
  }))), _g2534 || (_g2534 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-399",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.08,468.77c-.09.55-.19,1.09-.29,1.64-.32,1.63-.7,3.25-1.16,4.85",
    transform: "translate(-199.25 -225.79)"
  }))), _g2535 || (_g2535 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-400",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372,264.36h0a.06.06,0,0,0-.05,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2536 || (_g2536 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-401",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.65,385.68a.56.56,0,0,0,.17.4.61.61,0,0,0,.4.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2537 || (_g2537 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-402",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.44,385.69a.59.59,0,0,0,.16.39.57.57,0,0,0,.37.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2538 || (_g2538 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-403",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.72,451.48q-.06,3.25-.37,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g2539 || (_g2539 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1554",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.52,
    y1: 219.21,
    x2: 174.01,
    y2: 222.5
  }))), _g2540 || (_g2540 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1555",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.01,
    y1: 222.5,
    x2: 174.47,
    y2: 225.69
  }))), _g2541 || (_g2541 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1556",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.31,
    y1: 163.89,
    x2: 12.25,
    y2: 163.92
  }))), _g2542 || (_g2542 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1557",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.18,
    y1: 176.26,
    x2: 13.11,
    y2: 176.27
  }))), _g2543 || (_g2543 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1558",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.24,
    y1: 177.41,
    x2: 13.17,
    y2: 177.42
  }))), _g2544 || (_g2544 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-404",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.51,432.64h0a.07.07,0,0,1,0-.05",
    transform: "translate(-199.25 -225.79)"
  }))), _g2545 || (_g2545 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-405",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.52,442.84c-.07.54-.14,1.08-.22,1.62q-.36,2.44-.87,4.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g2546 || (_g2546 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1559",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.78,
    y1: 36.28,
    x2: 170.71,
    y2: 36.27
  }))), _g2547 || (_g2547 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-406",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.92,436.35a1.19,1.19,0,0,1-.55-.15,1.75,1.75,0,0,1-.52-.42",
    transform: "translate(-199.25 -225.79)"
  }))), _g2548 || (_g2548 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1560",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.6,
    y1: 209.99,
    x2: 11.44,
    y2: 209.79
  }))), _g2549 || (_g2549 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-407",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.09,377.57h0l0,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2550 || (_g2550 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-408",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.36,270.52v0a.08.08,0,0,1,.06,0",
    transform: "translate(-199.25 -225.79)"
  }))), _g2551 || (_g2551 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-409",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.93,262.24a5.5,5.5,0,0,1-.48.28,2.9,2.9,0,0,1-.41.16",
    transform: "translate(-199.25 -225.79)"
  }))), _g2552 || (_g2552 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-410",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207,262.68l-.3.1a.72.72,0,0,0-.2.09",
    transform: "translate(-199.25 -225.79)"
  }))), _g2553 || (_g2553 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-411",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.54,262.87a.3.3,0,0,0-.09.13.8.8,0,0,0,0,.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g2554 || (_g2554 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-412",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.8,382.52a.61.61,0,0,1,.14-.42.53.53,0,0,1,.39-.18",
    transform: "translate(-199.25 -225.79)"
  }))), _g2555 || (_g2555 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-413",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.26,460.13c-.14.55-.29,1.09-.44,1.64-.45,1.63-1,3.25-1.58,4.84",
    transform: "translate(-199.25 -225.79)"
  }))), _g2556 || (_g2556 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-414",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.39,382.51a.65.65,0,0,1,.16-.42.61.61,0,0,1,.42-.17",
    transform: "translate(-199.25 -225.79)"
  }))), _g2557 || (_g2557 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-415",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.12,477.42c-.26.56-.53,1.11-.81,1.66q-1.28,2.48-2.79,4.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2558 || (_g2558 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-416",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.74,513.42l-.7,1.07c-.72,1.06-1.46,2.11-2.23,3.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2559 || (_g2559 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-417",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.94,442.84c.07.54.15,1.08.23,1.62.24,1.63.52,3.25.86,4.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g2560 || (_g2560 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-418",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.73,513.42l.7,1.07c.71,1.06,1.45,2.11,2.22,3.14",
    transform: "translate(-199.25 -225.79)"
  }))), _g2561 || (_g2561 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-419",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.34,477.42c.26.56.53,1.11.81,1.66.85,1.65,1.79,3.26,2.79,4.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2562 || (_g2562 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-420",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.21,236.46l-.35-.18c-.36-.16-.73-.32-1.1-.46",
    transform: "translate(-199.25 -225.79)"
  }))), _g2563 || (_g2563 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-421",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.21,460.13c.13.55.28,1.09.43,1.64.46,1.63,1,3.25,1.58,4.84",
    transform: "translate(-199.25 -225.79)"
  }))), _g2564 || (_g2564 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1561",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 133.25,
    y1: 297.31,
    x2: 133.56,
    y2: 297.31
  }))), _g2565 || (_g2565 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1562",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 133.56,
    y1: 297.31,
    x2: 134.45,
    y2: 297.32
  }))), _g2566 || (_g2566 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1563",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 141.08,
    y1: 297.3,
    x2: 141.77,
    y2: 297.29
  }))), _g2567 || (_g2567 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1564",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 141.77,
    y1: 297.29,
    x2: 142.08,
    y2: 297.29
  }))), _g2568 || (_g2568 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1565",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.9,
    y1: 297.32,
    x2: 36.2,
    y2: 297.32
  }))), _g2569 || (_g2569 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1566",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.2,
    y1: 297.32,
    x2: 36.91,
    y2: 297.32
  }))), _g2570 || (_g2570 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1567",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.52,
    y1: 297.32,
    x2: 44.41,
    y2: 297.31
  }))), _g2571 || (_g2571 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1568",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.41,
    y1: 297.31,
    x2: 44.72,
    y2: 297.31
  }))), _g2572 || (_g2572 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-422",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.9,451.48q-.31.82-.66,1.65c-.69,1.64-1.44,3.26-2.26,4.84",
    transform: "translate(-199.25 -225.79)"
  }))), _g2573 || (_g2573 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1569",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.62,
    y1: 219.21,
    x2: 165.65,
    y2: 225.69
  }))), _g2574 || (_g2574 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-423",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.74,451.48c0,2.17.16,4.33.38,6.49",
    transform: "translate(-199.25 -225.79)"
  }))), _g2575 || (_g2575 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1570",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.44,
    y1: 219.21,
    x2: 3.96,
    y2: 222.5
  }))), _g2576 || (_g2576 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1571",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.96,
    y1: 222.5,
    x2: 3.49,
    y2: 225.69
  }))), _g2577 || (_g2577 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-424",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.38,468.77c.09.55.19,1.09.3,1.64.31,1.63.7,3.25,1.15,4.85",
    transform: "translate(-199.25 -225.79)"
  }))), _g2578 || (_g2578 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-425",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.49,486.07c.21.55.44,1.1.67,1.65.71,1.64,1.49,3.26,2.35,4.83",
    transform: "translate(-199.25 -225.79)"
  }))), _g2579 || (_g2579 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-426",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210,503.36c.18.26.35.52.53.77.54.77,1.09,1.53,1.67,2.28",
    transform: "translate(-199.25 -225.79)"
  }))), _g2580 || (_g2580 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-427",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.25,496.89c.14.37.29.73.44,1.09.44,1.09.92,2.16,1.43,3.22",
    transform: "translate(-199.25 -225.79)"
  }))), _g2581 || (_g2581 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1572",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 105.42,
    y1: 300.84,
    x2: 103.46,
    y2: 304.23
  }))), _g2582 || (_g2582 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1573",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 105.42,
    y1: 300.85,
    x2: 113.95,
    y2: 300.84
  }))), _g2583 || (_g2583 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1574",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 113.95,
    y1: 300.84,
    x2: 114.24,
    y2: 300.84
  }))), _g2584 || (_g2584 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1575",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.23,
    y1: 38.55,
    x2: 5.37,
    y2: 38.08
  }))), _g2585 || (_g2585 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1576",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.37,
    y1: 38.08,
    x2: 5.54,
    y2: 37.64
  }))), _g2586 || (_g2586 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1577",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.54,
    y1: 37.64,
    x2: 5.74,
    y2: 37.24
  }))), _g2587 || (_g2587 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-428",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.1,262.87a2,2,0,0,1,.35-.41,1.13,1.13,0,0,1,.35-.21",
    transform: "translate(-199.25 -225.79)"
  }))), _g2588 || (_g2588 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1578",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.01,
    y1: 225.26,
    x2: 162.8,
    y2: 223.96
  }))), _g2589 || (_g2589 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-429",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.73,261.52c-.22.12-.44.24-.67.34a2.58,2.58,0,0,1-.55.2",
    transform: "translate(-199.25 -225.79)"
  }))), _g2590 || (_g2590 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-1579",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.2,
    y1: 114.09,
    x2: 6.24,
    y2: 114.41
  }))), _g2591 || (_g2591 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-430",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211,360.14c-.4-2.22-.79-4.44-1.15-6.67s-.71-4.48-1-6.72-.63-4.57-.92-6.86",
    transform: "translate(-199.25 -225.79)"
  }))), _g2592 || (_g2592 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-431",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.49,340.2c.21,2,.42,3.93.65,5.89.2,1.75.41,3.51.63,5.26.19,1.55.38,3.11.59,4.66.19,1.38.38,2.76.59,4.13",
    transform: "translate(-199.25 -225.79)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarmosharkM6Ultra);
export default __webpack_public_path__ + "static/media/darmoshark-m6-ultra.fda09da128ee4a039c8a45b5536c06b4.svg";
export { ForwardRef as ReactComponent };